import { d as If, T as mo, c as _e, b as Mf, B as kf, P as Xr } from "./Page-CfAtPlZZ.mjs";
import { H as o0 } from "./Page-CfAtPlZZ.mjs";
import { jsxs as ne, jsx as N, Fragment as Le } from "react/jsx-runtime";
import * as V from "react";
import W, { useCallback as ke, useRef as fe, useState as we, useEffect as Ce, useLayoutEffect as cn, createElement as _r, forwardRef as lt, useMemo as Ne, useImperativeHandle as Au, createContext as Tt, useId as go, useContext as be, useInsertionEffect as Iu, Children as Mu, isValidElement as Lf, Fragment as vo, Component as Nf, cloneElement as Vf } from "react";
import { u as yo, c as ku, a as Ff, i as $f, b as Bf } from "./useDebounce-ch5IFavj.mjs";
import { g as So } from "./_commonjsHelpers-DaMA6jEr.mjs";
import * as jf from "react-dom";
import Zt, { createPortal as Wf } from "react-dom";
import { d as Lu, C as Nu, U as Uf, e as Hf, F as qf, N as zf, M as Kf, f as Yf } from "./24x24-BdiyggP2.mjs";
import { b as Gf, c as Xf } from "./20x20-Dcr-RE_A.mjs";
const Zf = "_item_t3uj0_2", pt = {
  item: Zf,
  "with-divider": "_with-divider_t3uj0_11",
  "item-content": "_item-content_t3uj0_17",
  "item-icon": "_item-icon_t3uj0_24",
  "raw-icon": "_raw-icon_t3uj0_30",
  "item-text": "_item-text_t3uj0_35",
  "item-description": "_item-description_t3uj0_45",
  "item-mark": "_item-mark_t3uj0_59"
}, Qf = ({
  icon: e,
  text: t,
  description: n,
  badge: r,
  marked: i,
  divider: o = !1,
  onClick: s = () => {
  },
  onAfterClick: a = () => {
  },
  rawIcon: u,
  isFirstItem: c
}) => {
  const { isPhone: l } = yo(), f = ke(
    (d) => {
      s(d), a();
    },
    [s, a]
  );
  return /* @__PURE__ */ ne(
    "div",
    {
      className: `${pt.item} ${o || !c && l ? pt["with-divider"] : ""}`,
      onClick: f,
      children: [
        /* @__PURE__ */ ne("div", { className: pt["item-content"], children: [
          /* @__PURE__ */ N("div", { className: `${pt["item-icon"]} ${u ? pt["raw-icon"] : ""}`, children: e }),
          /* @__PURE__ */ ne("div", { className: pt["item-text"], children: [
            t,
            r && /* @__PURE__ */ N(
              If,
              {
                customStyles: {
                  "margin-left": "9px",
                  "font-size": "14px",
                  "font-weight": 600,
                  padding: "4px 6px",
                  "margin-top": "-2px",
                  "text-transform": "uppercase"
                },
                variant: "blue",
                children: r
              }
            ),
            i && /* @__PURE__ */ N("span", { className: pt["item-mark"] })
          ] })
        ] }),
        n && /* @__PURE__ */ N("div", { className: `${pt["item-description"]} ${mo.Tiny}`, children: n })
      ]
    }
  );
};
function ji(e) {
  e.offsetTop;
}
const Jf = (e, t, n) => {
  const r = ku(n);
  Ff(e, (i) => {
    t.some(
      (s) => $f(s.current, i)
    ) || r(i);
  });
};
var Zr, fs;
function ed() {
  if (fs) return Zr;
  fs = 1;
  for (var e = "-_", t = 36; t--; )
    e += t.toString(36);
  for (t = 36; t-- - 10; )
    e += t.toString(36).toUpperCase();
  return Zr = function(n) {
    var r = "";
    for (t = n || 21; t--; )
      r += e[Math.random() * 64 | 0];
    return r;
  }, Zr;
}
var td = /* @__PURE__ */ ed();
const nd = /* @__PURE__ */ So(td);
function Vu(e) {
  const t = fe();
  return t.current || (t.current = { value: e() }), t.current.value;
}
function rd(e) {
  const [t, n] = we(!1);
  return Ce(() => {
    const r = (o) => {
      (o.key === e || o.keyCode === e) && n(!0);
    }, i = (o) => {
      (o.key === e || o.keyCode === e) && n(!1);
    };
    return window.addEventListener("keydown", r), window.addEventListener("keyup", i), () => {
      window.removeEventListener("keydown", r), window.removeEventListener("keyup", i);
    };
  }, [e]), t;
}
let tr = [];
const Fu = (e) => {
  const t = ku(e), n = Vu(() => nd()), r = rd(27);
  Ce(() => {
    r && tr.at(-1) === n && t();
  }, [t, n, r]), Ce(() => {
    const i = n;
    return tr.push(i), () => {
      tr = tr.filter((o) => o !== i);
    };
  }, [n]);
};
var nr = {}, ds;
function id() {
  return ds || (ds = 1, function(e) {
    (function(t, n) {
      n(e);
    })(nr, function(t) {
      function n(g) {
        if (Array.isArray(g)) {
          for (var p = 0, x = Array(g.length); p < g.length; p++) x[p] = g[p];
          return x;
        }
        return Array.from(g);
      }
      Object.defineProperty(t, "__esModule", { value: !0 });
      var r = !1;
      if (typeof window < "u") {
        var i = { get passive() {
          r = !0;
        } };
        window.addEventListener("testPassive", null, i), window.removeEventListener("testPassive", null, i);
      }
      function o(g) {
        return c.some(function(p) {
          return !(!p.options.allowTouchMove || !p.options.allowTouchMove(g));
        });
      }
      function s(g) {
        var p = g || window.event;
        return !!o(p.target) || 1 < p.touches.length || (p.preventDefault && p.preventDefault(), !1);
      }
      function a() {
        setTimeout(function() {
          h !== void 0 && (document.body.style.paddingRight = h, h = void 0), d !== void 0 && (document.body.style.overflow = d, d = void 0);
        });
      }
      var u = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && 1 < window.navigator.maxTouchPoints), c = [], l = !1, f = -1, d = void 0, h = void 0;
      t.disableBodyScroll = function(g, p) {
        if (u) {
          if (!g) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
          if (g && !c.some(function(O) {
            return O.targetElement === g;
          })) {
            var x = { targetElement: g, options: p || {} };
            c = [].concat(n(c), [x]), g.ontouchstart = function(O) {
              O.targetTouches.length === 1 && (f = O.targetTouches[0].clientY);
            }, g.ontouchmove = function(O) {
              var w, y, A, I;
              O.targetTouches.length === 1 && (y = g, I = (w = O).targetTouches[0].clientY - f, o(w.target) || (y && y.scrollTop === 0 && 0 < I || (A = y) && A.scrollHeight - A.scrollTop <= A.clientHeight && I < 0 ? s(w) : w.stopPropagation()));
            }, l || (document.addEventListener("touchmove", s, r ? { passive: !1 } : void 0), l = !0);
          }
        } else {
          D = p, setTimeout(function() {
            if (h === void 0) {
              var O = !!D && D.reserveScrollBarGap === !0, w = window.innerWidth - document.documentElement.clientWidth;
              O && 0 < w && (h = document.body.style.paddingRight, document.body.style.paddingRight = w + "px");
            }
            d === void 0 && (d = document.body.style.overflow, document.body.style.overflow = "hidden");
          });
          var m = { targetElement: g, options: p || {} };
          c = [].concat(n(c), [m]);
        }
        var D;
      }, t.clearAllBodyScrollLocks = function() {
        u ? (c.forEach(function(g) {
          g.targetElement.ontouchstart = null, g.targetElement.ontouchmove = null;
        }), l && (document.removeEventListener("touchmove", s, r ? { passive: !1 } : void 0), l = !1), c = [], f = -1) : (a(), c = []);
      }, t.enableBodyScroll = function(g) {
        if (u) {
          if (!g) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
          g.ontouchstart = null, g.ontouchmove = null, c = c.filter(function(p) {
            return p.targetElement !== g;
          }), l && c.length === 0 && (document.removeEventListener("touchmove", s, r ? { passive: !1 } : void 0), l = !1);
        } else (c = c.filter(function(p) {
          return p.targetElement !== g;
        })).length || a();
      };
    });
  }(nr)), nr;
}
var Mt = id();
const od = (e, t) => {
  const n = fe(t);
  cn(() => {
    const r = e == null ? void 0 : e.current;
    return r && Mt.disableBodyScroll(r, n.current), () => {
      r && Mt.enableBodyScroll(r);
    };
  }, [e]);
}, sd = "_container_svytu_1", ad = "_visible_svytu_11", ud = "_overlay_svytu_15", Xe = {
  container: sd,
  visible: ad,
  overlay: ud,
  "menu-cancellation": "_menu-cancellation_svytu_34",
  "align-left": "_align-left_svytu_72",
  "align-right": "_align-right_svytu_77",
  "position-top": "_position-top_svytu_83",
  "position-bottom": "_position-bottom_svytu_89"
}, cd = () => {
  const e = Vu(() => document.createElement("div"));
  return cn(() => (document.body.appendChild(e), () => {
    document.body.removeChild(e);
  }), [e]), e;
}, Uw = ({
  position: e,
  align: t = "right",
  actions: n = [],
  onClose: r = () => {
  },
  clickOutsideExceptRefs: i = []
}) => {
  const [o, s] = we(!1), { isPhone: a } = yo(), u = cd(), c = fe(null), l = fe(null), f = e ?? "top";
  Jf(l, i, r), Fu(r), cn(() => {
    c.current && ji(c.current), l.current && ji(l.current), s(!0);
  }, []), od(c);
  const d = n.filter((p) => !!p), h = [
    Xe.container,
    o ? Xe.visible : "",
    t === "left" ? Xe["align-left"] : Xe["align-right"],
    f === "top" ? Xe["position-top"] : Xe["position-bottom"]
  ].filter(Boolean).join(" "), g = /* @__PURE__ */ N("div", { className: h, ref: l, children: d.map((p, x) => /* @__PURE__ */ _r(
    Qf,
    {
      ...p,
      key: x,
      divider: p.divider,
      isFirstItem: x === 0,
      onAfterClick: r
    }
  )) });
  return a ? Zt.createPortal(
    /* @__PURE__ */ ne("div", { className: `${Xe.overlay} ${o ? Xe.visible : ""}`, ref: c, children: [
      g,
      /* @__PURE__ */ N("div", { className: `${Xe["menu-cancellation"]} ${o ? Xe.visible : ""}`, children: "Cancel" })
    ] }),
    u
  ) : g;
};
var Qr = {}, rr = { exports: {} }, ir = { exports: {} }, oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hs;
function ld() {
  if (hs) return oe;
  hs = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function O(y) {
    if (typeof y == "object" && y !== null) {
      var A = y.$$typeof;
      switch (A) {
        case t:
          switch (y = y.type, y) {
            case u:
            case c:
            case r:
            case o:
            case i:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case l:
                case g:
                case h:
                case s:
                  return y;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function w(y) {
    return O(y) === c;
  }
  return oe.AsyncMode = u, oe.ConcurrentMode = c, oe.ContextConsumer = a, oe.ContextProvider = s, oe.Element = t, oe.ForwardRef = l, oe.Fragment = r, oe.Lazy = g, oe.Memo = h, oe.Portal = n, oe.Profiler = o, oe.StrictMode = i, oe.Suspense = f, oe.isAsyncMode = function(y) {
    return w(y) || O(y) === u;
  }, oe.isConcurrentMode = w, oe.isContextConsumer = function(y) {
    return O(y) === a;
  }, oe.isContextProvider = function(y) {
    return O(y) === s;
  }, oe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, oe.isForwardRef = function(y) {
    return O(y) === l;
  }, oe.isFragment = function(y) {
    return O(y) === r;
  }, oe.isLazy = function(y) {
    return O(y) === g;
  }, oe.isMemo = function(y) {
    return O(y) === h;
  }, oe.isPortal = function(y) {
    return O(y) === n;
  }, oe.isProfiler = function(y) {
    return O(y) === o;
  }, oe.isStrictMode = function(y) {
    return O(y) === i;
  }, oe.isSuspense = function(y) {
    return O(y) === f;
  }, oe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === c || y === o || y === i || y === f || y === d || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === h || y.$$typeof === s || y.$$typeof === a || y.$$typeof === l || y.$$typeof === x || y.$$typeof === m || y.$$typeof === D || y.$$typeof === p);
  }, oe.typeOf = O, oe;
}
var se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ps;
function fd() {
  return ps || (ps = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
    function O(U) {
      return typeof U == "string" || typeof U == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      U === r || U === c || U === o || U === i || U === f || U === d || typeof U == "object" && U !== null && (U.$$typeof === g || U.$$typeof === h || U.$$typeof === s || U.$$typeof === a || U.$$typeof === l || U.$$typeof === x || U.$$typeof === m || U.$$typeof === D || U.$$typeof === p);
    }
    function w(U) {
      if (typeof U == "object" && U !== null) {
        var ce = U.$$typeof;
        switch (ce) {
          case t:
            var Z = U.type;
            switch (Z) {
              case u:
              case c:
              case r:
              case o:
              case i:
              case f:
                return Z;
              default:
                var ve = Z && Z.$$typeof;
                switch (ve) {
                  case a:
                  case l:
                  case g:
                  case h:
                  case s:
                    return ve;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var y = u, A = c, I = a, E = s, b = t, R = l, L = r, $ = g, F = h, H = n, X = o, K = i, z = f, M = !1;
    function _(U) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), S(U) || w(U) === u;
    }
    function S(U) {
      return w(U) === c;
    }
    function P(U) {
      return w(U) === a;
    }
    function v(U) {
      return w(U) === s;
    }
    function T(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function C(U) {
      return w(U) === l;
    }
    function k(U) {
      return w(U) === r;
    }
    function B(U) {
      return w(U) === g;
    }
    function j(U) {
      return w(U) === h;
    }
    function q(U) {
      return w(U) === n;
    }
    function Y(U) {
      return w(U) === o;
    }
    function G(U) {
      return w(U) === i;
    }
    function ee(U) {
      return w(U) === f;
    }
    se.AsyncMode = y, se.ConcurrentMode = A, se.ContextConsumer = I, se.ContextProvider = E, se.Element = b, se.ForwardRef = R, se.Fragment = L, se.Lazy = $, se.Memo = F, se.Portal = H, se.Profiler = X, se.StrictMode = K, se.Suspense = z, se.isAsyncMode = _, se.isConcurrentMode = S, se.isContextConsumer = P, se.isContextProvider = v, se.isElement = T, se.isForwardRef = C, se.isFragment = k, se.isLazy = B, se.isMemo = j, se.isPortal = q, se.isProfiler = Y, se.isStrictMode = G, se.isSuspense = ee, se.isValidElementType = O, se.typeOf = w;
  }()), se;
}
var ms;
function $u() {
  return ms || (ms = 1, process.env.NODE_ENV === "production" ? ir.exports = ld() : ir.exports = fd()), ir.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jr, gs;
function dd() {
  if (gs) return Jr;
  gs = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(l) {
        return s[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Jr = i() ? Object.assign : function(o, s) {
    for (var a, u = r(o), c, l = 1; l < arguments.length; l++) {
      a = Object(arguments[l]);
      for (var f in a)
        t.call(a, f) && (u[f] = a[f]);
      if (e) {
        c = e(a);
        for (var d = 0; d < c.length; d++)
          n.call(a, c[d]) && (u[c[d]] = a[c[d]]);
      }
    }
    return u;
  }, Jr;
}
var ei, vs;
function bo() {
  if (vs) return ei;
  vs = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ei = e, ei;
}
var ti, ys;
function Bu() {
  return ys || (ys = 1, ti = Function.call.bind(Object.prototype.hasOwnProperty)), ti;
}
var ni, Ss;
function hd() {
  if (Ss) return ni;
  Ss = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ bo(), n = {}, r = /* @__PURE__ */ Bu();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in o)
        if (r(o, l)) {
          var f;
          try {
            if (typeof o[l] != "function") {
              var d = Error(
                (u || "React class") + ": " + a + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[l](s, l, u, a, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + a + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ni = i, ni;
}
var ri, bs;
function pd() {
  if (bs) return ri;
  bs = 1;
  var e = $u(), t = dd(), n = /* @__PURE__ */ bo(), r = /* @__PURE__ */ Bu(), i = /* @__PURE__ */ hd(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ri = function(a, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(S) {
      var P = S && (c && S[c] || S[l]);
      if (typeof P == "function")
        return P;
    }
    var d = "<<anonymous>>", h = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: D(),
      arrayOf: O,
      element: w(),
      elementType: y(),
      instanceOf: A,
      node: R(),
      objectOf: E,
      oneOf: I,
      oneOfType: b,
      shape: $,
      exact: F
    };
    function g(S, P) {
      return S === P ? S !== 0 || 1 / S === 1 / P : S !== S && P !== P;
    }
    function p(S, P) {
      this.message = S, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function x(S) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, v = 0;
      function T(k, B, j, q, Y, G, ee) {
        if (q = q || d, G = G || j, ee !== n) {
          if (u) {
            var U = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw U.name = "Invariant Violation", U;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = q + ":" + j;
            !P[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            v < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[ce] = !0, v++);
          }
        }
        return B[j] == null ? k ? B[j] === null ? new p("The " + Y + " `" + G + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new p("The " + Y + " `" + G + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : S(B, j, q, Y, G);
      }
      var C = T.bind(null, !1);
      return C.isRequired = T.bind(null, !0), C;
    }
    function m(S) {
      function P(v, T, C, k, B, j) {
        var q = v[T], Y = K(q);
        if (Y !== S) {
          var G = z(q);
          return new p(
            "Invalid " + k + " `" + B + "` of type " + ("`" + G + "` supplied to `" + C + "`, expected ") + ("`" + S + "`."),
            { expectedType: S }
          );
        }
        return null;
      }
      return x(P);
    }
    function D() {
      return x(s);
    }
    function O(S) {
      function P(v, T, C, k, B) {
        if (typeof S != "function")
          return new p("Property `" + B + "` of component `" + C + "` has invalid PropType notation inside arrayOf.");
        var j = v[T];
        if (!Array.isArray(j)) {
          var q = K(j);
          return new p("Invalid " + k + " `" + B + "` of type " + ("`" + q + "` supplied to `" + C + "`, expected an array."));
        }
        for (var Y = 0; Y < j.length; Y++) {
          var G = S(j, Y, C, k, B + "[" + Y + "]", n);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return x(P);
    }
    function w() {
      function S(P, v, T, C, k) {
        var B = P[v];
        if (!a(B)) {
          var j = K(B);
          return new p("Invalid " + C + " `" + k + "` of type " + ("`" + j + "` supplied to `" + T + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(S);
    }
    function y() {
      function S(P, v, T, C, k) {
        var B = P[v];
        if (!e.isValidElementType(B)) {
          var j = K(B);
          return new p("Invalid " + C + " `" + k + "` of type " + ("`" + j + "` supplied to `" + T + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(S);
    }
    function A(S) {
      function P(v, T, C, k, B) {
        if (!(v[T] instanceof S)) {
          var j = S.name || d, q = _(v[T]);
          return new p("Invalid " + k + " `" + B + "` of type " + ("`" + q + "` supplied to `" + C + "`, expected ") + ("instance of `" + j + "`."));
        }
        return null;
      }
      return x(P);
    }
    function I(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function P(v, T, C, k, B) {
        for (var j = v[T], q = 0; q < S.length; q++)
          if (g(j, S[q]))
            return null;
        var Y = JSON.stringify(S, function(ee, U) {
          var ce = z(U);
          return ce === "symbol" ? String(U) : U;
        });
        return new p("Invalid " + k + " `" + B + "` of value `" + String(j) + "` " + ("supplied to `" + C + "`, expected one of " + Y + "."));
      }
      return x(P);
    }
    function E(S) {
      function P(v, T, C, k, B) {
        if (typeof S != "function")
          return new p("Property `" + B + "` of component `" + C + "` has invalid PropType notation inside objectOf.");
        var j = v[T], q = K(j);
        if (q !== "object")
          return new p("Invalid " + k + " `" + B + "` of type " + ("`" + q + "` supplied to `" + C + "`, expected an object."));
        for (var Y in j)
          if (r(j, Y)) {
            var G = S(j, Y, C, k, B + "." + Y, n);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return x(P);
    }
    function b(S) {
      if (!Array.isArray(S))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var P = 0; P < S.length; P++) {
        var v = S[P];
        if (typeof v != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + M(v) + " at index " + P + "."
          ), s;
      }
      function T(C, k, B, j, q) {
        for (var Y = [], G = 0; G < S.length; G++) {
          var ee = S[G], U = ee(C, k, B, j, q, n);
          if (U == null)
            return null;
          U.data && r(U.data, "expectedType") && Y.push(U.data.expectedType);
        }
        var ce = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new p("Invalid " + j + " `" + q + "` supplied to " + ("`" + B + "`" + ce + "."));
      }
      return x(T);
    }
    function R() {
      function S(P, v, T, C, k) {
        return H(P[v]) ? null : new p("Invalid " + C + " `" + k + "` supplied to " + ("`" + T + "`, expected a ReactNode."));
      }
      return x(S);
    }
    function L(S, P, v, T, C) {
      return new p(
        (S || "React class") + ": " + P + " type `" + v + "." + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + C + "`."
      );
    }
    function $(S) {
      function P(v, T, C, k, B) {
        var j = v[T], q = K(j);
        if (q !== "object")
          return new p("Invalid " + k + " `" + B + "` of type `" + q + "` " + ("supplied to `" + C + "`, expected `object`."));
        for (var Y in S) {
          var G = S[Y];
          if (typeof G != "function")
            return L(C, k, B, Y, z(G));
          var ee = G(j, Y, C, k, B + "." + Y, n);
          if (ee)
            return ee;
        }
        return null;
      }
      return x(P);
    }
    function F(S) {
      function P(v, T, C, k, B) {
        var j = v[T], q = K(j);
        if (q !== "object")
          return new p("Invalid " + k + " `" + B + "` of type `" + q + "` " + ("supplied to `" + C + "`, expected `object`."));
        var Y = t({}, v[T], S);
        for (var G in Y) {
          var ee = S[G];
          if (r(S, G) && typeof ee != "function")
            return L(C, k, B, G, z(ee));
          if (!ee)
            return new p(
              "Invalid " + k + " `" + B + "` key `" + G + "` supplied to `" + C + "`.\nBad object: " + JSON.stringify(v[T], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(S), null, "  ")
            );
          var U = ee(j, G, C, k, B + "." + G, n);
          if (U)
            return U;
        }
        return null;
      }
      return x(P);
    }
    function H(S) {
      switch (typeof S) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !S;
        case "object":
          if (Array.isArray(S))
            return S.every(H);
          if (S === null || a(S))
            return !0;
          var P = f(S);
          if (P) {
            var v = P.call(S), T;
            if (P !== S.entries) {
              for (; !(T = v.next()).done; )
                if (!H(T.value))
                  return !1;
            } else
              for (; !(T = v.next()).done; ) {
                var C = T.value;
                if (C && !H(C[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(S, P) {
      return S === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function K(S) {
      var P = typeof S;
      return Array.isArray(S) ? "array" : S instanceof RegExp ? "object" : X(P, S) ? "symbol" : P;
    }
    function z(S) {
      if (typeof S > "u" || S === null)
        return "" + S;
      var P = K(S);
      if (P === "object") {
        if (S instanceof Date)
          return "date";
        if (S instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function M(S) {
      var P = z(S);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function _(S) {
      return !S.constructor || !S.constructor.name ? d : S.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, ri;
}
var ii, ws;
function md() {
  if (ws) return ii;
  ws = 1;
  var e = /* @__PURE__ */ bo();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ii = function() {
    function r(s, a, u, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, ii;
}
var Ts;
function ln() {
  if (Ts) return rr.exports;
  if (Ts = 1, process.env.NODE_ENV !== "production") {
    var e = $u(), t = !0;
    rr.exports = /* @__PURE__ */ pd()(e.isElement, t);
  } else
    rr.exports = /* @__PURE__ */ md()();
  return rr.exports;
}
var oi, xs;
function gd() {
  if (xs) return oi;
  xs = 1;
  function e(t, n) {
    if (t === n)
      return !0;
    if (!t || !n)
      return !1;
    var r = t.length;
    if (n.length !== r)
      return !1;
    for (var i = 0; i < r; i++)
      if (t[i] !== n[i])
        return !1;
    return !0;
  }
  return oi = e, oi;
}
var si = {}, ai, Es;
function vd() {
  if (Es) return ai;
  Es = 1;
  var e = /* @__PURE__ */ function() {
    function t(n, r) {
      var i = [], o = !0, s = !1, a = void 0;
      try {
        for (var u = n[Symbol.iterator](), c; !(o = (c = u.next()).done) && (i.push(c.value), !(r && i.length === r)); o = !0)
          ;
      } catch (l) {
        s = !0, a = l;
      } finally {
        try {
          !o && u.return && u.return();
        } finally {
          if (s) throw a;
        }
      }
      return i;
    }
    return function(n, r) {
      if (Array.isArray(n))
        return n;
      if (Symbol.iterator in Object(n))
        return t(n, r);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }();
  return ai = function(t) {
    var n = t.data, r = t.multiSection;
    function i(c) {
      for (c === null ? c = 0 : c++; c < n.length && n[c] === 0; )
        c++;
      return c === n.length ? null : c;
    }
    function o(c) {
      for (c === null ? c = n.length - 1 : c--; c >= 0 && n[c] === 0; )
        c--;
      return c === -1 ? null : c;
    }
    function s(c) {
      var l = e(c, 2), f = l[0], d = l[1];
      return r ? d === null || d === n[f] - 1 ? (f = i(f), f === null ? [null, null] : [f, 0]) : [f, d + 1] : n === 0 || d === n - 1 ? [null, null] : d === null ? [null, 0] : [null, d + 1];
    }
    function a(c) {
      var l = e(c, 2), f = l[0], d = l[1];
      return r ? d === null || d === 0 ? (f = o(f), f === null ? [null, null] : [f, n[f] - 1]) : [f, d - 1] : n === 0 || d === 0 ? [null, null] : d === null ? [null, n - 1] : [null, d - 1];
    }
    function u(c) {
      return s(c)[1] === null;
    }
    return {
      next: s,
      prev: a,
      isLast: u
    };
  }, ai;
}
var or = { exports: {} }, ui, Ps;
function yd() {
  if (Ps) return ui;
  Ps = 1;
  var e = Object.prototype.propertyIsEnumerable;
  function t(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function n(r) {
    var i = Object.getOwnPropertyNames(r);
    return Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(r))), i.filter(function(o) {
      return e.call(r, o);
    });
  }
  return ui = Object.assign || function(r, i) {
    for (var o, s, a = t(r), u = 1; u < arguments.length; u++) {
      o = arguments[u], s = n(Object(o));
      for (var c = 0; c < s.length; c++)
        a[s[c]] = o[s[c]];
    }
    return a;
  }, ui;
}
var _s;
function Sd() {
  return _s || (_s = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = /* @__PURE__ */ function() {
      function u(c, l) {
        var f = [], d = !0, h = !1, g = void 0;
        try {
          for (var p = c[Symbol.iterator](), x; !(d = (x = p.next()).done) && (f.push(x.value), !(l && f.length === l)); d = !0)
            ;
        } catch (m) {
          h = !0, g = m;
        } finally {
          try {
            !d && p.return && p.return();
          } finally {
            if (h) throw g;
          }
        }
        return f;
      }
      return function(c, l) {
        if (Array.isArray(c))
          return c;
        if (Symbol.iterator in Object(c))
          return u(c, l);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }();
    function r(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function i(u) {
      if (Array.isArray(u)) {
        for (var c = 0, l = Array(u.length); c < u.length; c++) l[c] = u[c];
        return l;
      } else
        return Array.from(u);
    }
    var o = yd(), s = r(o), a = function(c) {
      return c;
    };
    t.default = function(u) {
      var c = Array.isArray(u) && u.length === 2 ? u : [u, null], l = n(c, 2), f = l[0], d = l[1];
      return function(h) {
        for (var g = arguments.length, p = Array(g > 1 ? g - 1 : 0), x = 1; x < g; x++)
          p[x - 1] = arguments[x];
        var m = p.map(function(D) {
          return f[D];
        }).filter(a);
        return typeof m[0] == "string" || typeof d == "function" ? { key: h, className: d ? d.apply(void 0, i(m)) : m.join(" ") } : { key: h, style: s.default.apply(void 0, [{}].concat(i(m))) };
      };
    }, e.exports = t.default;
  }(or, or.exports)), or.exports;
}
var ci = {}, li = {}, Cs;
function wo() {
  return Cs || (Cs = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    function t(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(o) {
        return typeof o;
      } : t = function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, t(r);
    }
    function n(r, i) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r === i)
        return !1;
      var s = Object.keys(r), a = Object.keys(i);
      if (s.length !== a.length)
        return !0;
      var u = {}, c, l;
      for (c = 0, l = o.length; c < l; c++)
        u[o[c]] = !0;
      for (c = 0, l = s.length; c < l; c++) {
        var f = s[c], d = r[f], h = i[f];
        if (d !== h) {
          if (!u[f] || d === null || h === null || t(d) !== "object" || t(h) !== "object")
            return !0;
          var g = Object.keys(d), p = Object.keys(h);
          if (g.length !== p.length)
            return !0;
          for (var x = 0, m = g.length; x < m; x++) {
            var D = g[x];
            if (d[D] !== h[D])
              return !0;
          }
        }
      }
      return !1;
    }
  }(li)), li;
}
var Rs;
function bd() {
  return Rs || (Rs = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = s(W), n = i(/* @__PURE__ */ ln()), r = i(wo());
    function i(w) {
      return w && w.__esModule ? w : { default: w };
    }
    function o() {
      if (typeof WeakMap != "function") return null;
      var w = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return w;
      }, w;
    }
    function s(w) {
      if (w && w.__esModule)
        return w;
      if (w === null || a(w) !== "object" && typeof w != "function")
        return { default: w };
      var y = o();
      if (y && y.has(w))
        return y.get(w);
      var A = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in w)
        if (Object.prototype.hasOwnProperty.call(w, E)) {
          var b = I ? Object.getOwnPropertyDescriptor(w, E) : null;
          b && (b.get || b.set) ? Object.defineProperty(A, E, b) : A[E] = w[E];
        }
      return A.default = w, y && y.set(w, A), A;
    }
    function a(w) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(A) {
        return typeof A;
      } : a = function(A) {
        return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
      }, a(w);
    }
    function u(w, y) {
      if (!(w instanceof y))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(w, y) {
      for (var A = 0; A < y.length; A++) {
        var I = y[A];
        I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(w, I.key, I);
      }
    }
    function l(w, y, A) {
      return y && c(w.prototype, y), w;
    }
    function f(w) {
      return function() {
        var y = p(w), A;
        if (g()) {
          var I = p(this).constructor;
          A = Reflect.construct(y, arguments, I);
        } else
          A = y.apply(this, arguments);
        return d(this, A);
      };
    }
    function d(w, y) {
      return y && (a(y) === "object" || typeof y == "function") ? y : h(w);
    }
    function h(w) {
      if (w === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return w;
    }
    function g() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function p(w) {
      return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
        return A.__proto__ || Object.getPrototypeOf(A);
      }, p(w);
    }
    function x(w, y) {
      if (typeof y != "function" && y !== null)
        throw new TypeError("Super expression must either be null or a function");
      w.prototype = Object.create(y && y.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), y && m(w, y);
    }
    function m(w, y) {
      return m = Object.setPrototypeOf || function(I, E) {
        return I.__proto__ = E, I;
      }, m(w, y);
    }
    function D(w, y, A) {
      return y in w ? Object.defineProperty(w, y, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : w[y] = A, w;
    }
    var O = /* @__PURE__ */ function(w) {
      x(A, w);
      var y = f(A);
      function A() {
        return u(this, A), y.apply(this, arguments);
      }
      return l(A, [{
        key: "shouldComponentUpdate",
        value: function(E) {
          return (0, r.default)(E, this.props);
        }
      }, {
        key: "render",
        value: function() {
          var E = this.props, b = E.section, R = E.renderSectionTitle, L = E.theme, $ = E.sectionKeyPrefix, F = R(b);
          return F ? /* @__PURE__ */ t.default.createElement("div", L("".concat($, "title"), "sectionTitle"), F) : null;
        }
      }]), A;
    }(t.Component);
    e.default = O, D(O, "propTypes", {
      section: n.default.any.isRequired,
      renderSectionTitle: n.default.func.isRequired,
      theme: n.default.func.isRequired,
      sectionKeyPrefix: n.default.string.isRequired
    });
  }(ci)), ci;
}
var fi = {}, di = {}, Os;
function wd() {
  return Os || (Os = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = s(W), n = i(/* @__PURE__ */ ln()), r = i(wo());
    function i(b) {
      return b && b.__esModule ? b : { default: b };
    }
    function o() {
      if (typeof WeakMap != "function") return null;
      var b = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return b;
      }, b;
    }
    function s(b) {
      if (b && b.__esModule)
        return b;
      if (b === null || a(b) !== "object" && typeof b != "function")
        return { default: b };
      var R = o();
      if (R && R.has(b))
        return R.get(b);
      var L = {}, $ = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var F in b)
        if (Object.prototype.hasOwnProperty.call(b, F)) {
          var H = $ ? Object.getOwnPropertyDescriptor(b, F) : null;
          H && (H.get || H.set) ? Object.defineProperty(L, F, H) : L[F] = b[F];
        }
      return L.default = b, R && R.set(b, L), L;
    }
    function a(b) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(L) {
        return typeof L;
      } : a = function(L) {
        return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
      }, a(b);
    }
    function u() {
      return u = Object.assign || function(b) {
        for (var R = 1; R < arguments.length; R++) {
          var L = arguments[R];
          for (var $ in L)
            Object.prototype.hasOwnProperty.call(L, $) && (b[$] = L[$]);
        }
        return b;
      }, u.apply(this, arguments);
    }
    function c(b, R) {
      var L = Object.keys(b);
      if (Object.getOwnPropertySymbols) {
        var $ = Object.getOwnPropertySymbols(b);
        R && ($ = $.filter(function(F) {
          return Object.getOwnPropertyDescriptor(b, F).enumerable;
        })), L.push.apply(L, $);
      }
      return L;
    }
    function l(b) {
      for (var R = 1; R < arguments.length; R++) {
        var L = arguments[R] != null ? arguments[R] : {};
        R % 2 ? c(Object(L), !0).forEach(function($) {
          I(b, $, L[$]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(L)) : c(Object(L)).forEach(function($) {
          Object.defineProperty(b, $, Object.getOwnPropertyDescriptor(L, $));
        });
      }
      return b;
    }
    function f(b, R) {
      if (b == null) return {};
      var L = d(b, R), $, F;
      if (Object.getOwnPropertySymbols) {
        var H = Object.getOwnPropertySymbols(b);
        for (F = 0; F < H.length; F++)
          $ = H[F], !(R.indexOf($) >= 0) && Object.prototype.propertyIsEnumerable.call(b, $) && (L[$] = b[$]);
      }
      return L;
    }
    function d(b, R) {
      if (b == null) return {};
      var L = {}, $ = Object.keys(b), F, H;
      for (H = 0; H < $.length; H++)
        F = $[H], !(R.indexOf(F) >= 0) && (L[F] = b[F]);
      return L;
    }
    function h(b, R) {
      if (!(b instanceof R))
        throw new TypeError("Cannot call a class as a function");
    }
    function g(b, R) {
      for (var L = 0; L < R.length; L++) {
        var $ = R[L];
        $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(b, $.key, $);
      }
    }
    function p(b, R, L) {
      return R && g(b.prototype, R), b;
    }
    function x(b) {
      return function() {
        var R = w(b), L;
        if (O()) {
          var $ = w(this).constructor;
          L = Reflect.construct(R, arguments, $);
        } else
          L = R.apply(this, arguments);
        return m(this, L);
      };
    }
    function m(b, R) {
      return R && (a(R) === "object" || typeof R == "function") ? R : D(b);
    }
    function D(b) {
      if (b === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return b;
    }
    function O() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w(b) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
        return L.__proto__ || Object.getPrototypeOf(L);
      }, w(b);
    }
    function y(b, R) {
      if (typeof R != "function" && R !== null)
        throw new TypeError("Super expression must either be null or a function");
      b.prototype = Object.create(R && R.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), R && A(b, R);
    }
    function A(b, R) {
      return A = Object.setPrototypeOf || function($, F) {
        return $.__proto__ = F, $;
      }, A(b, R);
    }
    function I(b, R, L) {
      return R in b ? Object.defineProperty(b, R, { value: L, enumerable: !0, configurable: !0, writable: !0 }) : b[R] = L, b;
    }
    var E = /* @__PURE__ */ function(b) {
      y(L, b);
      var R = x(L);
      function L() {
        var $;
        h(this, L);
        for (var F = arguments.length, H = new Array(F), X = 0; X < F; X++)
          H[X] = arguments[X];
        return $ = R.call.apply(R, [this].concat(H)), I(D($), "storeItemReference", function(K) {
          K !== null && ($.item = K);
        }), I(D($), "onMouseEnter", function(K) {
          var z = $.props, M = z.sectionIndex, _ = z.itemIndex;
          $.props.onMouseEnter(K, {
            sectionIndex: M,
            itemIndex: _
          });
        }), I(D($), "onMouseLeave", function(K) {
          var z = $.props, M = z.sectionIndex, _ = z.itemIndex;
          $.props.onMouseLeave(K, {
            sectionIndex: M,
            itemIndex: _
          });
        }), I(D($), "onMouseDown", function(K) {
          var z = $.props, M = z.sectionIndex, _ = z.itemIndex;
          $.props.onMouseDown(K, {
            sectionIndex: M,
            itemIndex: _
          });
        }), I(D($), "onClick", function(K) {
          var z = $.props, M = z.sectionIndex, _ = z.itemIndex;
          $.props.onClick(K, {
            sectionIndex: M,
            itemIndex: _
          });
        }), $;
      }
      return p(L, [{
        key: "shouldComponentUpdate",
        value: function(F) {
          return (0, r.default)(F, this.props, ["renderItemData"]);
        }
      }, {
        key: "render",
        value: function() {
          var F = this.props, H = F.isHighlighted, X = F.item, K = F.renderItem, z = F.renderItemData, M = f(F, ["isHighlighted", "item", "renderItem", "renderItemData"]);
          return delete M.sectionIndex, delete M.itemIndex, typeof M.onMouseEnter == "function" && (M.onMouseEnter = this.onMouseEnter), typeof M.onMouseLeave == "function" && (M.onMouseLeave = this.onMouseLeave), typeof M.onMouseDown == "function" && (M.onMouseDown = this.onMouseDown), typeof M.onClick == "function" && (M.onClick = this.onClick), /* @__PURE__ */ t.default.createElement("li", u({
            role: "option"
          }, M, {
            ref: this.storeItemReference
          }), K(X, l({
            isHighlighted: H
          }, z)));
        }
      }]), L;
    }(t.Component);
    e.default = E, I(E, "propTypes", {
      sectionIndex: n.default.number,
      isHighlighted: n.default.bool.isRequired,
      itemIndex: n.default.number.isRequired,
      item: n.default.any.isRequired,
      renderItem: n.default.func.isRequired,
      renderItemData: n.default.object.isRequired,
      onMouseEnter: n.default.func,
      onMouseLeave: n.default.func,
      onMouseDown: n.default.func,
      onClick: n.default.func
    });
  }(di)), di;
}
var Ds;
function Td() {
  return Ds || (Ds = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = a(W), n = o(/* @__PURE__ */ ln()), r = o(wd()), i = o(wo());
    function o(E) {
      return E && E.__esModule ? E : { default: E };
    }
    function s() {
      if (typeof WeakMap != "function") return null;
      var E = /* @__PURE__ */ new WeakMap();
      return s = function() {
        return E;
      }, E;
    }
    function a(E) {
      if (E && E.__esModule)
        return E;
      if (E === null || u(E) !== "object" && typeof E != "function")
        return { default: E };
      var b = s();
      if (b && b.has(E))
        return b.get(E);
      var R = {}, L = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var $ in E)
        if (Object.prototype.hasOwnProperty.call(E, $)) {
          var F = L ? Object.getOwnPropertyDescriptor(E, $) : null;
          F && (F.get || F.set) ? Object.defineProperty(R, $, F) : R[$] = E[$];
        }
      return R.default = E, b && b.set(E, R), R;
    }
    function u(E) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? u = function(R) {
        return typeof R;
      } : u = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, u(E);
    }
    function c() {
      return c = Object.assign || function(E) {
        for (var b = 1; b < arguments.length; b++) {
          var R = arguments[b];
          for (var L in R)
            Object.prototype.hasOwnProperty.call(R, L) && (E[L] = R[L]);
        }
        return E;
      }, c.apply(this, arguments);
    }
    function l(E, b) {
      var R = Object.keys(E);
      if (Object.getOwnPropertySymbols) {
        var L = Object.getOwnPropertySymbols(E);
        b && (L = L.filter(function($) {
          return Object.getOwnPropertyDescriptor(E, $).enumerable;
        })), R.push.apply(R, L);
      }
      return R;
    }
    function f(E) {
      for (var b = 1; b < arguments.length; b++) {
        var R = arguments[b] != null ? arguments[b] : {};
        b % 2 ? l(Object(R), !0).forEach(function(L) {
          A(E, L, R[L]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(R)) : l(Object(R)).forEach(function(L) {
          Object.defineProperty(E, L, Object.getOwnPropertyDescriptor(R, L));
        });
      }
      return E;
    }
    function d(E, b) {
      if (!(E instanceof b))
        throw new TypeError("Cannot call a class as a function");
    }
    function h(E, b) {
      for (var R = 0; R < b.length; R++) {
        var L = b[R];
        L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(E, L.key, L);
      }
    }
    function g(E, b, R) {
      return b && h(E.prototype, b), E;
    }
    function p(E) {
      return function() {
        var b = O(E), R;
        if (D()) {
          var L = O(this).constructor;
          R = Reflect.construct(b, arguments, L);
        } else
          R = b.apply(this, arguments);
        return x(this, R);
      };
    }
    function x(E, b) {
      return b && (u(b) === "object" || typeof b == "function") ? b : m(E);
    }
    function m(E) {
      if (E === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return E;
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(E) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(R) {
        return R.__proto__ || Object.getPrototypeOf(R);
      }, O(E);
    }
    function w(E, b) {
      if (typeof b != "function" && b !== null)
        throw new TypeError("Super expression must either be null or a function");
      E.prototype = Object.create(b && b.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), b && y(E, b);
    }
    function y(E, b) {
      return y = Object.setPrototypeOf || function(L, $) {
        return L.__proto__ = $, L;
      }, y(E, b);
    }
    function A(E, b, R) {
      return b in E ? Object.defineProperty(E, b, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : E[b] = R, E;
    }
    var I = /* @__PURE__ */ function(E) {
      w(R, E);
      var b = p(R);
      function R() {
        var L;
        d(this, R);
        for (var $ = arguments.length, F = new Array($), H = 0; H < $; H++)
          F[H] = arguments[H];
        return L = b.call.apply(b, [this].concat(F)), A(m(L), "storeHighlightedItemReference", function(X) {
          L.props.onHighlightedItemChange(X === null ? null : X.item);
        }), L;
      }
      return g(R, [{
        key: "shouldComponentUpdate",
        value: function($) {
          return (0, i.default)($, this.props, ["itemProps"]);
        }
      }, {
        key: "render",
        value: function() {
          var $ = this, F = this.props, H = F.items, X = F.itemProps, K = F.renderItem, z = F.renderItemData, M = F.sectionIndex, _ = F.highlightedItemIndex, S = F.getItemId, P = F.theme, v = F.keyPrefix, T = M === null ? v : "".concat(v, "section-").concat(M, "-"), C = typeof X == "function";
          return /* @__PURE__ */ t.default.createElement("ul", c({
            role: "listbox"
          }, P("".concat(T, "items-list"), "itemsList")), H.map(function(k, B) {
            var j = B === 0, q = B === _, Y = "".concat(T, "item-").concat(B), G = C ? X({
              sectionIndex: M,
              itemIndex: B
            }) : X, ee = f({
              id: S(M, B),
              "aria-selected": q
            }, P(Y, "item", j && "itemFirst", q && "itemHighlighted"), {}, G);
            return q && (ee.ref = $.storeHighlightedItemReference), /* @__PURE__ */ t.default.createElement(r.default, c({}, ee, {
              sectionIndex: M,
              isHighlighted: q,
              itemIndex: B,
              item: k,
              renderItem: K,
              renderItemData: z
            }));
          }));
        }
      }]), R;
    }(t.Component);
    e.default = I, A(I, "propTypes", {
      items: n.default.array.isRequired,
      itemProps: n.default.oneOfType([n.default.object, n.default.func]),
      renderItem: n.default.func.isRequired,
      renderItemData: n.default.object.isRequired,
      sectionIndex: n.default.number,
      highlightedItemIndex: n.default.number,
      onHighlightedItemChange: n.default.func.isRequired,
      getItemId: n.default.func.isRequired,
      theme: n.default.func.isRequired,
      keyPrefix: n.default.string.isRequired
    }), A(I, "defaultProps", {
      sectionIndex: null
    });
  }(fi)), fi;
}
var As;
function xd() {
  return As || (As = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = c(W), n = a(/* @__PURE__ */ ln()), r = a(vd()), i = a(Sd()), o = a(bd()), s = a(Td());
    function a(_) {
      return _ && _.__esModule ? _ : { default: _ };
    }
    function u() {
      if (typeof WeakMap != "function") return null;
      var _ = /* @__PURE__ */ new WeakMap();
      return u = function() {
        return _;
      }, _;
    }
    function c(_) {
      if (_ && _.__esModule)
        return _;
      if (_ === null || D(_) !== "object" && typeof _ != "function")
        return { default: _ };
      var S = u();
      if (S && S.has(_))
        return S.get(_);
      var P = {}, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var T in _)
        if (Object.prototype.hasOwnProperty.call(_, T)) {
          var C = v ? Object.getOwnPropertyDescriptor(_, T) : null;
          C && (C.get || C.set) ? Object.defineProperty(P, T, C) : P[T] = _[T];
        }
      return P.default = _, S && S.set(_, P), P;
    }
    function l(_, S) {
      var P = Object.keys(_);
      if (Object.getOwnPropertySymbols) {
        var v = Object.getOwnPropertySymbols(_);
        S && (v = v.filter(function(T) {
          return Object.getOwnPropertyDescriptor(_, T).enumerable;
        })), P.push.apply(P, v);
      }
      return P;
    }
    function f(_) {
      for (var S = 1; S < arguments.length; S++) {
        var P = arguments[S] != null ? arguments[S] : {};
        S % 2 ? l(Object(P), !0).forEach(function(v) {
          F(_, v, P[v]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_, Object.getOwnPropertyDescriptors(P)) : l(Object(P)).forEach(function(v) {
          Object.defineProperty(_, v, Object.getOwnPropertyDescriptor(P, v));
        });
      }
      return _;
    }
    function d(_, S) {
      return m(_) || x(_, S) || g(_, S) || h();
    }
    function h() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function g(_, S) {
      if (_) {
        if (typeof _ == "string") return p(_, S);
        var P = Object.prototype.toString.call(_).slice(8, -1);
        if (P === "Object" && _.constructor && (P = _.constructor.name), P === "Map" || P === "Set") return Array.from(P);
        if (P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P)) return p(_, S);
      }
    }
    function p(_, S) {
      (S == null || S > _.length) && (S = _.length);
      for (var P = 0, v = new Array(S); P < S; P++)
        v[P] = _[P];
      return v;
    }
    function x(_, S) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(_)))) {
        var P = [], v = !0, T = !1, C = void 0;
        try {
          for (var k = _[Symbol.iterator](), B; !(v = (B = k.next()).done) && (P.push(B.value), !(S && P.length === S)); v = !0)
            ;
        } catch (j) {
          T = !0, C = j;
        } finally {
          try {
            !v && k.return != null && k.return();
          } finally {
            if (T) throw C;
          }
        }
        return P;
      }
    }
    function m(_) {
      if (Array.isArray(_)) return _;
    }
    function D(_) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? D = function(P) {
        return typeof P;
      } : D = function(P) {
        return P && typeof Symbol == "function" && P.constructor === Symbol && P !== Symbol.prototype ? "symbol" : typeof P;
      }, D(_);
    }
    function O(_, S) {
      if (!(_ instanceof S))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(_, S) {
      for (var P = 0; P < S.length; P++) {
        var v = S[P];
        v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(_, v.key, v);
      }
    }
    function y(_, S, P) {
      return S && w(_.prototype, S), _;
    }
    function A(_) {
      return function() {
        var S = R(_), P;
        if (b()) {
          var v = R(this).constructor;
          P = Reflect.construct(S, arguments, v);
        } else
          P = S.apply(this, arguments);
        return I(this, P);
      };
    }
    function I(_, S) {
      return S && (D(S) === "object" || typeof S == "function") ? S : E(_);
    }
    function E(_) {
      if (_ === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return _;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function R(_) {
      return R = Object.setPrototypeOf ? Object.getPrototypeOf : function(P) {
        return P.__proto__ || Object.getPrototypeOf(P);
      }, R(_);
    }
    function L(_, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Super expression must either be null or a function");
      _.prototype = Object.create(S && S.prototype, { constructor: { value: _, writable: !0, configurable: !0 } }), S && $(_, S);
    }
    function $(_, S) {
      return $ = Object.setPrototypeOf || function(v, T) {
        return v.__proto__ = T, v;
      }, $(_, S);
    }
    function F(_, S, P) {
      return S in _ ? Object.defineProperty(_, S, { value: P, enumerable: !0, configurable: !0, writable: !0 }) : _[S] = P, _;
    }
    var H = {}, X = function(S) {
      return /* @__PURE__ */ t.default.createElement("input", S);
    }, K = function(S) {
      var P = S.containerProps, v = S.children;
      return /* @__PURE__ */ t.default.createElement("div", P, v);
    }, z = {
      container: "react-autowhatever__container",
      containerOpen: "react-autowhatever__container--open",
      input: "react-autowhatever__input",
      inputOpen: "react-autowhatever__input--open",
      inputFocused: "react-autowhatever__input--focused",
      itemsContainer: "react-autowhatever__items-container",
      itemsContainerOpen: "react-autowhatever__items-container--open",
      itemsList: "react-autowhatever__items-list",
      item: "react-autowhatever__item",
      itemFirst: "react-autowhatever__item--first",
      itemHighlighted: "react-autowhatever__item--highlighted",
      sectionContainer: "react-autowhatever__section-container",
      sectionContainerFirst: "react-autowhatever__section-container--first",
      sectionTitle: "react-autowhatever__section-title"
    }, M = /* @__PURE__ */ function(_) {
      L(P, _);
      var S = A(P);
      function P(v) {
        var T;
        return O(this, P), T = S.call(this, v), F(E(T), "storeInputReference", function(C) {
          C !== null && (T.input = C);
          var k = T.props.inputProps.ref;
          k && (typeof k == "function" ? k(C) : D(k) === "object" && Object.prototype.hasOwnProperty.call(k, "current") && (k.current = C));
        }), F(E(T), "storeItemsContainerReference", function(C) {
          C !== null && (T.itemsContainer = C);
        }), F(E(T), "onHighlightedItemChange", function(C) {
          T.highlightedItem = C;
        }), F(E(T), "getItemId", function(C, k) {
          if (k === null)
            return null;
          var B = T.props.id, j = C === null ? "" : "section-".concat(C);
          return "react-autowhatever-".concat(B, "-").concat(j, "-item-").concat(k);
        }), F(E(T), "onFocus", function(C) {
          var k = T.props.inputProps;
          T.setState({
            isInputFocused: !0
          }), k.onFocus && k.onFocus(C);
        }), F(E(T), "onBlur", function(C) {
          var k = T.props.inputProps;
          T.setState({
            isInputFocused: !1
          }), k.onBlur && k.onBlur(C);
        }), F(E(T), "onKeyDown", function(C) {
          var k = T.props, B = k.inputProps, j = k.highlightedSectionIndex, q = k.highlightedItemIndex, Y = C.keyCode;
          switch (Y) {
            case 40:
            // ArrowDown
            case 38: {
              var G = Y === 40 ? "next" : "prev", ee = T.sectionIterator[G]([j, q]), U = d(ee, 2), ce = U[0], Z = U[1];
              B.onKeyDown(C, {
                newHighlightedSectionIndex: ce,
                newHighlightedItemIndex: Z
              });
              break;
            }
            default:
              B.onKeyDown(C, {
                highlightedSectionIndex: j,
                highlightedItemIndex: q
              });
          }
        }), T.highlightedItem = null, T.state = {
          isInputFocused: !1
        }, T.setSectionsItems(v), T.setSectionIterator(v), T.setTheme(v), T;
      }
      return y(P, [{
        key: "componentDidMount",
        value: function() {
          this.ensureHighlightedItemIsVisible();
        }
        // eslint-disable-next-line camelcase, react/sort-comp
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function(T) {
          T.items !== this.props.items && this.setSectionsItems(T), (T.items !== this.props.items || T.multiSection !== this.props.multiSection) && this.setSectionIterator(T), T.theme !== this.props.theme && this.setTheme(T);
        }
      }, {
        key: "componentDidUpdate",
        value: function() {
          this.ensureHighlightedItemIsVisible();
        }
      }, {
        key: "setSectionsItems",
        value: function(T) {
          T.multiSection && (this.sectionsItems = T.items.map(function(C) {
            return T.getSectionItems(C);
          }), this.sectionsLengths = this.sectionsItems.map(function(C) {
            return C.length;
          }), this.allSectionsAreEmpty = this.sectionsLengths.every(function(C) {
            return C === 0;
          }));
        }
      }, {
        key: "setSectionIterator",
        value: function(T) {
          this.sectionIterator = (0, r.default)({
            multiSection: T.multiSection,
            data: T.multiSection ? this.sectionsLengths : T.items.length
          });
        }
      }, {
        key: "setTheme",
        value: function(T) {
          this.theme = (0, i.default)(T.theme);
        }
      }, {
        key: "renderSections",
        value: function() {
          var T = this;
          if (this.allSectionsAreEmpty)
            return null;
          var C = this.theme, k = this.props, B = k.id, j = k.items, q = k.renderItem, Y = k.renderItemData, G = k.renderSectionTitle, ee = k.highlightedSectionIndex, U = k.highlightedItemIndex, ce = k.itemProps;
          return j.map(function(Z, ve) {
            var rt = "react-autowhatever-".concat(B, "-"), Ke = "".concat(rt, "section-").concat(ve, "-"), je = ve === 0;
            return /* @__PURE__ */ t.default.createElement("div", C("".concat(Ke, "container"), "sectionContainer", je && "sectionContainerFirst"), /* @__PURE__ */ t.default.createElement(o.default, {
              section: Z,
              renderSectionTitle: G,
              theme: C,
              sectionKeyPrefix: Ke
            }), /* @__PURE__ */ t.default.createElement(s.default, {
              items: T.sectionsItems[ve],
              itemProps: ce,
              renderItem: q,
              renderItemData: Y,
              sectionIndex: ve,
              highlightedItemIndex: ee === ve ? U : null,
              onHighlightedItemChange: T.onHighlightedItemChange,
              getItemId: T.getItemId,
              theme: C,
              keyPrefix: rt,
              ref: T.storeItemsListReference
            }));
          });
        }
      }, {
        key: "renderItems",
        value: function() {
          var T = this.props.items;
          if (T.length === 0)
            return null;
          var C = this.theme, k = this.props, B = k.id, j = k.renderItem, q = k.renderItemData, Y = k.highlightedSectionIndex, G = k.highlightedItemIndex, ee = k.itemProps;
          return /* @__PURE__ */ t.default.createElement(s.default, {
            items: T,
            itemProps: ee,
            renderItem: j,
            renderItemData: q,
            highlightedItemIndex: Y === null ? G : null,
            onHighlightedItemChange: this.onHighlightedItemChange,
            getItemId: this.getItemId,
            theme: C,
            keyPrefix: "react-autowhatever-".concat(B, "-")
          });
        }
      }, {
        key: "ensureHighlightedItemIsVisible",
        value: function() {
          var T = this.highlightedItem;
          if (T) {
            var C = this.itemsContainer, k = T.offsetParent === C ? T.offsetTop : T.offsetTop - C.offsetTop, B = C.scrollTop;
            k < B ? B = k : k + T.offsetHeight > B + C.offsetHeight && (B = k + T.offsetHeight - C.offsetHeight), B !== C.scrollTop && (C.scrollTop = B);
          }
        }
      }, {
        key: "render",
        value: function() {
          var T = this.theme, C = this.props, k = C.id, B = C.multiSection, j = C.renderInputComponent, q = C.renderItemsContainer, Y = C.highlightedSectionIndex, G = C.highlightedItemIndex, ee = this.state.isInputFocused, U = B ? this.renderSections() : this.renderItems(), ce = U !== null, Z = this.getItemId(Y, G), ve = "react-autowhatever-".concat(k), rt = f({
            role: "combobox",
            "aria-haspopup": "listbox",
            "aria-owns": ve,
            "aria-expanded": ce
          }, T("react-autowhatever-".concat(k, "-container"), "container", ce && "containerOpen"), {}, this.props.containerProps), Ke = j(f({
            type: "text",
            value: "",
            autoComplete: "off",
            "aria-autocomplete": "list",
            "aria-controls": ve,
            "aria-activedescendant": Z
          }, T("react-autowhatever-".concat(k, "-input"), "input", ce && "inputOpen", ee && "inputFocused"), {}, this.props.inputProps, {
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
            ref: this.storeInputReference
          })), je = q({
            containerProps: f({
              id: ve,
              role: "listbox"
            }, T("react-autowhatever-".concat(k, "-items-container"), "itemsContainer", ce && "itemsContainerOpen"), {
              ref: this.storeItemsContainerReference
            }),
            children: U
          });
          return /* @__PURE__ */ t.default.createElement("div", rt, Ke, je);
        }
      }]), P;
    }(t.Component);
    e.default = M, F(M, "propTypes", {
      id: n.default.string,
      // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
      multiSection: n.default.bool,
      // Indicates whether a multi section layout should be rendered.
      renderInputComponent: n.default.func,
      // When specified, it is used to render the input element.
      renderItemsContainer: n.default.func,
      // Renders the items container.
      items: n.default.array.isRequired,
      // Array of items or sections to render.
      renderItem: n.default.func,
      // This function renders a single item.
      renderItemData: n.default.object,
      // Arbitrary data that will be passed to renderItem()
      renderSectionTitle: n.default.func,
      // This function gets a section and renders its title.
      getSectionItems: n.default.func,
      // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
      containerProps: n.default.object,
      // Arbitrary container props
      inputProps: n.default.object,
      // Arbitrary input props
      itemProps: n.default.oneOfType([
        // Arbitrary item props
        n.default.object,
        n.default.func
      ]),
      highlightedSectionIndex: n.default.number,
      // Section index of the highlighted item
      highlightedItemIndex: n.default.number,
      // Highlighted item index (within a section)
      theme: n.default.oneOfType([
        // Styles. See: https://github.com/markdalgleish/react-themeable
        n.default.object,
        n.default.array
      ])
    }), F(M, "defaultProps", {
      id: "1",
      multiSection: !1,
      renderInputComponent: X,
      renderItemsContainer: K,
      renderItem: function() {
        throw new Error("`renderItem` must be provided");
      },
      renderItemData: H,
      renderSectionTitle: function() {
        throw new Error("`renderSectionTitle` must be provided");
      },
      getSectionItems: function() {
        throw new Error("`getSectionItems` must be provided");
      },
      containerProps: H,
      inputProps: H,
      itemProps: H,
      highlightedSectionIndex: null,
      highlightedItemIndex: null,
      theme: z
    });
  }(si)), si;
}
var Ct = {}, Is;
function Ed() {
  if (Is) return Ct;
  Is = 1, Object.defineProperty(Ct, "__esModule", {
    value: !0
  }), Ct.mapToAutowhateverTheme = Ct.defaultTheme = void 0;
  var e = {
    container: "react-autosuggest__container",
    containerOpen: "react-autosuggest__container--open",
    input: "react-autosuggest__input",
    inputOpen: "react-autosuggest__input--open",
    inputFocused: "react-autosuggest__input--focused",
    suggestionsContainer: "react-autosuggest__suggestions-container",
    suggestionsContainerOpen: "react-autosuggest__suggestions-container--open",
    suggestionsList: "react-autosuggest__suggestions-list",
    suggestion: "react-autosuggest__suggestion",
    suggestionFirst: "react-autosuggest__suggestion--first",
    suggestionHighlighted: "react-autosuggest__suggestion--highlighted",
    sectionContainer: "react-autosuggest__section-container",
    sectionContainerFirst: "react-autosuggest__section-container--first",
    sectionTitle: "react-autosuggest__section-title"
  };
  Ct.defaultTheme = e;
  var t = function(r) {
    var i = {};
    for (var o in r)
      switch (o) {
        case "suggestionsContainer":
          i.itemsContainer = r[o];
          break;
        case "suggestionsContainerOpen":
          i.itemsContainerOpen = r[o];
          break;
        case "suggestion":
          i.item = r[o];
          break;
        case "suggestionFirst":
          i.itemFirst = r[o];
          break;
        case "suggestionHighlighted":
          i.itemHighlighted = r[o];
          break;
        case "suggestionsList":
          i.itemsList = r[o];
          break;
        default:
          i[o] = r[o];
      }
    return i;
  };
  return Ct.mapToAutowhateverTheme = t, Ct;
}
var Ms;
function Pd() {
  return Ms || (Ms = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var t = u(W), n = s(/* @__PURE__ */ ln()), r = s(gd()), i = s(xd()), o = Ed();
    function s(M) {
      return M && M.__esModule ? M : { default: M };
    }
    function a() {
      if (typeof WeakMap != "function") return null;
      var M = /* @__PURE__ */ new WeakMap();
      return a = function() {
        return M;
      }, M;
    }
    function u(M) {
      if (M && M.__esModule)
        return M;
      if (M === null || c(M) !== "object" && typeof M != "function")
        return { default: M };
      var _ = a();
      if (_ && _.has(M))
        return _.get(M);
      var S = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var v in M)
        if (Object.prototype.hasOwnProperty.call(M, v)) {
          var T = P ? Object.getOwnPropertyDescriptor(M, v) : null;
          T && (T.get || T.set) ? Object.defineProperty(S, v, T) : S[v] = M[v];
        }
      return S.default = M, _ && _.set(M, S), S;
    }
    function c(M) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? c = function(S) {
        return typeof S;
      } : c = function(S) {
        return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
      }, c(M);
    }
    function l(M, _) {
      var S = Object.keys(M);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(M);
        _ && (P = P.filter(function(v) {
          return Object.getOwnPropertyDescriptor(M, v).enumerable;
        })), S.push.apply(S, P);
      }
      return S;
    }
    function f(M) {
      for (var _ = 1; _ < arguments.length; _++) {
        var S = arguments[_] != null ? arguments[_] : {};
        _ % 2 ? l(Object(S), !0).forEach(function(P) {
          A(M, P, S[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(S)) : l(Object(S)).forEach(function(P) {
          Object.defineProperty(M, P, Object.getOwnPropertyDescriptor(S, P));
        });
      }
      return M;
    }
    function d(M, _) {
      if (!(M instanceof _))
        throw new TypeError("Cannot call a class as a function");
    }
    function h(M, _) {
      for (var S = 0; S < _.length; S++) {
        var P = _[S];
        P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(M, P.key, P);
      }
    }
    function g(M, _, S) {
      return _ && h(M.prototype, _), M;
    }
    function p(M) {
      return function() {
        var _ = O(M), S;
        if (D()) {
          var P = O(this).constructor;
          S = Reflect.construct(_, arguments, P);
        } else
          S = _.apply(this, arguments);
        return x(this, S);
      };
    }
    function x(M, _) {
      return _ && (c(_) === "object" || typeof _ == "function") ? _ : m(M);
    }
    function m(M) {
      if (M === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return M;
    }
    function D() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function O(M) {
      return O = Object.setPrototypeOf ? Object.getPrototypeOf : function(S) {
        return S.__proto__ || Object.getPrototypeOf(S);
      }, O(M);
    }
    function w(M, _) {
      if (typeof _ != "function" && _ !== null)
        throw new TypeError("Super expression must either be null or a function");
      M.prototype = Object.create(_ && _.prototype, { constructor: { value: M, writable: !0, configurable: !0 } }), _ && y(M, _);
    }
    function y(M, _) {
      return y = Object.setPrototypeOf || function(P, v) {
        return P.__proto__ = v, P;
      }, y(M, _);
    }
    function A(M, _, S) {
      return _ in M ? Object.defineProperty(M, _, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : M[_] = S, M;
    }
    var I = function() {
      return !0;
    }, E = function(_) {
      return _.trim().length > 0;
    }, b = function(_) {
      var S = _.containerProps, P = _.children;
      return /* @__PURE__ */ t.default.createElement("div", S, P);
    }, R = "suggestions-revealed", L = "suggestions-updated", $ = "suggestion-selected", F = "input-focused", H = "input-changed", X = "input-blurred", K = "escape-pressed", z = /* @__PURE__ */ function(M) {
      w(S, M);
      var _ = p(S);
      function S(P) {
        var v, T = P.alwaysRenderSuggestions;
        return d(this, S), v = _.call(this), A(m(v), "onDocumentMouseDown", function(C) {
          v.justClickedOnSuggestionsContainer = !1;
          for (var k = C.detail && C.detail.target || // This is for testing only. Please show me a better way to emulate this.
          C.target; k !== null && k !== document; ) {
            if (k.getAttribute && k.getAttribute("data-suggestion-index") !== null)
              return;
            if (k === v.suggestionsContainer) {
              v.justClickedOnSuggestionsContainer = !0;
              return;
            }
            k = k.parentNode;
          }
        }), A(m(v), "storeAutowhateverRef", function(C) {
          C !== null && (v.autowhatever = C);
        }), A(m(v), "onSuggestionMouseEnter", function(C, k) {
          var B = k.sectionIndex, j = k.itemIndex;
          v.updateHighlightedSuggestion(B, j), C.target === v.pressedSuggestion && (v.justSelectedSuggestion = !0), v.justMouseEntered = !0, setTimeout(function() {
            v.justMouseEntered = !1;
          });
        }), A(m(v), "highlightFirstSuggestion", function() {
          v.updateHighlightedSuggestion(v.props.multiSection ? 0 : null, 0);
        }), A(m(v), "onDocumentMouseUp", function() {
          v.pressedSuggestion && !v.justSelectedSuggestion && v.input.focus(), v.pressedSuggestion = null;
        }), A(m(v), "onSuggestionMouseDown", function(C) {
          v.justSelectedSuggestion || (v.justSelectedSuggestion = !0, v.pressedSuggestion = C.target);
        }), A(m(v), "onSuggestionsClearRequested", function() {
          var C = v.props.onSuggestionsClearRequested;
          C && C();
        }), A(m(v), "onSuggestionSelected", function(C, k) {
          var B = v.props, j = B.alwaysRenderSuggestions, q = B.onSuggestionSelected, Y = B.onSuggestionsFetchRequested;
          q && q(C, k);
          var G = v.props.shouldKeepSuggestionsOnSelect(k.suggestion);
          j || G ? Y({
            value: k.suggestionValue,
            reason: $
          }) : v.onSuggestionsClearRequested(), v.resetHighlightedSuggestion();
        }), A(m(v), "onSuggestionClick", function(C) {
          var k = v.props, B = k.alwaysRenderSuggestions, j = k.focusInputOnSuggestionClick, q = v.getSuggestionIndices(v.findSuggestionElement(C.target)), Y = q.sectionIndex, G = q.suggestionIndex, ee = v.getSuggestion(Y, G), U = v.props.getSuggestionValue(ee);
          v.maybeCallOnChange(C, U, "click"), v.onSuggestionSelected(C, {
            suggestion: ee,
            suggestionValue: U,
            suggestionIndex: G,
            sectionIndex: Y,
            method: "click"
          });
          var ce = v.props.shouldKeepSuggestionsOnSelect(ee);
          B || ce || v.closeSuggestions(), j === !0 ? v.input.focus() : v.onBlur(), setTimeout(function() {
            v.justSelectedSuggestion = !1;
          });
        }), A(m(v), "onBlur", function() {
          var C = v.props, k = C.inputProps, B = C.shouldRenderSuggestions, j = k.value, q = k.onBlur, Y = v.getHighlightedSuggestion(), G = B(j, X);
          v.setState({
            isFocused: !1,
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null,
            valueBeforeUpDown: null,
            isCollapsed: !G
          }), q && q(v.blurEvent, {
            highlightedSuggestion: Y
          });
        }), A(m(v), "onSuggestionMouseLeave", function(C) {
          v.resetHighlightedSuggestion(!1), v.justSelectedSuggestion && C.target === v.pressedSuggestion && (v.justSelectedSuggestion = !1);
        }), A(m(v), "onSuggestionTouchStart", function() {
          v.justSelectedSuggestion = !0;
        }), A(m(v), "onSuggestionTouchMove", function() {
          v.justSelectedSuggestion = !1, v.pressedSuggestion = null, v.input.focus();
        }), A(m(v), "itemProps", function(C) {
          var k = C.sectionIndex, B = C.itemIndex;
          return {
            "data-section-index": k,
            "data-suggestion-index": B,
            onMouseEnter: v.onSuggestionMouseEnter,
            onMouseLeave: v.onSuggestionMouseLeave,
            onMouseDown: v.onSuggestionMouseDown,
            onTouchStart: v.onSuggestionTouchStart,
            onTouchMove: v.onSuggestionTouchMove,
            onClick: v.onSuggestionClick
          };
        }), A(m(v), "renderSuggestionsContainer", function(C) {
          var k = C.containerProps, B = C.children, j = v.props.renderSuggestionsContainer;
          return j({
            containerProps: k,
            children: B,
            query: v.getQuery()
          });
        }), v.state = {
          isFocused: !1,
          isCollapsed: !T,
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: null
        }, v.justPressedUpDown = !1, v.justMouseEntered = !1, v.pressedSuggestion = null, v;
      }
      return g(S, [{
        key: "componentDidMount",
        value: function() {
          document.addEventListener("mousedown", this.onDocumentMouseDown), document.addEventListener("mouseup", this.onDocumentMouseUp), this.input = this.autowhatever.input, this.suggestionsContainer = this.autowhatever.itemsContainer;
        }
        // eslint-disable-next-line camelcase, react/sort-comp
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function(v) {
          var T = this.state.highlightedSuggestionIndex === 0 && this.props.highlightFirstSuggestion && !v.highlightFirstSuggestion;
          (0, r.default)(v.suggestions, this.props.suggestions) ? v.highlightFirstSuggestion && v.suggestions.length > 0 && this.justPressedUpDown === !1 && this.justMouseEntered === !1 ? this.highlightFirstSuggestion() : T && this.resetHighlightedSuggestion() : this.willRenderSuggestions(v, L) ? (this.state.isCollapsed && !this.justSelectedSuggestion && this.revealSuggestions(), T && this.resetHighlightedSuggestion()) : this.resetHighlightedSuggestion();
        }
      }, {
        key: "componentDidUpdate",
        value: function(v, T) {
          var C = this.props, k = C.suggestions, B = C.onSuggestionHighlighted, j = C.highlightFirstSuggestion;
          if (!(0, r.default)(k, v.suggestions) && k.length > 0 && j) {
            this.highlightFirstSuggestion();
            return;
          }
          if (B) {
            var q = this.getHighlightedSuggestion(), Y = T.highlightedSuggestion;
            q != Y && B({
              suggestion: q
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          document.removeEventListener("mousedown", this.onDocumentMouseDown), document.removeEventListener("mouseup", this.onDocumentMouseUp);
        }
      }, {
        key: "updateHighlightedSuggestion",
        value: function(v, T, C) {
          var k = this;
          this.setState(function(B) {
            var j = B.valueBeforeUpDown;
            return T === null ? j = null : j === null && typeof C < "u" && (j = C), {
              highlightedSectionIndex: v,
              highlightedSuggestionIndex: T,
              highlightedSuggestion: T === null ? null : k.getSuggestion(v, T),
              valueBeforeUpDown: j
            };
          });
        }
      }, {
        key: "resetHighlightedSuggestion",
        value: function() {
          var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          this.setState(function(T) {
            var C = T.valueBeforeUpDown;
            return {
              highlightedSectionIndex: null,
              highlightedSuggestionIndex: null,
              highlightedSuggestion: null,
              valueBeforeUpDown: v ? null : C
            };
          });
        }
      }, {
        key: "revealSuggestions",
        value: function() {
          this.setState({
            isCollapsed: !1
          });
        }
      }, {
        key: "closeSuggestions",
        value: function() {
          this.setState({
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null,
            valueBeforeUpDown: null,
            isCollapsed: !0
          });
        }
      }, {
        key: "getSuggestion",
        value: function(v, T) {
          var C = this.props, k = C.suggestions, B = C.multiSection, j = C.getSectionSuggestions;
          return B ? j(k[v])[T] : k[T];
        }
      }, {
        key: "getHighlightedSuggestion",
        value: function() {
          var v = this.state, T = v.highlightedSectionIndex, C = v.highlightedSuggestionIndex;
          return C === null ? null : this.getSuggestion(T, C);
        }
      }, {
        key: "getSuggestionValueByIndex",
        value: function(v, T) {
          var C = this.props.getSuggestionValue;
          return C(this.getSuggestion(v, T));
        }
      }, {
        key: "getSuggestionIndices",
        value: function(v) {
          var T = v.getAttribute("data-section-index"), C = v.getAttribute("data-suggestion-index");
          return {
            sectionIndex: typeof T == "string" ? parseInt(T, 10) : null,
            suggestionIndex: parseInt(C, 10)
          };
        }
      }, {
        key: "findSuggestionElement",
        value: function(v) {
          var T = v;
          do {
            if (T.getAttribute && T.getAttribute("data-suggestion-index") !== null)
              return T;
            T = T.parentNode;
          } while (T !== null);
          throw console.error("Clicked element:", v), new Error("Couldn't find suggestion element");
        }
      }, {
        key: "maybeCallOnChange",
        value: function(v, T, C) {
          var k = this.props.inputProps, B = k.value, j = k.onChange;
          T !== B && j(v, {
            newValue: T,
            method: C
          });
        }
      }, {
        key: "willRenderSuggestions",
        value: function(v, T) {
          var C = v.suggestions, k = v.inputProps, B = v.shouldRenderSuggestions, j = k.value;
          return C.length > 0 && B(j, T);
        }
      }, {
        key: "getQuery",
        value: function() {
          var v = this.props.inputProps, T = v.value, C = this.state.valueBeforeUpDown;
          return (C === null ? T : C).trim();
        }
      }, {
        key: "render",
        value: function() {
          var v = this, T = this.props, C = T.suggestions, k = T.renderInputComponent, B = T.onSuggestionsFetchRequested, j = T.renderSuggestion, q = T.inputProps, Y = T.multiSection, G = T.renderSectionTitle, ee = T.id, U = T.getSectionSuggestions, ce = T.theme, Z = T.getSuggestionValue, ve = T.alwaysRenderSuggestions, rt = T.highlightFirstSuggestion, Ke = T.containerProps, je = this.state, Yr = je.isFocused, it = je.isCollapsed, pn = je.highlightedSectionIndex, Gn = je.highlightedSuggestionIndex, Ye = je.valueBeforeUpDown, jt = ve ? I : this.props.shouldRenderSuggestions, ot = q.value, Xn = q.onFocus, Zn = q.onKeyDown, Wt = this.willRenderSuggestions(this.props, "render"), Ut = ve || Yr && !it && Wt, Qn = Ut ? C : [], Gr = f({}, q, {
            onFocus: function(ge) {
              if (!v.justSelectedSuggestion && !v.justClickedOnSuggestionsContainer) {
                var We = jt(ot, F);
                v.setState({
                  isFocused: !0,
                  isCollapsed: !We
                }), Xn && Xn(ge), We && B({
                  value: ot,
                  reason: F
                });
              }
            },
            onBlur: function(ge) {
              if (v.justClickedOnSuggestionsContainer) {
                v.input.focus();
                return;
              }
              v.blurEvent = ge, v.justSelectedSuggestion || (v.onBlur(), v.onSuggestionsClearRequested());
            },
            onChange: function(ge) {
              var We = ge.target.value, Pt = jt(We, H);
              v.maybeCallOnChange(ge, We, "type"), v.suggestionsContainer && (v.suggestionsContainer.scrollTop = 0), v.setState(f({}, rt ? {} : {
                highlightedSectionIndex: null,
                highlightedSuggestionIndex: null,
                highlightedSuggestion: null
              }, {
                valueBeforeUpDown: null,
                isCollapsed: !Pt
              })), Pt ? B({
                value: We,
                reason: H
              }) : v.onSuggestionsClearRequested();
            },
            onKeyDown: function(ge, We) {
              var Pt = ge.keyCode;
              switch (Pt) {
                case 40:
                // ArrowDown
                case 38:
                  if (it)
                    jt(ot, R) && (B({
                      value: ot,
                      reason: R
                    }), v.revealSuggestions(), ge.preventDefault());
                  else if (C.length > 0) {
                    var Jn = We.newHighlightedSectionIndex, mn = We.newHighlightedItemIndex, Q;
                    mn === null ? Q = Ye === null ? ot : Ye : Q = v.getSuggestionValueByIndex(Jn, mn), v.updateHighlightedSuggestion(Jn, mn, ot), v.maybeCallOnChange(ge, Q, Pt === 40 ? "down" : "up"), ge.preventDefault();
                  }
                  v.justPressedUpDown = !0, setTimeout(function() {
                    v.justPressedUpDown = !1;
                  });
                  break;
                // Enter
                case 13: {
                  if (ge.keyCode === 229)
                    break;
                  var ie = v.getHighlightedSuggestion();
                  if (Ut && !ve && v.closeSuggestions(), ie != null) {
                    ge.preventDefault();
                    var ae = Z(ie);
                    v.maybeCallOnChange(ge, ae, "enter"), v.onSuggestionSelected(ge, {
                      suggestion: ie,
                      suggestionValue: ae,
                      suggestionIndex: Gn,
                      sectionIndex: pn,
                      method: "enter"
                    }), v.justSelectedSuggestion = !0, setTimeout(function() {
                      v.justSelectedSuggestion = !1;
                    });
                  }
                  break;
                }
                // Escape
                case 27: {
                  Ut && ge.preventDefault();
                  var re = Ut && !ve;
                  if (Ye === null) {
                    if (!re) {
                      var le = "";
                      v.maybeCallOnChange(ge, le, "escape"), jt(le, K) ? B({
                        value: le,
                        reason: K
                      }) : v.onSuggestionsClearRequested();
                    }
                  } else
                    v.maybeCallOnChange(ge, Ye, "escape");
                  re ? (v.onSuggestionsClearRequested(), v.closeSuggestions()) : v.resetHighlightedSuggestion();
                  break;
                }
              }
              Zn && Zn(ge);
            }
          }), Et = {
            query: this.getQuery()
          };
          return /* @__PURE__ */ t.default.createElement(i.default, {
            multiSection: Y,
            items: Qn,
            renderInputComponent: k,
            renderItemsContainer: this.renderSuggestionsContainer,
            renderItem: j,
            renderItemData: Et,
            renderSectionTitle: G,
            getSectionItems: U,
            highlightedSectionIndex: pn,
            highlightedItemIndex: Gn,
            containerProps: Ke,
            inputProps: Gr,
            itemProps: this.itemProps,
            theme: (0, o.mapToAutowhateverTheme)(ce),
            id: ee,
            ref: this.storeAutowhateverRef
          });
        }
      }]), S;
    }(t.Component);
    e.default = z, A(z, "propTypes", {
      suggestions: n.default.array.isRequired,
      onSuggestionsFetchRequested: function(_, S) {
        var P = _[S];
        if (typeof P != "function")
          throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
      },
      onSuggestionsClearRequested: function(_, S) {
        var P = _[S];
        if (_.alwaysRenderSuggestions === !1 && typeof P != "function")
          throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
      },
      shouldKeepSuggestionsOnSelect: n.default.func,
      onSuggestionSelected: n.default.func,
      onSuggestionHighlighted: n.default.func,
      renderInputComponent: n.default.func,
      renderSuggestionsContainer: n.default.func,
      getSuggestionValue: n.default.func.isRequired,
      renderSuggestion: n.default.func.isRequired,
      inputProps: function(_, S) {
        var P = _[S];
        if (!P)
          throw new Error("'inputProps' must be passed.");
        if (!Object.prototype.hasOwnProperty.call(P, "value"))
          throw new Error("'inputProps' must have 'value'.");
        if (!Object.prototype.hasOwnProperty.call(P, "onChange"))
          throw new Error("'inputProps' must have 'onChange'.");
      },
      shouldRenderSuggestions: n.default.func,
      alwaysRenderSuggestions: n.default.bool,
      multiSection: n.default.bool,
      renderSectionTitle: function(_, S) {
        var P = _[S];
        if (_.multiSection === !0 && typeof P != "function")
          throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
      },
      getSectionSuggestions: function(_, S) {
        var P = _[S];
        if (_.multiSection === !0 && typeof P != "function")
          throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
      },
      focusInputOnSuggestionClick: n.default.bool,
      highlightFirstSuggestion: n.default.bool,
      theme: n.default.object,
      id: n.default.string,
      containerProps: n.default.object
      // Arbitrary container props
    }), A(z, "defaultProps", {
      renderSuggestionsContainer: b,
      shouldRenderSuggestions: E,
      alwaysRenderSuggestions: !1,
      multiSection: !1,
      shouldKeepSuggestionsOnSelect: function() {
        return !1;
      },
      focusInputOnSuggestionClick: !0,
      highlightFirstSuggestion: !1,
      theme: o.defaultTheme,
      id: "1",
      containerProps: {}
    });
  }(Qr)), Qr;
}
var hi, ks;
function _d() {
  return ks || (ks = 1, hi = Pd().default), hi;
}
var Cd = _d();
const Rd = /* @__PURE__ */ So(Cd), Od = (e) => {
  let t = !1;
  return {
    promise: new Promise((r, i) => {
      e.then((o) => !t && r(o)), e.catch((o) => !t && i(o));
    }),
    cancel: () => {
      t = !0;
    }
  };
}, Dd = "_menu_b5dub_1", Ad = "_container_b5dub_33", Rt = {
  menu: Dd,
  "menu-item": "_menu-item_b5dub_26",
  container: Ad,
  "menu-highlighted": "_menu-highlighted_b5dub_48",
  "menu-empty": "_menu-empty_b5dub_53"
}, Id = 1500, Md = ({ query: e, text: t }) => {
  const n = t.toLowerCase().indexOf(e.toLowerCase());
  return n === -1 ? /* @__PURE__ */ N(Le, { children: t }) : /* @__PURE__ */ ne(Le, { children: [
    /* @__PURE__ */ N("span", { children: t.substring(0, n) }),
    /* @__PURE__ */ N("b", { children: t.substring(n, n + e.length) }),
    /* @__PURE__ */ N("span", { children: t.substring(n + e.length) })
  ] });
}, Ls = [], kd = (e, t) => {
  const {
    className: n,
    name: r,
    children: i,
    debounceInterval: o,
    getSuggestionValue: s = (H) => typeof H.text == "string" ? H.text : "",
    onChange: a,
    defaultSuggestions: u = [],
    inputProps: c,
    clearPreviousSuggestions: l = !0,
    emptyStateElement: f,
    containerClassName: d,
    ...h
  } = e, g = e.value || "", [p, x] = we([]), [m, D] = we(), [O, w] = we(!1), y = () => {
    const H = setTimeout(() => {
      w(!0);
    }, Id);
    Ls.push(H);
  }, A = ({
    containerProps: H,
    children: X
  }) => /* @__PURE__ */ ne(Le, { children: [
    /* @__PURE__ */ N(
      "div",
      {
        ...H,
        className: X ? Rt.menu : `${Rt.menu} ${Rt["menu-empty"]}`,
        children: /* @__PURE__ */ N(Le, { children: X })
      }
    ),
    g && O && f
  ] }), I = fe({}), b = Bf(({ value: H }) => {
    if (m == null || m.cancel(), w(!1), Ls.forEach((M) => clearTimeout(M)), H.length === 0) return;
    const X = I.current[H];
    if (X) {
      X.then((M) => {
        M.length < 1 && y(), x(M);
      });
      return;
    }
    const K = Od(e.fetchItems(H));
    D(K);
    const z = K.promise;
    z.then((M) => {
      M.length < 1 && y(), x(M);
    }), I.current[H] = z;
  }, o || 350), R = () => {
    m == null || m.cancel(), l && x([]);
  }, L = (H, X) => {
    if (X.method === "enter" && H.preventDefault(), typeof e.onSuggestionSelected == "function")
      return e.onSuggestionSelected(H, X);
    const K = {
      ...H.target,
      name: r || "",
      value: X.suggestionValue
    };
    a({ ...H, target: K });
  }, $ = () => {
  }, F = (H, X) => /* @__PURE__ */ N(
    "div",
    {
      className: X.isHighlighted ? Rt["menu-item"] : `${Rt["menu-item"]} ${Rt["menu-highlighted"]}`,
      children: e.highlightedQuery ? /* @__PURE__ */ N(Md, { query: X.query, text: s(H) }) : s(H)
    }
  );
  return /* @__PURE__ */ N("div", { className: `${!!d && d} ${Rt.container}`, children: /* @__PURE__ */ N(
    Rd,
    {
      ref: t,
      renderSuggestionsContainer: A,
      renderSuggestion: F,
      ...h,
      suggestions: g.length === 0 ? u : p,
      onSuggestionsFetchRequested: b,
      onSuggestionsClearRequested: R,
      renderInputComponent: i,
      inputProps: {
        name: r,
        value: g,
        // @ts-ignore "react-autosuggest" uses FormEvent instead of ChangeEvent for some reason
        onChange: a,
        onBlur: $,
        ...c
      },
      getSuggestionValue: s,
      onSuggestionSelected: L
    }
  ) });
}, Ld = lt(kd), Nd = "_overlay_ckym2_1", Vd = "_visible_ckym2_19", Fd = "_content_ckym2_23", gn = {
  overlay: Nd,
  visible: Vd,
  content: Fd,
  "full-screen": "_full-screen_ckym2_41"
}, $d = ({ onPress: e, children: t }) => (Fu(e), t || null), Hw = ({
  children: e,
  onClick: t,
  onClose: n,
  overlayFadeDuration: r = 0,
  contentSlideDuration: i = 100,
  fullScreen: o = !1,
  backgroundOpacity: s = 0.8,
  background: a
}) => {
  const [u, c] = we(!1), l = fe(null), f = fe(null);
  Ce(() => (d(), l.current && Mt.disableBodyScroll(l.current), () => {
    var p;
    (p = Mt.clearAllBodyScrollLocks) == null || p.call(Mt), l.current && Mt.enableBodyScroll(l.current);
  }), []);
  const d = () => {
    l.current && ji(l.current), c(!0);
  }, h = (p) => {
    if (!t) return;
    const x = l.current, m = f.current;
    (x === p.target || m === p.target) && t(p);
  }, g = n || t;
  return /* @__PURE__ */ ne(
    "div",
    {
      className: _e(gn.overlay, u ? gn.visible : ""),
      onClick: h,
      ref: l,
      style: {
        background: a || `rgba(15, 20, 31, ${s})`,
        opacity: u ? 1 : 0,
        transition: `opacity ${r}ms ease-out`
      },
      children: [
        g && /* @__PURE__ */ N($d, { onPress: g }),
        /* @__PURE__ */ N(
          "div",
          {
            className: _e(
              gn.content,
              u ? gn.visible : "",
              o ? gn["full-screen"] : ""
            ),
            ref: f,
            style: {
              transition: `opacity ${i}ms ease-out, transform ${i}ms ease-out`,
              transform: u ? "none" : "translateY(-100px)",
              opacity: u ? 1 : 0
            },
            children: e
          }
        )
      ]
    }
  );
};
function Bd(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function Wi(e, t) {
  return Wi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Wi(e, t);
}
function jd(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Wi(e, t);
}
var Wd = /* @__PURE__ */ ln();
const te = /* @__PURE__ */ So(Wd), Ns = {
  disabled: !1
};
var Ud = process.env.NODE_ENV !== "production" ? te.oneOfType([te.number, te.shape({
  enter: te.number,
  exit: te.number,
  appear: te.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && te.oneOfType([te.string, te.shape({
  enter: te.string,
  exit: te.string,
  active: te.string
}), te.shape({
  enter: te.string,
  enterDone: te.string,
  enterActive: te.string,
  exit: te.string,
  exitDone: te.string,
  exitActive: te.string
})]);
const ju = W.createContext(null);
var Hd = function(t) {
  return t.scrollTop;
}, wn = "unmounted", Dt = "exited", At = "entering", Xt = "entered", Ui = "exiting", nt = /* @__PURE__ */ function(e) {
  jd(t, e);
  function t(r, i) {
    var o;
    o = e.call(this, r, i) || this;
    var s = i, a = s && !s.isMounting ? r.enter : r.appear, u;
    return o.appearStatus = null, r.in ? a ? (u = Dt, o.appearStatus = At) : u = Xt : r.unmountOnExit || r.mountOnEnter ? u = wn : u = Dt, o.state = {
      status: u
    }, o.nextCallback = null, o;
  }
  t.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === wn ? {
      status: Dt
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== At && s !== Xt && (o = At) : (s === At || s === Xt) && (o = Ui);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, o, s, a;
    return o = s = a = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, a = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: a
    };
  }, n.updateStatus = function(i, o) {
    if (i === void 0 && (i = !1), o !== null)
      if (this.cancelNextCallback(), o === At) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Zt.findDOMNode(this);
          s && Hd(s);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Dt && this.setState({
      status: wn
    });
  }, n.performEnter = function(i) {
    var o = this, s = this.props.enter, a = this.context ? this.context.isMounting : i, u = this.props.nodeRef ? [a] : [Zt.findDOMNode(this), a], c = u[0], l = u[1], f = this.getTimeouts(), d = a ? f.appear : f.enter;
    if (!i && !s || Ns.disabled) {
      this.safeSetState({
        status: Xt
      }, function() {
        o.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, l), this.safeSetState({
      status: At
    }, function() {
      o.props.onEntering(c, l), o.onTransitionEnd(d, function() {
        o.safeSetState({
          status: Xt
        }, function() {
          o.props.onEntered(c, l);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : Zt.findDOMNode(this);
    if (!o || Ns.disabled) {
      this.safeSetState({
        status: Dt
      }, function() {
        i.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: Ui
    }, function() {
      i.props.onExiting(a), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: Dt
        }, function() {
          i.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, n.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, o.nextCallback = null, i(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Zt.findDOMNode(this), a = i == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], c = u[0], l = u[1];
      this.props.addEndListener(c, l);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === wn)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var a = Bd(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ W.createElement(ju.Provider, {
        value: null
      }, typeof s == "function" ? s(i, a) : W.cloneElement(W.Children.only(s), a))
    );
  }, t;
}(W.Component);
nt.contextType = ju;
nt.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: te.shape({
    current: typeof Element > "u" ? te.any : function(e, t, n, r, i, o) {
      var s = e[t];
      return te.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: te.oneOfType([te.func.isRequired, te.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: te.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: te.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: te.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: te.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: te.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: te.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = Ud;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: te.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: te.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: te.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: te.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: te.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: te.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: te.func
} : {};
function qt() {
}
nt.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: qt,
  onEntering: qt,
  onEntered: qt,
  onExit: qt,
  onExiting: qt,
  onExited: qt
};
nt.UNMOUNTED = wn;
nt.EXITED = Dt;
nt.ENTERING = At;
nt.ENTERED = Xt;
nt.EXITING = Ui;
const pi = {
  "field-note": "_field-note_hb0hy_1",
  "state-entering": "_state-entering_hb0hy_21",
  "state-entered": "_state-entered_hb0hy_25",
  "state-exiting": "_state-exiting_hb0hy_29",
  "state-exited": "_state-exited_hb0hy_30",
  "variant-error": "_variant-error_hb0hy_33"
}, qd = ({ error: e, warning: t, description: n }) => {
  const r = fe(null), i = e || t || n, o = e ? "error" : "default", s = Ne(() => i ? typeof i == "string" ? { dangerouslySetInnerHTML: { __html: i } } : { children: i } : {}, [i]);
  return /* @__PURE__ */ N(nt, { in: !!i, nodeRef: r, timeout: 200, mountOnEnter: !0, unmountOnExit: !0, children: (a) => /* @__PURE__ */ N(
    "div",
    {
      ...s,
      ref: r,
      className: _e(
        pi["field-note"],
        mo.Caption,
        pi[`variant-${o}`],
        pi[`state-${a}`]
      )
    }
  ) });
}, zd = "_error_oz8is_15", Kd = "_left_oz8is_64", Yd = "_right_oz8is_68", Gd = "_white_oz8is_72", Xd = "_warning_oz8is_112", Zd = "_entering_oz8is_116", Qd = "_entered_oz8is_117", Jd = "_exiting_oz8is_122", eh = "_exited_oz8is_127", Ee = {
  "text-field-label-container": "_text-field-label-container_oz8is_1",
  "text-field-label": "_text-field-label_oz8is_1",
  error: zd,
  "text-field-required": "_text-field-required_oz8is_19",
  "text-field-hint": "_text-field-hint_oz8is_23",
  "text-field-input-wrapper": "_text-field-input-wrapper_oz8is_27",
  "text-field-input": "_text-field-input_oz8is_27",
  left: Kd,
  right: Yd,
  white: Gd,
  "text-field-icon": "_text-field-icon_oz8is_76",
  "text-field-bar": "_text-field-bar_oz8is_96",
  warning: Xd,
  entering: Zd,
  entered: Qd,
  exiting: Jd,
  exited: eh,
  "label-content": "_label-content_oz8is_132"
}, th = ({
  className: e,
  active: t,
  label: n,
  hint: r,
  tagName: i,
  inputTheme: o = "default",
  inputIcon: s = null,
  inputIconPosition: a = "left",
  error: u,
  errorNoMsg: c = !1,
  warning: l,
  description: f,
  onFocus: d = () => {
  },
  onBlur: h = () => {
  },
  required: g,
  badge: p,
  ...x
}, m) => {
  const [D, O] = we(!1), w = fe(null), y = !!u || c, A = !!l, I = D || t || y || A;
  Au(m, () => w.current);
  const E = ke(
    (R) => {
      d(R), O(!0);
    },
    [d]
  ), b = ke(
    (R) => {
      h(R), O(!1);
    },
    [h]
  );
  return Ce(() => {
    var R;
    !D && w.current === document.activeElement && ((R = w.current) == null || R.focus());
  }, [D]), /* @__PURE__ */ ne("div", { className: e, children: [
    n && /* @__PURE__ */ ne("div", { className: Ee["text-field-label-container"], children: [
      /* @__PURE__ */ N(
        "label",
        {
          className: _e(
            Ee["text-field-label"],
            mo.Caption,
            y ? Ee.error : ""
          ),
          children: /* @__PURE__ */ ne("span", { style: { alignItems: "center" }, children: [
            /* @__PURE__ */ N("div", { className: Ee["label-content"], children: n }),
            g && /* @__PURE__ */ N("span", { className: Ee["text-field-required"], children: " *" }),
            r && !p && /* @__PURE__ */ N(Mf, { position: "top", className: Ee["text-field-hint"], children: r })
          ] })
        }
      ),
      p
    ] }),
    /* @__PURE__ */ ne("div", { className: Ee["text-field-input-wrapper"], children: [
      /* @__PURE__ */ N(
        "input",
        {
          ...x,
          as: i ?? "input",
          ref: w,
          onFocus: E,
          onBlur: b,
          className: _e(
            Ee["text-field-input"],
            Ee[o],
            s === null ? void 0 : Ee[a]
          )
        }
      ),
      s && /* @__PURE__ */ N("span", { className: _e(Ee["text-field-icon"], Ee[a]), children: s }),
      /* @__PURE__ */ N(nt, { nodeRef: w, in: I, timeout: 100, children: (R) => /* @__PURE__ */ N(
        "div",
        {
          className: _e(
            Ee["text-field-bar"],
            y ? Ee.error : A ? Ee.warning : "",
            Ee[R]
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ N(qd, { error: u, warning: l, description: f })
  ] });
}, qw = lt(th), To = Tt({});
function jn(e) {
  const t = fe(null);
  return t.current === null && (t.current = e()), t.current;
}
const xo = typeof window < "u", Eo = xo ? cn : Ce, Nr = /* @__PURE__ */ Tt(null), Vr = Tt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
class nh extends V.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = n.offsetParent, i = r instanceof HTMLElement && r.offsetWidth || 0, o = this.props.sizeRef.current;
      o.height = n.offsetHeight || 0, o.width = n.offsetWidth || 0, o.top = n.offsetTop, o.left = n.offsetLeft, o.right = i - o.width - o.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function rh({ children: e, isPresent: t, anchorX: n }) {
  const r = go(), i = fe(null), o = fe({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: s } = be(Vr);
  return Iu(() => {
    const { width: a, height: u, top: c, left: l, right: f } = o.current;
    if (t || !i.current || !a || !u)
      return;
    const d = n === "left" ? `left: ${l}` : `right: ${f}`;
    i.current.dataset.motionPopId = r;
    const h = document.createElement("style");
    return s && (h.nonce = s), document.head.appendChild(h), h.sheet && h.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${u}px !important;
            ${d}px !important;
            top: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(h);
    };
  }, [t]), N(nh, { isPresent: t, childRef: i, sizeRef: o, children: V.cloneElement(e, { ref: i }) });
}
const ih = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: s, anchorX: a }) => {
  const u = jn(oh), c = go(), l = ke((d) => {
    u.set(d, !0);
    for (const h of u.values())
      if (!h)
        return;
    r && r();
  }, [u, r]), f = Ne(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: i,
      onExitComplete: l,
      register: (d) => (u.set(d, !1), () => u.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    o ? [Math.random(), l] : [n, l]
  );
  return Ne(() => {
    u.forEach((d, h) => u.set(h, !1));
  }, [n]), V.useEffect(() => {
    !n && !u.size && r && r();
  }, [n]), s === "popLayout" && (e = N(rh, { isPresent: n, anchorX: a, children: e })), N(Nr.Provider, { value: f, children: e });
};
function oh() {
  return /* @__PURE__ */ new Map();
}
function Wu(e = !0) {
  const t = be(Nr);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, o = go();
  Ce(() => {
    if (e)
      return i(o);
  }, [e]);
  const s = ke(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, s] : [!0];
}
const sr = (e) => e.key || "";
function Vs(e) {
  const t = [];
  return Mu.forEach(e, (n) => {
    Lf(n) && t.push(n);
  }), t;
}
const Uu = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: o = "sync", propagate: s = !1, anchorX: a = "left" }) => {
  const [u, c] = Wu(s), l = Ne(() => Vs(e), [e]), f = s && !u ? [] : l.map(sr), d = fe(!0), h = fe(l), g = jn(() => /* @__PURE__ */ new Map()), [p, x] = we(l), [m, D] = we(l);
  Eo(() => {
    d.current = !1, h.current = l;
    for (let y = 0; y < m.length; y++) {
      const A = sr(m[y]);
      f.includes(A) ? g.delete(A) : g.get(A) !== !0 && g.set(A, !1);
    }
  }, [m, f.length, f.join("-")]);
  const O = [];
  if (l !== p) {
    let y = [...l];
    for (let A = 0; A < m.length; A++) {
      const I = m[A], E = sr(I);
      f.includes(E) || (y.splice(A, 0, I), O.push(I));
    }
    return o === "wait" && O.length && (y = O), D(Vs(y)), x(l), null;
  }
  process.env.NODE_ENV !== "production" && o === "wait" && m.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: w } = be(To);
  return N(Le, { children: m.map((y) => {
    const A = sr(y), I = s && !u ? !1 : l === m || f.includes(A), E = () => {
      if (g.has(A))
        g.set(A, !0);
      else
        return;
      let b = !0;
      g.forEach((R) => {
        R || (b = !1);
      }), b && (w == null || w(), D(h.current), s && (c == null || c()), r && r());
    };
    return N(ih, { isPresent: I, initial: !d.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: i, mode: o, onExitComplete: I ? void 0 : E, anchorX: a, children: y }, A);
  }) });
};
function Po(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Fr(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
let fn = () => {
}, tt = () => {
};
process.env.NODE_ENV !== "production" && (fn = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, tt = (e, t) => {
  if (!e)
    throw new Error(t);
});
const Hi = {
  useManualTiming: !1
};
// @__NO_SIDE_EFFECTS__
function _o(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const $e = /* @__NO_SIDE_EFFECTS__ */ (e) => e, on = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class Co {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Po(this.subscriptions, t), () => Fr(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const s = this.subscriptions[o];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Be = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Qe = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function Hu(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Fs = /* @__PURE__ */ new Set();
function Wn(e, t, n) {
  e || Fs.has(t) || (console.warn(t), Fs.add(t));
}
const sh = /* @__PURE__ */ _o(() => window.ScrollTimeline !== void 0);
class ah {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => t.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((i) => {
      if (sh() && i.attachTimeline)
        return i.attachTimeline(t);
      if (typeof n == "function")
        return n(i);
    });
    return () => {
      r.forEach((i, o) => {
        i && i(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class qu extends ah {
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
}
const Ro = (e) => Array.isArray(e) && typeof e[0] == "number", uh = {};
function ch(e, t) {
  const n = /* @__PURE__ */ _o(e);
  return () => uh[t] ?? n();
}
const An = /* @__PURE__ */ ch(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), zu = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let o = 0; o < i; o++)
    r += e(o / (i - 1)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Tn = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, qi = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Tn([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Tn([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Tn([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Tn([0.33, 1.53, 0.69, 0.99])
};
function Ku(e, t) {
  if (e)
    return typeof e == "function" && An() ? zu(e, t) : Ro(e) ? Tn(e) : Array.isArray(e) ? e.map((n) => Ku(n, t) || qi.easeOut) : qi[e];
}
function lh(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: s = "loop", ease: a = "easeInOut", times: u } = {}, c = void 0) {
  const l = {
    [t]: n
  };
  u && (l.offset = u);
  const f = Ku(a, i);
  return Array.isArray(f) && (l.easing = f), e.animate(l, {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: s === "reverse" ? "alternate" : "normal",
    pseudoElement: c
  });
}
function $r(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function Oo(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Cr = 2e4;
function Do(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Cr; )
    t += n, r = e.next(t);
  return t >= Cr ? 1 / 0 : t;
}
function Yu(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(Do(r), Cr);
  return {
    type: "keyframes",
    ease: (o) => r.next(i * o).value / t,
    duration: /* @__PURE__ */ Qe(i)
  };
}
function Gu(e) {
  return !!(typeof e == "function" && An() || !e || typeof e == "string" && (e in qi || An()) || Ro(e) || Array.isArray(e) && e.every(Gu));
}
function $s(e, t) {
  e.timeline = t, e.onfinish = null;
}
const ar = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function fh(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, o = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function u(l) {
    s.has(l) && (c.schedule(l), e()), l(a);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (l, f = !1, d = !1) => {
      const g = d && i ? n : r;
      return f && s.add(l), g.has(l) || g.add(l), l;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (l) => {
      r.delete(l), s.delete(l);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (l) => {
      if (a = l, i) {
        o = !0;
        return;
      }
      i = !0, [n, r] = [r, n], n.forEach(u), n.clear(), i = !1, o && (o = !1, c.process(l));
    }
  };
  return c;
}
const dh = 40;
function Xu(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, s = ar.reduce((m, D) => (m[D] = fh(o), m), {}), { read: a, resolveKeyframes: u, update: c, preRender: l, render: f, postRender: d } = s, h = () => {
    const m = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(m - i.timestamp, dh), 1), i.timestamp = m, i.isProcessing = !0, a.process(i), u.process(i), c.process(i), l.process(i), f.process(i), d.process(i), i.isProcessing = !1, n && t && (r = !1, e(h));
  }, g = () => {
    n = !0, r = !0, i.isProcessing || e(h);
  };
  return { schedule: ar.reduce((m, D) => {
    const O = s[D];
    return m[D] = (w, y = !1, A = !1) => (n || g(), O.schedule(w, y, A)), m;
  }, {}), cancel: (m) => {
    for (let D = 0; D < ar.length; D++)
      s[ar[D]].cancel(m);
  }, state: i, steps: s };
}
const { schedule: Ao } = /* @__PURE__ */ Xu(queueMicrotask, !1), { schedule: ue, cancel: ut, state: xe, steps: mi } = /* @__PURE__ */ Xu(typeof requestAnimationFrame < "u" ? requestAnimationFrame : $e, !0);
let br;
function hh() {
  br = void 0;
}
const Je = {
  now: () => (br === void 0 && Je.set(xe.isProcessing || Hi.useManualTiming ? xe.timestamp : performance.now()), br),
  set: (e) => {
    br = e, queueMicrotask(hh);
  }
}, He = {
  x: !1,
  y: !1
};
function Zu() {
  return He.x || He.y;
}
function ph(e) {
  return e === "x" || e === "y" ? He[e] ? null : (He[e] = !0, () => {
    He[e] = !1;
  }) : He.x || He.y ? null : (He.x = He.y = !0, () => {
    He.x = He.y = !1;
  });
}
function Qu(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
function Ju(e, t) {
  const n = Qu(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function Bs(e) {
  return !(e.pointerType === "touch" || Zu());
}
function mh(e, t, n = {}) {
  const [r, i, o] = Ju(e, n), s = (a) => {
    if (!Bs(a))
      return;
    const { target: u } = a, c = t(u, a);
    if (typeof c != "function" || !u)
      return;
    const l = (f) => {
      Bs(f) && (c(f), u.removeEventListener("pointerleave", l));
    };
    u.addEventListener("pointerleave", l, i);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", s, i);
  }), o;
}
const ec = (e, t) => t ? e === t ? !0 : ec(e, t.parentElement) : !1, Io = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, gh = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function vh(e) {
  return gh.has(e.tagName) || e.tabIndex !== -1;
}
const xn = /* @__PURE__ */ new WeakSet();
function js(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function gi(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const yh = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = js(() => {
    if (xn.has(n))
      return;
    gi(n, "down");
    const i = js(() => {
      gi(n, "up");
    }), o = () => gi(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Ws(e) {
  return Io(e) && !Zu();
}
function Sh(e, t, n = {}) {
  const [r, i, o] = Ju(e, n), s = (a) => {
    const u = a.currentTarget;
    if (!Ws(a) || xn.has(u))
      return;
    xn.add(u);
    const c = t(u, a), l = (h, g) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", d), !(!Ws(h) || !xn.has(u)) && (xn.delete(u), typeof c == "function" && c(h, { success: g }));
    }, f = (h) => {
      l(h, u === window || u === document || n.useGlobalTarget || ec(u, h.target));
    }, d = (h) => {
      l(h, !1);
    };
    window.addEventListener("pointerup", f, i), window.addEventListener("pointercancel", d, i);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", s, i), a instanceof HTMLElement && (a.addEventListener("focus", (c) => yh(c, i)), !vh(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), o;
}
const Us = 30, bh = (e) => !isNaN(parseFloat(e)), En = {
  current: void 0
};
class wh {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.version = "12.7.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const o = Je.now();
      this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Je.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = bh(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Wn(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Co());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ue.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return En.current && En.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Je.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Us)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Us);
    return Hu(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function sn(e, t) {
  return new wh(e, t);
}
const tc = Tt({ strict: !1 }), Hs = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, an = {};
for (const e in Hs)
  an[e] = {
    isEnabled: (t) => Hs[e].some((n) => !!t[n])
  };
function Th(e) {
  for (const t in e)
    an[t] = {
      ...an[t],
      ...e[t]
    };
}
const xh = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Rr(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || xh.has(e);
}
let nc = (e) => !Rr(e);
function Eh(e) {
  e && (nc = (t) => t.startsWith("on") ? !Rr(t) : e(t));
}
try {
  Eh(require("@emotion/is-prop-valid").default);
} catch {
}
function Ph(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (nc(i) || n === !0 && Rr(i) || !t && !Rr(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function _h(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && Wn(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
  });
}
const Br = /* @__PURE__ */ Tt({});
function jr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function In(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Mo = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], ko = ["initial", ...Mo];
function Wr(e) {
  return jr(e.animate) || ko.some((t) => In(e[t]));
}
function rc(e) {
  return !!(Wr(e) || e.variants);
}
function Ch(e, t) {
  if (Wr(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || In(n) ? n : void 0,
      animate: In(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Rh(e) {
  const { initial: t, animate: n } = Ch(e, be(Br));
  return Ne(() => ({ initial: t, animate: n }), [qs(t), qs(n)]);
}
function qs(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Oh = Symbol.for("motionComponentSymbol");
function Qt(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Dh(e, t, n) {
  return ke(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Qt(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const Lo = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Ah = "framerAppearId", ic = "data-" + Lo(Ah), oc = Tt({});
function Ih(e, t, n, r, i) {
  var p, x;
  const { visualElement: o } = be(Br), s = be(tc), a = be(Nr), u = be(Vr).reducedMotion, c = fe(null);
  r = r || s.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const l = c.current, f = be(oc);
  l && !l.projection && i && (l.type === "html" || l.type === "svg") && Mh(c.current, n, i, f);
  const d = fe(!1);
  Iu(() => {
    l && d.current && l.update(n, a);
  });
  const h = n[ic], g = fe(!!h && !((p = window.MotionHandoffIsComplete) != null && p.call(window, h)) && ((x = window.MotionHasOptimisedAnimation) == null ? void 0 : x.call(window, h)));
  return Eo(() => {
    l && (d.current = !0, window.MotionIsMounted = !0, l.updateFeatures(), Ao.render(l.render), g.current && l.animationState && l.animationState.animateChanges());
  }), Ce(() => {
    l && (!g.current && l.animationState && l.animationState.animateChanges(), g.current && (queueMicrotask(() => {
      var m;
      (m = window.MotionHandoffMarkAsComplete) == null || m.call(window, h);
    }), g.current = !1));
  }), l;
}
function Mh(e, t, n, r) {
  const { layoutId: i, layout: o, drag: s, dragConstraints: a, layoutScroll: u, layoutRoot: c, layoutCrossfade: l } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : sc(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!s || a && Qt(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: l,
    layoutScroll: u,
    layoutRoot: c
  });
}
function sc(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : sc(e.parent);
}
function kh({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && Th(e);
  function o(a, u) {
    let c;
    const l = {
      ...be(Vr),
      ...a,
      layoutId: Lh(a)
    }, { isStatic: f } = l, d = Rh(a), h = r(a, f);
    if (!f && xo) {
      Nh(l, e);
      const g = Vh(l);
      c = g.MeasureLayout, d.visualElement = Ih(i, h, l, t, g.ProjectionNode);
    }
    return ne(Br.Provider, { value: d, children: [c && d.visualElement ? N(c, { visualElement: d.visualElement, ...l }) : null, n(i, a, Dh(h, d.visualElement, u), h, f, d.visualElement)] });
  }
  o.displayName = `motion.${typeof i == "string" ? i : `create(${i.displayName ?? i.name ?? ""})`}`;
  const s = lt(o);
  return s[Oh] = i, s;
}
function Lh({ layoutId: e }) {
  const t = be(To).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Nh(e, t) {
  const n = be(tc).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? fn(!1, r) : tt(!1, r);
  }
}
function Vh(e) {
  const { drag: t, layout: n } = an;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const ac = (e) => (t) => typeof t == "string" && t.startsWith(e), No = /* @__PURE__ */ ac("--"), Fh = /* @__PURE__ */ ac("var(--"), Vo = (e) => Fh(e) ? $h.test(e.split("/*")[0].trim()) : !1, $h = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Mn = {};
function Bh(e) {
  for (const t in e)
    Mn[t] = e[t], No(t) && (Mn[t].isCSSVariable = !0);
}
const dn = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], $t = new Set(dn);
function uc(e, { layout: t, layoutId: n }) {
  return $t.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Mn[e] || e === "opacity");
}
const Te = (e) => !!(e && e.getVelocity), cc = (e, t) => t && typeof e == "number" ? t.transform(e) : e, ct = (e, t, n) => n > t ? t : n < e ? e : n, hn = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, kn = {
  ...hn,
  transform: (e) => ct(0, 1, e)
}, ur = {
  ...hn,
  default: 1
}, Un = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), vt = /* @__PURE__ */ Un("deg"), et = /* @__PURE__ */ Un("%"), J = /* @__PURE__ */ Un("px"), jh = /* @__PURE__ */ Un("vh"), Wh = /* @__PURE__ */ Un("vw"), zs = {
  ...et,
  parse: (e) => et.parse(e) / 100,
  transform: (e) => et.transform(e * 100)
}, Uh = {
  // Border props
  borderWidth: J,
  borderTopWidth: J,
  borderRightWidth: J,
  borderBottomWidth: J,
  borderLeftWidth: J,
  borderRadius: J,
  radius: J,
  borderTopLeftRadius: J,
  borderTopRightRadius: J,
  borderBottomRightRadius: J,
  borderBottomLeftRadius: J,
  // Positioning props
  width: J,
  maxWidth: J,
  height: J,
  maxHeight: J,
  top: J,
  right: J,
  bottom: J,
  left: J,
  // Spacing props
  padding: J,
  paddingTop: J,
  paddingRight: J,
  paddingBottom: J,
  paddingLeft: J,
  margin: J,
  marginTop: J,
  marginRight: J,
  marginBottom: J,
  marginLeft: J,
  // Misc
  backgroundPositionX: J,
  backgroundPositionY: J
}, Hh = {
  rotate: vt,
  rotateX: vt,
  rotateY: vt,
  rotateZ: vt,
  scale: ur,
  scaleX: ur,
  scaleY: ur,
  scaleZ: ur,
  skew: vt,
  skewX: vt,
  skewY: vt,
  distance: J,
  translateX: J,
  translateY: J,
  translateZ: J,
  x: J,
  y: J,
  z: J,
  perspective: J,
  transformPerspective: J,
  opacity: kn,
  originX: zs,
  originY: zs,
  originZ: J
}, Ks = {
  ...hn,
  transform: Math.round
}, Fo = {
  ...Uh,
  ...Hh,
  zIndex: Ks,
  size: J,
  // SVG
  fillOpacity: kn,
  strokeOpacity: kn,
  numOctaves: Ks
}, qh = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, zh = dn.length;
function Kh(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < zh; o++) {
    const s = dn[o], a = e[s];
    if (a === void 0)
      continue;
    let u = !0;
    if (typeof a == "number" ? u = a === (s.startsWith("scale") ? 1 : 0) : u = parseFloat(a) === 0, !u || n) {
      const c = cc(a, Fo[s]);
      if (!u) {
        i = !1;
        const l = qh[s] || s;
        r += `${l}(${c}) `;
      }
      n && (t[s] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function $o(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let s = !1, a = !1;
  for (const u in t) {
    const c = t[u];
    if ($t.has(u)) {
      s = !0;
      continue;
    } else if (No(u)) {
      i[u] = c;
      continue;
    } else {
      const l = cc(c, Fo[u]);
      u.startsWith("origin") ? (a = !0, o[u] = l) : r[u] = l;
    }
  }
  if (t.transform || (s || n ? r.transform = Kh(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: u = "50%", originY: c = "50%", originZ: l = 0 } = o;
    r.transformOrigin = `${u} ${c} ${l}`;
  }
}
const Bo = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function lc(e, t, n) {
  for (const r in t)
    !Te(t[r]) && !uc(r, n) && (e[r] = t[r]);
}
function Yh({ transformTemplate: e }, t) {
  return Ne(() => {
    const n = Bo();
    return $o(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Gh(e, t) {
  const n = e.style || {}, r = {};
  return lc(r, n, e), Object.assign(r, Yh(e, t)), r;
}
function Xh(e, t) {
  const n = {}, r = Gh(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const Zh = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function jo(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Zh.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
const Qh = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Jh = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function ep(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? Qh : Jh;
  e[o.offset] = J.transform(-r);
  const s = J.transform(t), a = J.transform(n);
  e[o.array] = `${s} ${a}`;
}
function Ys(e, t, n) {
  return typeof e == "string" ? e : J.transform(t + n * e);
}
function tp(e, t, n) {
  const r = Ys(t, e.x, e.width), i = Ys(n, e.y, e.height);
  return `${r} ${i}`;
}
function Wo(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: o,
  pathLength: s,
  pathSpacing: a = 1,
  pathOffset: u = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, l, f) {
  if ($o(e, c, f), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: d, style: h, dimensions: g } = e;
  d.transform && (g && (h.transform = d.transform), delete d.transform), g && (i !== void 0 || o !== void 0 || h.transform) && (h.transformOrigin = tp(g, i !== void 0 ? i : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), s !== void 0 && ep(d, s, a, u, !1);
}
const fc = () => ({
  ...Bo(),
  attrs: {}
}), Uo = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function np(e, t, n, r) {
  const i = Ne(() => {
    const o = fc();
    return Wo(o, t, Uo(r), e.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    lc(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
function rp(e = !1) {
  return (n, r, i, { latestValues: o }, s) => {
    const u = (jo(n) ? np : Xh)(r, o, s, n), c = Ph(r, typeof n == "string", e), l = n !== vo ? { ...c, ...u, ref: i } : {}, { children: f } = r, d = Ne(() => Te(f) ? f.get() : f, [f]);
    return _r(n, {
      ...l,
      children: d
    });
  };
}
function Gs(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Ho(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = Gs(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = Gs(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
const zi = (e) => Array.isArray(e), ip = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), op = (e) => zi(e) ? e[e.length - 1] || 0 : e;
function wr(e) {
  const t = Te(e) ? e.get() : e;
  return ip(t) ? t.toValue() : t;
}
function sp({ scrapeMotionValuesFromProps: e, createRenderState: t, onUpdate: n }, r, i, o) {
  const s = {
    latestValues: ap(r, i, o, e),
    renderState: t()
  };
  return n && (s.onMount = (a) => n({ props: r, current: a, ...s }), s.onUpdate = (a) => n(a)), s;
}
const dc = (e) => (t, n) => {
  const r = be(Br), i = be(Nr), o = () => sp(e, t, r, i);
  return n ? o() : jn(o);
};
function ap(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const d in o)
    i[d] = wr(o[d]);
  let { initial: s, animate: a } = e;
  const u = Wr(e), c = rc(e);
  t && c && !u && e.inherit !== !1 && (s === void 0 && (s = t.initial), a === void 0 && (a = t.animate));
  let l = n ? n.initial === !1 : !1;
  l = l || s === !1;
  const f = l ? a : s;
  if (f && typeof f != "boolean" && !jr(f)) {
    const d = Array.isArray(f) ? f : [f];
    for (let h = 0; h < d.length; h++) {
      const g = Ho(e, d[h]);
      if (g) {
        const { transitionEnd: p, transition: x, ...m } = g;
        for (const D in m) {
          let O = m[D];
          if (Array.isArray(O)) {
            const w = l ? O.length - 1 : 0;
            O = O[w];
          }
          O !== null && (i[D] = O);
        }
        for (const D in p)
          i[D] = p[D];
      }
    }
  }
  return i;
}
function qo(e, t, n) {
  var o;
  const { style: r } = e, i = {};
  for (const s in r)
    (Te(r[s]) || t.style && Te(t.style[s]) || uc(s, e) || ((o = n == null ? void 0 : n.getValue(s)) == null ? void 0 : o.liveStyle) !== void 0) && (i[s] = r[s]);
  return i;
}
const up = {
  useVisualState: dc({
    scrapeMotionValuesFromProps: qo,
    createRenderState: Bo
  })
};
function hc(e, t) {
  try {
    t.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
  } catch {
    t.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
function pc(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const o in n)
    e.style.setProperty(o, n[o]);
}
const mc = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function gc(e, t, n, r) {
  pc(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(mc.has(i) ? i : Lo(i), t.attrs[i]);
}
function vc(e, t, n) {
  const r = qo(e, t, n);
  for (const i in e)
    if (Te(e[i]) || Te(t[i])) {
      const o = dn.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
const Xs = ["x", "y", "width", "height", "cx", "cy", "r"], cp = {
  useVisualState: dc({
    scrapeMotionValuesFromProps: vc,
    createRenderState: fc,
    onUpdate: ({ props: e, prevProps: t, current: n, renderState: r, latestValues: i }) => {
      if (!n)
        return;
      let o = !!e.drag;
      if (!o) {
        for (const a in i)
          if ($t.has(a)) {
            o = !0;
            break;
          }
      }
      if (!o)
        return;
      let s = !t;
      if (t)
        for (let a = 0; a < Xs.length; a++) {
          const u = Xs[a];
          e[u] !== t[u] && (s = !0);
        }
      s && ue.read(() => {
        hc(n, r), ue.render(() => {
          Wo(r, i, Uo(n.tagName), e.transformTemplate), gc(n, r);
        });
      });
    }
  })
};
function lp(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const s = {
      ...jo(r) ? cp : up,
      preloadedFeatures: e,
      useRender: rp(i),
      createVisualElement: t,
      Component: r
    };
    return kh(s);
  };
}
function Ln(e, t, n) {
  const r = e.getProps();
  return Ho(r, t, n !== void 0 ? n : r.custom, e);
}
const yc = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...dn
]);
function fp(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, sn(n));
}
function dp(e, t) {
  const n = Ln(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const s in o) {
    const a = op(o[s]);
    fp(e, s, a);
  }
}
function hp(e) {
  return !!(Te(e) && e.add);
}
function Ki(e, t) {
  const n = e.getValue("willChange");
  if (hp(n))
    return n.add(t);
  if (!n && Hi.WillChange) {
    const r = new Hi.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Sc(e) {
  return e.props[ic];
}
const bc = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, pp = 1e-7, mp = 12;
function gp(e, t, n, r, i) {
  let o, s, a = 0;
  do
    s = t + (n - t) / 2, o = bc(s, r, i) - e, o > 0 ? n = s : t = s;
  while (Math.abs(o) > pp && ++a < mp);
  return s;
}
function Hn(e, t, n, r) {
  if (e === t && n === r)
    return $e;
  const i = (o) => gp(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : bc(i(o), t, r);
}
const wc = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Tc = (e) => (t) => 1 - e(1 - t), xc = /* @__PURE__ */ Hn(0.33, 1.53, 0.69, 0.99), zo = /* @__PURE__ */ Tc(xc), Ec = /* @__PURE__ */ wc(zo), Pc = (e) => (e *= 2) < 1 ? 0.5 * zo(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ko = (e) => 1 - Math.sin(Math.acos(e)), _c = Tc(Ko), Cc = wc(Ko), Rc = (e) => /^0[^.\s]+$/u.test(e);
function vp(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Rc(e) : !0;
}
const Pn = (e) => Math.round(e * 1e5) / 1e5, Yo = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function yp(e) {
  return e == null;
}
const Sp = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Go = (e, t) => (n) => !!(typeof n == "string" && Sp.test(n) && n.startsWith(e) || t && !yp(n) && Object.prototype.hasOwnProperty.call(n, t)), Oc = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, s, a] = r.match(Yo);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, bp = (e) => ct(0, 255, e), vi = {
  ...hn,
  transform: (e) => Math.round(bp(e))
}, kt = {
  test: /* @__PURE__ */ Go("rgb", "red"),
  parse: /* @__PURE__ */ Oc("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + vi.transform(e) + ", " + vi.transform(t) + ", " + vi.transform(n) + ", " + Pn(kn.transform(r)) + ")"
};
function wp(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Yi = {
  test: /* @__PURE__ */ Go("#"),
  parse: wp,
  transform: kt.transform
}, Jt = {
  test: /* @__PURE__ */ Go("hsl", "hue"),
  parse: /* @__PURE__ */ Oc("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + et.transform(Pn(t)) + ", " + et.transform(Pn(n)) + ", " + Pn(kn.transform(r)) + ")"
}, Pe = {
  test: (e) => kt.test(e) || Yi.test(e) || Jt.test(e),
  parse: (e) => kt.test(e) ? kt.parse(e) : Jt.test(e) ? Jt.parse(e) : Yi.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? kt.transform(e) : Jt.transform(e)
}, Tp = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function xp(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Yo)) == null ? void 0 : t.length) || 0) + (((n = e.match(Tp)) == null ? void 0 : n.length) || 0) > 0;
}
const Dc = "number", Ac = "color", Ep = "var", Pp = "var(", Zs = "${}", _p = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Nn(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const a = t.replace(_p, (u) => (Pe.test(u) ? (r.color.push(o), i.push(Ac), n.push(Pe.parse(u))) : u.startsWith(Pp) ? (r.var.push(o), i.push(Ep), n.push(u)) : (r.number.push(o), i.push(Dc), n.push(parseFloat(u))), ++o, Zs)).split(Zs);
  return { values: n, split: a, indexes: r, types: i };
}
function Ic(e) {
  return Nn(e).values;
}
function Mc(e) {
  const { split: t, types: n } = Nn(e), r = t.length;
  return (i) => {
    let o = "";
    for (let s = 0; s < r; s++)
      if (o += t[s], i[s] !== void 0) {
        const a = n[s];
        a === Dc ? o += Pn(i[s]) : a === Ac ? o += Pe.transform(i[s]) : o += i[s];
      }
    return o;
  };
}
const Cp = (e) => typeof e == "number" ? 0 : e;
function Rp(e) {
  const t = Ic(e);
  return Mc(e)(t.map(Cp));
}
const wt = {
  test: xp,
  parse: Ic,
  createTransformer: Mc,
  getAnimatableNone: Rp
}, Op = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Dp(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Yo) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = Op.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const Ap = /\b([a-z-]*)\(.*?\)/gu, Gi = {
  ...wt,
  getAnimatableNone: (e) => {
    const t = e.match(Ap);
    return t ? t.map(Dp).join(" ") : e;
  }
}, Ip = {
  ...Fo,
  // Color props
  color: Pe,
  backgroundColor: Pe,
  outlineColor: Pe,
  fill: Pe,
  stroke: Pe,
  // Border props
  borderColor: Pe,
  borderTopColor: Pe,
  borderRightColor: Pe,
  borderBottomColor: Pe,
  borderLeftColor: Pe,
  filter: Gi,
  WebkitFilter: Gi
}, kc = (e) => Ip[e];
function Lc(e, t) {
  let n = kc(e);
  return n !== Gi && (n = wt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const Mp = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function kp(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !Mp.has(o) && Nn(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = Lc(n, i);
}
const Lt = (e) => e * 180 / Math.PI, Xi = (e) => {
  const t = Lt(Math.atan2(e[1], e[0]));
  return Zi(t);
}, Lp = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Xi,
  rotateZ: Xi,
  skewX: (e) => Lt(Math.atan(e[1])),
  skewY: (e) => Lt(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, Zi = (e) => (e = e % 360, e < 0 && (e += 360), e), Qs = Xi, Js = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), ea = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), Np = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Js,
  scaleY: ea,
  scale: (e) => (Js(e) + ea(e)) / 2,
  rotateX: (e) => Zi(Lt(Math.atan2(e[6], e[5]))),
  rotateY: (e) => Zi(Lt(Math.atan2(-e[2], e[0]))),
  rotateZ: Qs,
  rotate: Qs,
  skewX: (e) => Lt(Math.atan(e[4])),
  skewY: (e) => Lt(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function ta(e) {
  return e.includes("scale") ? 1 : 0;
}
function Qi(e, t) {
  if (!e || e === "none")
    return ta(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = Np, i = n;
  else {
    const a = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = Lp, i = a;
  }
  if (!i)
    return ta(t);
  const o = r[t], s = i[1].split(",").map(Fp);
  return typeof o == "function" ? o(s) : s[o];
}
const Vp = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return Qi(n, t);
};
function Fp(e) {
  return parseFloat(e.trim());
}
const na = (e) => e === hn || e === J, $p = /* @__PURE__ */ new Set(["x", "y", "z"]), Bp = dn.filter((e) => !$p.has(e));
function jp(e) {
  const t = [];
  return Bp.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const un = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => Qi(t, "x"),
  y: (e, { transform: t }) => Qi(t, "y")
};
un.translateX = un.x;
un.translateY = un.y;
const Nt = /* @__PURE__ */ new Set();
let Ji = !1, eo = !1;
function Nc() {
  if (eo) {
    const e = Array.from(Nt).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = jp(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, s]) => {
        var a;
        (a = r.getValue(o)) == null || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  eo = !1, Ji = !1, Nt.forEach((e) => e.complete()), Nt.clear();
}
function Vc() {
  Nt.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (eo = !0);
  });
}
function Wp() {
  Vc(), Nc();
}
class Xo {
  constructor(t, n, r, i, o, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Nt.add(this), Ji || (Ji = !0, ue.read(Vc), ue.resolveKeyframes(Nc))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    for (let o = 0; o < t.length; o++)
      if (t[o] === null)
        if (o === 0) {
          const s = i == null ? void 0 : i.get(), a = t[t.length - 1];
          if (s !== void 0)
            t[0] = s;
          else if (r && n) {
            const u = r.readValue(n, a);
            u != null && (t[0] = u);
          }
          t[0] === void 0 && (t[0] = a), i && s === void 0 && i.set(t[0]);
        } else
          t[o] = t[o - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Nt.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Nt.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Fc = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Up = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Hp(e) {
  const t = Up.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const qp = 4;
function $c(e, t, n = 1) {
  tt(n <= qp, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, i] = Hp(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const s = o.trim();
    return Fc(s) ? parseFloat(s) : s;
  }
  return Vo(i) ? $c(i, t, n + 1) : i;
}
const Bc = (e) => (t) => t.test(e), zp = {
  test: (e) => e === "auto",
  parse: (e) => e
}, jc = [hn, J, et, vt, Wh, jh, zp], ra = (e) => jc.find(Bc(e));
class Wc extends Xo {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < t.length; u++) {
      let c = t[u];
      if (typeof c == "string" && (c = c.trim(), Vo(c))) {
        const l = $c(c, n.current);
        l !== void 0 && (t[u] = l), u === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !yc.has(r) || t.length !== 2)
      return;
    const [i, o] = t, s = ra(i), a = ra(o);
    if (s !== a)
      if (na(s) && na(a))
        for (let u = 0; u < t.length; u++) {
          const c = t[u];
          typeof c == "string" && (t[u] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      vp(t[i]) && r.push(i);
    r.length && kp(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = un[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var a;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, s = r[o];
    r[o] = un[n](t.measureViewportBox(), window.getComputedStyle(t.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([u, c]) => {
      t.getValue(u).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const ia = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(wt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function Kp(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function Yp(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], s = ia(i, t), a = ia(o, t);
  return fn(s === a, `You are trying to animate ${t} from "${i}" to "${o}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${o} via the \`style\` property.`), !s || !a ? !1 : Kp(e) || (n === "spring" || $r(n)) && r;
}
const Gp = (e) => e !== null;
function Ur(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(Gp), o = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !o || r === void 0 ? i[o] : r;
}
const Xp = 40;
class Uc {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: s = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = Je.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: s,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > Xp ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && Wp(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = Je.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: o, delay: s, onComplete: a, onUpdate: u, isGenerator: c } = this.options;
    if (!c && !Yp(t, r, i, o))
      if (s)
        this.options.duration = 0;
      else {
        u && u(Ur(t, this.options, n)), a && a(), this.resolveFinishedPromise();
        return;
      }
    const l = this.initPlayback(t, n);
    l !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...l
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  flatten() {
    this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear");
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
const de = (e, t, n) => e + (t - e) * n;
function yi(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Zp({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, s = 0;
  if (!t)
    i = o = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, u = 2 * n - a;
    i = yi(u, a, e + 1 / 3), o = yi(u, a, e), s = yi(u, a, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Or(e, t) {
  return (n) => n > 0 ? t : e;
}
const Si = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Qp = [Yi, kt, Jt], Jp = (e) => Qp.find((t) => t.test(e));
function oa(e) {
  const t = Jp(e);
  if (fn(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === Jt && (n = Zp(n)), n;
}
const sa = (e, t) => {
  const n = oa(e), r = oa(t);
  if (!n || !r)
    return Or(e, t);
  const i = { ...n };
  return (o) => (i.red = Si(n.red, r.red, o), i.green = Si(n.green, r.green, o), i.blue = Si(n.blue, r.blue, o), i.alpha = de(n.alpha, r.alpha, o), kt.transform(i));
}, em = (e, t) => (n) => t(e(n)), qn = (...e) => e.reduce(em), to = /* @__PURE__ */ new Set(["none", "hidden"]);
function tm(e, t) {
  return to.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function nm(e, t) {
  return (n) => de(e, t, n);
}
function Zo(e) {
  return typeof e == "number" ? nm : typeof e == "string" ? Vo(e) ? Or : Pe.test(e) ? sa : om : Array.isArray(e) ? Hc : typeof e == "object" ? Pe.test(e) ? sa : rm : Or;
}
function Hc(e, t) {
  const n = [...e], r = n.length, i = e.map((o, s) => Zo(o)(o, t[s]));
  return (o) => {
    for (let s = 0; s < r; s++)
      n[s] = i[s](o);
    return n;
  };
}
function rm(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = Zo(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function im(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], s = e.indexes[o][r[o]], a = e.values[s] ?? 0;
    n[i] = a, r[o]++;
  }
  return n;
}
const om = (e, t) => {
  const n = wt.createTransformer(t), r = Nn(e), i = Nn(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? to.has(e) && !i.values.length || to.has(t) && !r.values.length ? tm(e, t) : qn(Hc(im(r, i), i.values), n) : (fn(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Or(e, t));
};
function qc(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? de(e, t, n) : Zo(e)(e, t);
}
const sm = 5;
function zc(e, t, n) {
  const r = Math.max(t - sm, 0);
  return Hu(n - e(r), t - r);
}
const pe = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, aa = 1e-3;
function am({ duration: e = pe.duration, bounce: t = pe.bounce, velocity: n = pe.velocity, mass: r = pe.mass }) {
  let i, o;
  fn(e <= /* @__PURE__ */ Be(pe.maxDuration), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = ct(pe.minDamping, pe.maxDamping, s), e = ct(pe.minDuration, pe.maxDuration, /* @__PURE__ */ Qe(e)), s < 1 ? (i = (c) => {
    const l = c * s, f = l * e, d = l - n, h = no(c, s), g = Math.exp(-f);
    return aa - d / h * g;
  }, o = (c) => {
    const f = c * s * e, d = f * n + n, h = Math.pow(s, 2) * Math.pow(c, 2) * e, g = Math.exp(-f), p = no(Math.pow(c, 2), s);
    return (-i(c) + aa > 0 ? -1 : 1) * ((d - h) * g) / p;
  }) : (i = (c) => {
    const l = Math.exp(-c * e), f = (c - n) * e + 1;
    return -1e-3 + l * f;
  }, o = (c) => {
    const l = Math.exp(-c * e), f = (n - c) * (e * e);
    return l * f;
  });
  const a = 5 / e, u = cm(i, o, a);
  if (e = /* @__PURE__ */ Be(e), isNaN(u))
    return {
      stiffness: pe.stiffness,
      damping: pe.damping,
      duration: e
    };
  {
    const c = Math.pow(u, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const um = 12;
function cm(e, t, n) {
  let r = n;
  for (let i = 1; i < um; i++)
    r = r - e(r) / t(r);
  return r;
}
function no(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const lm = ["duration", "bounce"], fm = ["stiffness", "damping", "mass"];
function ua(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function dm(e) {
  let t = {
    velocity: pe.velocity,
    stiffness: pe.stiffness,
    damping: pe.damping,
    mass: pe.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ua(e, fm) && ua(e, lm))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, o = 2 * ct(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: pe.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = am(e);
      t = {
        ...t,
        ...n,
        mass: pe.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Vn(e = pe.visualDuration, t = pe.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const o = n.keyframes[0], s = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: o }, { stiffness: u, damping: c, mass: l, duration: f, velocity: d, isResolvedFromDuration: h } = dm({
    ...n,
    velocity: -/* @__PURE__ */ Qe(n.velocity || 0)
  }), g = d || 0, p = c / (2 * Math.sqrt(u * l)), x = s - o, m = /* @__PURE__ */ Qe(Math.sqrt(u / l)), D = Math.abs(x) < 5;
  r || (r = D ? pe.restSpeed.granular : pe.restSpeed.default), i || (i = D ? pe.restDelta.granular : pe.restDelta.default);
  let O;
  if (p < 1) {
    const y = no(m, p);
    O = (A) => {
      const I = Math.exp(-p * m * A);
      return s - I * ((g + p * m * x) / y * Math.sin(y * A) + x * Math.cos(y * A));
    };
  } else if (p === 1)
    O = (y) => s - Math.exp(-m * y) * (x + (g + m * x) * y);
  else {
    const y = m * Math.sqrt(p * p - 1);
    O = (A) => {
      const I = Math.exp(-p * m * A), E = Math.min(y * A, 300);
      return s - I * ((g + p * m * x) * Math.sinh(E) + y * x * Math.cosh(E)) / y;
    };
  }
  const w = {
    calculatedDuration: h && f || null,
    next: (y) => {
      const A = O(y);
      if (h)
        a.done = y >= f;
      else {
        let I = 0;
        p < 1 && (I = y === 0 ? /* @__PURE__ */ Be(g) : zc(O, y, A));
        const E = Math.abs(I) <= r, b = Math.abs(s - A) <= i;
        a.done = E && b;
      }
      return a.value = a.done ? s : A, a;
    },
    toString: () => {
      const y = Math.min(Do(w), Cr), A = zu((I) => w.next(y * I).value, y, 30);
      return y + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return w;
}
Vn.applyToOptions = (e) => {
  const t = Yu(e, 100, Vn);
  return e.ease = An() ? t.ease : "easeOut", e.duration = /* @__PURE__ */ Be(t.duration), e.type = "keyframes", e;
};
function ca({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: s, min: a, max: u, restDelta: c = 0.5, restSpeed: l }) {
  const f = e[0], d = {
    done: !1,
    value: f
  }, h = (E) => a !== void 0 && E < a || u !== void 0 && E > u, g = (E) => a === void 0 ? u : u === void 0 || Math.abs(a - E) < Math.abs(u - E) ? a : u;
  let p = n * t;
  const x = f + p, m = s === void 0 ? x : s(x);
  m !== x && (p = m - f);
  const D = (E) => -p * Math.exp(-E / r), O = (E) => m + D(E), w = (E) => {
    const b = D(E), R = O(E);
    d.done = Math.abs(b) <= c, d.value = d.done ? m : R;
  };
  let y, A;
  const I = (E) => {
    h(d.value) && (y = E, A = Vn({
      keyframes: [d.value, g(d.value)],
      velocity: zc(O, E, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: c,
      restSpeed: l
    }));
  };
  return I(0), {
    calculatedDuration: null,
    next: (E) => {
      let b = !1;
      return !A && y === void 0 && (b = !0, w(E), I(E)), y !== void 0 && E >= y ? A.next(E - y) : (!b && w(E), d);
    }
  };
}
const hm = /* @__PURE__ */ Hn(0.42, 0, 1, 1), pm = /* @__PURE__ */ Hn(0, 0, 0.58, 1), Kc = /* @__PURE__ */ Hn(0.42, 0, 0.58, 1), Yc = (e) => Array.isArray(e) && typeof e[0] != "number", la = {
  linear: $e,
  easeIn: hm,
  easeInOut: Kc,
  easeOut: pm,
  circIn: Ko,
  circInOut: Cc,
  circOut: _c,
  backIn: zo,
  backInOut: Ec,
  backOut: xc,
  anticipate: Pc
}, fa = (e) => {
  if (Ro(e)) {
    tt(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, i] = e;
    return Hn(t, n, r, i);
  } else if (typeof e == "string")
    return tt(la[e] !== void 0, `Invalid easing type '${e}'`), la[e];
  return e;
};
function mm(e, t, n) {
  const r = [], i = n || qc, o = e.length - 1;
  for (let s = 0; s < o; s++) {
    let a = i(e[s], e[s + 1]);
    if (t) {
      const u = Array.isArray(t) ? t[s] || $e : t;
      a = qn(u, a);
    }
    r.push(a);
  }
  return r;
}
function Gc(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (tt(o === t.length, "Both input and output ranges must be the same length"), o === 1)
    return () => t[0];
  if (o === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = mm(t, r, i), u = a.length, c = (l) => {
    if (s && l < e[0])
      return t[0];
    let f = 0;
    if (u > 1)
      for (; f < e.length - 2 && !(l < e[f + 1]); f++)
        ;
    const d = /* @__PURE__ */ on(e[f], e[f + 1], l);
    return a[f](d);
  };
  return n ? (l) => c(ct(e[0], e[o - 1], l)) : c;
}
function Xc(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ on(0, t, r);
    e.push(de(n, 1, i));
  }
}
function Zc(e) {
  const t = [0];
  return Xc(t, e.length - 1), t;
}
function gm(e, t) {
  return e.map((n) => n * t);
}
function vm(e, t) {
  return e.map(() => t || Kc).splice(0, e.length - 1);
}
function _n({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = Yc(r) ? r.map(fa) : fa(r), o = {
    done: !1,
    value: t[0]
  }, s = gm(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Zc(t),
    e
  ), a = Gc(s, t, {
    ease: Array.isArray(i) ? i : vm(t, i)
  });
  return {
    calculatedDuration: e,
    next: (u) => (o.value = a(u), o.done = u >= e, o)
  };
}
const ym = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => ue.update(t, !0),
    stop: () => ut(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => xe.isProcessing ? xe.timestamp : Je.now()
  };
}, Sm = {
  decay: ca,
  inertia: ca,
  tween: _n,
  keyframes: _n,
  spring: Vn
}, bm = (e) => e / 100;
class Qo extends Uc {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: u } = this.options;
      u && u();
    };
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options, s = (i == null ? void 0 : i.KeyframeResolver) || Xo, a = (u, c) => this.onKeyframesResolved(u, c);
    this.resolver = new s(o, a, n, r, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: s = 0 } = this.options, a = $r(n) ? n : Sm[n] || _n;
    let u, c;
    process.env.NODE_ENV !== "production" && a !== _n && tt(t.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), a !== _n && typeof t[0] != "number" && (u = qn(bm, qc(t[0], t[1])), t = [0, 100]);
    const l = a({ ...this.options, keyframes: t });
    o === "mirror" && (c = a({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -s
    })), l.calculatedDuration === null && (l.calculatedDuration = Do(l));
    const { calculatedDuration: f } = l, d = f + i, h = d * (r + 1) - i;
    return {
      generator: l,
      mirroredGenerator: c,
      mapPercentToKeyframes: u,
      calculatedDuration: f,
      resolvedDuration: d,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: E } = this.options;
      return { done: !0, value: E[E.length - 1] };
    }
    const { finalKeyframe: i, generator: o, mirroredGenerator: s, mapPercentToKeyframes: a, keyframes: u, calculatedDuration: c, totalDuration: l, resolvedDuration: f } = r;
    if (this.startTime === null)
      return o.next(0);
    const { delay: d, repeat: h, repeatType: g, repeatDelay: p, onUpdate: x } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - l / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const m = this.currentTime - d * (this.speed >= 0 ? 1 : -1), D = this.speed >= 0 ? m < 0 : m > l;
    this.currentTime = Math.max(m, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = l);
    let O = this.currentTime, w = o;
    if (h) {
      const E = Math.min(this.currentTime, l) / f;
      let b = Math.floor(E), R = E % 1;
      !R && E >= 1 && (R = 1), R === 1 && b--, b = Math.min(b, h + 1), !!(b % 2) && (g === "reverse" ? (R = 1 - R, p && (R -= p / f)) : g === "mirror" && (w = s)), O = ct(0, 1, R) * f;
    }
    const y = D ? { done: !1, value: u[0] } : w.next(O);
    a && (y.value = a(y.value));
    let { done: A } = y;
    !D && c !== null && (A = this.speed >= 0 ? this.currentTime >= l : this.currentTime <= 0);
    const I = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return I && i !== void 0 && (y.value = Ur(u, this.options, i)), x && x(y.value), I && this.finish(), y;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? /* @__PURE__ */ Qe(t.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ Qe(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Be(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ Qe(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = ym, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = this.currentTime ?? 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  get finished() {
    return this.currentFinishedPromise;
  }
}
const wm = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Tm = /* @__PURE__ */ _o(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Dr = 10, xm = 2e4;
function Em(e) {
  return $r(e.type) || e.type === "spring" || !Gu(e.ease);
}
function Pm(e, t) {
  const n = new Qo({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const i = [];
  let o = 0;
  for (; !r.done && o < xm; )
    r = n.sample(o), i.push(r.value), o += Dr;
  return {
    times: void 0,
    keyframes: i,
    duration: o - Dr,
    ease: "linear"
  };
}
const Qc = {
  anticipate: Pc,
  backInOut: Ec,
  circInOut: Cc
};
function _m(e) {
  return e in Qc;
}
class da extends Uc {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options;
    this.resolver = new Wc(o, (s, a) => this.onKeyframesResolved(s, a), n, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    let { duration: r = 300, times: i, ease: o, type: s, motionValue: a, name: u, startTime: c } = this.options;
    if (!a.owner || !a.owner.current)
      return !1;
    if (typeof o == "string" && An() && _m(o) && (o = Qc[o]), Em(this.options)) {
      const { onComplete: f, onUpdate: d, motionValue: h, element: g, ...p } = this.options, x = Pm(t, p);
      t = x.keyframes, t.length === 1 && (t[1] = t[0]), r = x.duration, i = x.times, o = x.ease, s = "keyframes";
    }
    const l = lh(a.owner.current, u, t, { ...this.options, duration: r, times: i, ease: o });
    return l.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? ($s(l, this.pendingTimeline), this.pendingTimeline = void 0) : l.onfinish = () => {
      const { onComplete: f } = this.options;
      a.set(Ur(t, this.options, n)), f && f(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: l,
      duration: r,
      times: i,
      type: s,
      ease: o,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return /* @__PURE__ */ Qe(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return /* @__PURE__ */ Qe(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = /* @__PURE__ */ Be(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  get finished() {
    return this.resolved.animation.finished;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return $e;
      const { animation: r } = n;
      $s(r, t);
    }
    return $e;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: i, type: o, ease: s, times: a } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: l, onComplete: f, element: d, ...h } = this.options, g = new Qo({
        ...h,
        keyframes: r,
        duration: i,
        type: o,
        ease: s,
        times: a,
        isGenerator: !0
      }), p = /* @__PURE__ */ Be(this.time);
      c.setWithVelocity(g.sample(p - Dr).value, g.sample(p).value, Dr);
    }
    const { onStop: u } = this.options;
    u && u(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: o, damping: s, type: a } = t;
    if (!n || !n.owner || !(n.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: u, transformTemplate: c } = n.owner.getProps();
    return Tm() && r && wm.has(r) && (r !== "transform" || !c) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !u && !i && o !== "mirror" && s !== 0 && a !== "inertia";
  }
}
const Cm = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Rm = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Om = {
  type: "keyframes",
  duration: 0.8
}, Dm = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Am = (e, { keyframes: t }) => t.length > 2 ? Om : $t.has(e) ? e.startsWith("scale") ? Rm(t[1]) : Cm : Dm;
function Im({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: o, repeatType: s, repeatDelay: a, from: u, elapsed: c, ...l }) {
  return !!Object.keys(l).length;
}
const Jo = (e, t, n, r = {}, i, o) => (s) => {
  const a = Oo(r, e) || {}, u = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ Be(u);
  let l = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (d) => {
      t.set(d), a.onUpdate && a.onUpdate(d);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  Im(a) || (l = {
    ...l,
    ...Am(e, l)
  }), l.duration && (l.duration = /* @__PURE__ */ Be(l.duration)), l.repeatDelay && (l.repeatDelay = /* @__PURE__ */ Be(l.repeatDelay)), l.from !== void 0 && (l.keyframes[0] = l.from);
  let f = !1;
  if ((l.type === !1 || l.duration === 0 && !l.repeatDelay) && (l.duration = 0, l.delay === 0 && (f = !0)), l.allowFlatten = !a.type && !a.ease, f && !o && t.get() !== void 0) {
    const d = Ur(l.keyframes, a);
    if (d !== void 0)
      return ue.update(() => {
        l.onUpdate(d), l.onComplete();
      }), new qu([]);
  }
  return !o && da.supports(l) ? new da(l) : new Qo(l);
};
function Mm({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function es(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: o = e.getDefaultTransition(), transitionEnd: s, ...a } = t;
  r && (o = r);
  const u = [], c = i && e.animationState && e.animationState.getState()[i];
  for (const l in a) {
    const f = e.getValue(l, e.latestValues[l] ?? null), d = a[l];
    if (d === void 0 || c && Mm(c, l))
      continue;
    const h = {
      delay: n,
      ...Oo(o || {}, l)
    };
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const x = Sc(e);
      if (x) {
        const m = window.MotionHandoffAnimation(x, l, ue);
        m !== null && (h.startTime = m, g = !0);
      }
    }
    Ki(e, l), f.start(Jo(l, f, d, e.shouldReduceMotion && yc.has(l) ? { type: !1 } : h, e, g));
    const p = f.animation;
    p && u.push(p);
  }
  return s && Promise.all(u).then(() => {
    ue.update(() => {
      s && dp(e, s);
    });
  }), u;
}
function ro(e, t, n = {}) {
  var u;
  const r = Ln(e, t, n.type === "exit" ? (u = e.presenceContext) == null ? void 0 : u.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(es(e, r, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: l = 0, staggerChildren: f, staggerDirection: d } = i;
    return km(e, t, l + c, f, d, n);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [c, l] = a === "beforeChildren" ? [o, s] : [s, o];
    return c().then(() => l());
  } else
    return Promise.all([o(), s(n.delay)]);
}
function km(e, t, n = 0, r = 0, i = 1, o) {
  const s = [], a = (e.variantChildren.size - 1) * r, u = i === 1 ? (c = 0) => c * r : (c = 0) => a - c * r;
  return Array.from(e.variantChildren).sort(Lm).forEach((c, l) => {
    c.notify("AnimationStart", t), s.push(ro(c, t, {
      ...o,
      delay: n + u(l)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function Lm(e, t) {
  return e.sortNodePosition(t);
}
function Nm(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => ro(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = ro(e, t, n);
  else {
    const i = typeof t == "function" ? Ln(e, t, n.custom) : t;
    r = Promise.all(es(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function Jc(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const Vm = ko.length;
function el(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? el(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < Vm; n++) {
    const r = ko[n], i = e.props[r];
    (In(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const Fm = [...Mo].reverse(), $m = Mo.length;
function Bm(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => Nm(e, n, r)));
}
function jm(e) {
  let t = Bm(e), n = ha(), r = !0;
  const i = (u) => (c, l) => {
    var d;
    const f = Ln(e, l, u === "exit" ? (d = e.presenceContext) == null ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: g, ...p } = f;
      c = { ...c, ...p, ...g };
    }
    return c;
  };
  function o(u) {
    t = u(e);
  }
  function s(u) {
    const { props: c } = e, l = el(e.parent) || {}, f = [], d = /* @__PURE__ */ new Set();
    let h = {}, g = 1 / 0;
    for (let x = 0; x < $m; x++) {
      const m = Fm[x], D = n[m], O = c[m] !== void 0 ? c[m] : l[m], w = In(O), y = m === u ? D.isActive : null;
      y === !1 && (g = x);
      let A = O === l[m] && O !== c[m] && w;
      if (A && r && e.manuallyAnimateOnMount && (A = !1), D.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !D.isActive && y === null || // If we didn't and don't have any defined prop for this animation type
      !O && !D.prevProp || // Or if the prop doesn't define an animation
      jr(O) || typeof O == "boolean")
        continue;
      const I = Wm(D.prevProp, O);
      let E = I || // If we're making this variant active, we want to always make it active
      m === u && D.isActive && !A && w || // If we removed a higher-priority variant (i is in reverse order)
      x > g && w, b = !1;
      const R = Array.isArray(O) ? O : [O];
      let L = R.reduce(i(m), {});
      y === !1 && (L = {});
      const { prevResolvedValues: $ = {} } = D, F = {
        ...$,
        ...L
      }, H = (z) => {
        E = !0, d.has(z) && (b = !0, d.delete(z)), D.needsAnimating[z] = !0;
        const M = e.getValue(z);
        M && (M.liveStyle = !1);
      };
      for (const z in F) {
        const M = L[z], _ = $[z];
        if (h.hasOwnProperty(z))
          continue;
        let S = !1;
        zi(M) && zi(_) ? S = !Jc(M, _) : S = M !== _, S ? M != null ? H(z) : d.add(z) : M !== void 0 && d.has(z) ? H(z) : D.protectedKeys[z] = !0;
      }
      D.prevProp = O, D.prevResolvedValues = L, D.isActive && (h = { ...h, ...L }), r && e.blockInitialAnimation && (E = !1), E && (!(A && I) || b) && f.push(...R.map((z) => ({
        animation: z,
        options: { type: m }
      })));
    }
    if (d.size) {
      const x = {};
      if (typeof c.initial != "boolean") {
        const m = Ln(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        m && m.transition && (x.transition = m.transition);
      }
      d.forEach((m) => {
        const D = e.getBaseTarget(m), O = e.getValue(m);
        O && (O.liveStyle = !0), x[m] = D ?? null;
      }), f.push({ animation: x });
    }
    let p = !!f.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (p = !1), r = !1, p ? t(f) : Promise.resolve();
  }
  function a(u, c) {
    var f;
    if (n[u].isActive === c)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((d) => {
      var h;
      return (h = d.animationState) == null ? void 0 : h.setActive(u, c);
    }), n[u].isActive = c;
    const l = s(u);
    for (const d in n)
      n[d].protectedKeys = {};
    return l;
  }
  return {
    animateChanges: s,
    setActive: a,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = ha(), r = !0;
    }
  };
}
function Wm(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Jc(t, e) : !1;
}
function Ot(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ha() {
  return {
    animate: Ot(!0),
    whileInView: Ot(),
    whileHover: Ot(),
    whileTap: Ot(),
    whileDrag: Ot(),
    whileFocus: Ot(),
    exit: Ot()
  };
}
class xt {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class Um extends xt {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = jm(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    jr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let Hm = 0;
class qm extends xt {
  constructor() {
    super(...arguments), this.id = Hm++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const zm = {
  animation: {
    Feature: Um
  },
  exit: {
    Feature: qm
  }
};
function Fn(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function zn(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const Km = (e) => (t) => Io(t) && e(t, zn(t));
function Cn(e, t, n, r) {
  return Fn(e, t, Km(n), r);
}
function tl({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Ym({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Gm(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
const nl = 1e-4, Xm = 1 - nl, Zm = 1 + nl, rl = 0.01, Qm = 0 - rl, Jm = 0 + rl;
function Oe(e) {
  return e.max - e.min;
}
function eg(e, t, n) {
  return Math.abs(e - t) <= n;
}
function pa(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = de(t.min, t.max, e.origin), e.scale = Oe(n) / Oe(t), e.translate = de(n.min, n.max, e.origin) - e.originPoint, (e.scale >= Xm && e.scale <= Zm || isNaN(e.scale)) && (e.scale = 1), (e.translate >= Qm && e.translate <= Jm || isNaN(e.translate)) && (e.translate = 0);
}
function Rn(e, t, n, r) {
  pa(e.x, t.x, n.x, r ? r.originX : void 0), pa(e.y, t.y, n.y, r ? r.originY : void 0);
}
function ma(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Oe(t);
}
function tg(e, t, n) {
  ma(e.x, t.x, n.x), ma(e.y, t.y, n.y);
}
function ga(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Oe(t);
}
function On(e, t, n) {
  ga(e.x, t.x, n.x), ga(e.y, t.y, n.y);
}
const va = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), en = () => ({
  x: va(),
  y: va()
}), ya = () => ({ min: 0, max: 0 }), me = () => ({
  x: ya(),
  y: ya()
});
function Fe(e) {
  return [e("x"), e("y")];
}
function bi(e) {
  return e === void 0 || e === 1;
}
function io({ scale: e, scaleX: t, scaleY: n }) {
  return !bi(e) || !bi(t) || !bi(n);
}
function It(e) {
  return io(e) || il(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function il(e) {
  return Sa(e.x) || Sa(e.y);
}
function Sa(e) {
  return e && e !== "0%";
}
function Ar(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function ba(e, t, n, r, i) {
  return i !== void 0 && (e = Ar(e, i, r)), Ar(e, n, r) + t;
}
function oo(e, t = 0, n = 1, r, i) {
  e.min = ba(e.min, t, n, r, i), e.max = ba(e.max, t, n, r, i);
}
function ol(e, { x: t, y: n }) {
  oo(e.x, t.translate, t.scale, t.originPoint), oo(e.y, n.translate, n.scale, n.originPoint);
}
const wa = 0.999999999999, Ta = 1.0000000000001;
function ng(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, s;
  for (let a = 0; a < i; a++) {
    o = n[a], s = o.projectionDelta;
    const { visualElement: u } = o.options;
    u && u.props.style && u.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && nn(e, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, ol(e, s)), r && It(o.latestValues) && nn(e, o.latestValues));
  }
  t.x < Ta && t.x > wa && (t.x = 1), t.y < Ta && t.y > wa && (t.y = 1);
}
function tn(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function xa(e, t, n, r, i = 0.5) {
  const o = de(e.min, e.max, i);
  oo(e, t, n, o, r);
}
function nn(e, t) {
  xa(e.x, t.x, t.scaleX, t.scale, t.originX), xa(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function sl(e, t) {
  return tl(Gm(e.getBoundingClientRect(), t));
}
function rg(e, t, n) {
  const r = sl(e, n), { scroll: i } = t;
  return i && (tn(r.x, i.offset.x), tn(r.y, i.offset.y)), r;
}
const al = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Ea = (e, t) => Math.abs(e - t);
function ig(e, t) {
  const n = Ea(e.x, t.x), r = Ea(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class ul {
  constructor(t, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: o = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = Ti(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, h = ig(f.offset, { x: 0, y: 0 }) >= 3;
      if (!d && !h)
        return;
      const { point: g } = f, { timestamp: p } = xe;
      this.history.push({ ...g, timestamp: p });
      const { onStart: x, onMove: m } = this.handlers;
      d || (x && x(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), m && m(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, d) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = wi(d, this.transformPagePoint), ue.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, d) => {
      this.end();
      const { onEnd: h, onSessionEnd: g, resumeAnimation: p } = this.handlers;
      if (this.dragSnapToOrigin && p && p(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const x = Ti(f.type === "pointercancel" ? this.lastMoveEventInfo : wi(d, this.transformPagePoint), this.history);
      this.startEvent && h && h(f, x), g && g(f, x);
    }, !Io(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const s = zn(t), a = wi(s, this.transformPagePoint), { point: u } = a, { timestamp: c } = xe;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: l } = n;
    l && l(t, Ti(a, this.history)), this.removeListeners = qn(Cn(this.contextWindow, "pointermove", this.handlePointerMove), Cn(this.contextWindow, "pointerup", this.handlePointerUp), Cn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), ut(this.updatePoint);
  }
}
function wi(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Pa(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ti({ point: e }, t) {
  return {
    point: e,
    delta: Pa(e, cl(t)),
    offset: Pa(e, og(t)),
    velocity: sg(t, 0.1)
  };
}
function og(e) {
  return e[0];
}
function cl(e) {
  return e[e.length - 1];
}
function sg(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = cl(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Be(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const o = /* @__PURE__ */ Qe(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function ag(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? de(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? de(n, e, r.max) : Math.min(e, n)), e;
}
function _a(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function ug(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: _a(e.x, n, i),
    y: _a(e.y, t, r)
  };
}
function Ca(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function cg(e, t) {
  return {
    x: Ca(e.x, t.x),
    y: Ca(e.y, t.y)
  };
}
function lg(e, t) {
  let n = 0.5;
  const r = Oe(e), i = Oe(t);
  return i > r ? n = /* @__PURE__ */ on(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ on(e.min, e.max - i, t.min)), ct(0, 1, n);
}
function fg(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const so = 0.35;
function dg(e = so) {
  return e === !1 ? e = 0 : e === !0 && (e = so), {
    x: Ra(e, "left", "right"),
    y: Ra(e, "top", "bottom")
  };
}
function Ra(e, t, n) {
  return {
    min: Oa(e, t),
    max: Oa(e, n)
  };
}
function Oa(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const hg = /* @__PURE__ */ new WeakMap();
class pg {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = me(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (l) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(zn(l).point);
    }, o = (l, f) => {
      const { drag: d, dragPropagation: h, onDragStart: g } = this.getProps();
      if (d && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = ph(d), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Fe((x) => {
        let m = this.getAxisMotionValue(x).get() || 0;
        if (et.test(m)) {
          const { projection: D } = this.visualElement;
          if (D && D.layout) {
            const O = D.layout.layoutBox[x];
            O && (m = Oe(O) * (parseFloat(m) / 100));
          }
        }
        this.originPoint[x] = m;
      }), g && ue.postRender(() => g(l, f)), Ki(this.visualElement, "transform");
      const { animationState: p } = this.visualElement;
      p && p.setActive("whileDrag", !0);
    }, s = (l, f) => {
      const { dragPropagation: d, dragDirectionLock: h, onDirectionLock: g, onDrag: p } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: x } = f;
      if (h && this.currentDirection === null) {
        this.currentDirection = mg(x), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, x), this.updateAxis("y", f.point, x), this.visualElement.render(), p && p(l, f);
    }, a = (l, f) => this.stop(l, f), u = () => Fe((l) => {
      var f;
      return this.getAnimationState(l) === "paused" && ((f = this.getAxisMotionValue(l).animation) == null ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new ul(t, {
      onSessionStart: i,
      onStart: o,
      onMove: s,
      onSessionEnd: a,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: al(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: o } = this.getProps();
    o && ue.postRender(() => o(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !cr(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = ag(s, this.constraints[t], this.elastic[t])), o.set(s);
  }
  resolveConstraints() {
    var o;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (o = this.visualElement.projection) == null ? void 0 : o.layout, i = this.constraints;
    t && Qt(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = ug(r.layoutBox, t) : this.constraints = !1, this.elastic = dg(n), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && Fe((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = fg(r.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Qt(t))
      return !1;
    const r = t.current;
    tt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = rg(r, i.root, this.visualElement.getTransformPagePoint());
    let s = cg(i.layout.layoutBox, o);
    if (n) {
      const a = n(Ym(s));
      this.hasMutatedConstraints = !!a, a && (s = tl(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), u = this.constraints || {}, c = Fe((l) => {
      if (!cr(l, n, this.currentDirection))
        return;
      let f = u && u[l] || {};
      s && (f = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, h = i ? 40 : 1e7, g = {
        type: "inertia",
        velocity: r ? t[l] : 0,
        bounceStiffness: d,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...f
      };
      return this.startAxisValueAnimation(l, g);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Ki(this.visualElement, t), r.start(Jo(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Fe((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Fe((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Fe((n) => {
      const { drag: r } = this.getProps();
      if (!cr(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: s, max: a } = i.layout.layoutBox[n];
        o.set(t[n] - de(s, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Qt(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Fe((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const u = a.get();
        i[s] = lg({ min: u, max: u }, this.constraints[s]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Fe((s) => {
      if (!cr(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: u, max: c } = this.constraints[s];
      a.set(de(u, c, i[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    hg.set(this.visualElement, this);
    const t = this.visualElement.current, n = Cn(t, "pointerdown", (u) => {
      const { drag: c, dragListener: l = !0 } = this.getProps();
      c && l && this.start(u);
    }), r = () => {
      const { dragConstraints: u } = this.getProps();
      Qt(u) && u.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), ue.read(r);
    const s = Fn(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: c }) => {
      this.isDragging && c && (Fe((l) => {
        const f = this.getAxisMotionValue(l);
        f && (this.originPoint[l] += u[l].translate, f.set(f.get() + u[l].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), o(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: s = so, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function cr(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function mg(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class gg extends xt {
  constructor(t) {
    super(t), this.removeGroupControls = $e, this.removeListeners = $e, this.controls = new pg(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || $e;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Da = (e) => (t, n) => {
  e && ue.postRender(() => e(t, n));
};
class vg extends xt {
  constructor() {
    super(...arguments), this.removePointerDownListener = $e;
  }
  onPointerDown(t) {
    this.session = new ul(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: al(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Da(t),
      onStart: Da(n),
      onMove: r,
      onEnd: (o, s) => {
        delete this.session, i && ue.postRender(() => i(o, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Cn(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Tr = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Aa(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const vn = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (J.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Aa(e, t.target.x), r = Aa(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, yg = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = wt.parse(e);
    if (i.length > 5)
      return r;
    const o = wt.createTransformer(e), s = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * t.x, u = n.y.scale * t.y;
    i[0 + s] /= a, i[1 + s] /= u;
    const c = de(a, u, 0.5);
    return typeof i[2 + s] == "number" && (i[2 + s] /= c), typeof i[3 + s] == "number" && (i[3 + s] /= c), o(i);
  }
};
class Sg extends Nf {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    Bh(bg), o && (n.group && n.group.add(o), r && r.register && i && r.register(o), o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), Tr.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, s = r.projection;
    return s && (s.isPresent = o, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? s.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? s.promote() : s.relegate() || ue.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), Ao.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function ll(e) {
  const [t, n] = Wu(), r = be(To);
  return N(Sg, { ...e, layoutGroup: r, switchLayoutGroup: be(oc), isPresent: t, safeToRemove: n });
}
const bg = {
  borderRadius: {
    ...vn,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: vn,
  borderTopRightRadius: vn,
  borderBottomLeftRadius: vn,
  borderBottomRightRadius: vn,
  boxShadow: yg
};
function fl(e, t, n) {
  const r = Te(e) ? e : sn(e);
  return r.start(Jo("", r, t, n)), r.animation;
}
function dl(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const wg = (e, t) => e.depth - t.depth;
class Tg {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Po(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Fr(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(wg), this.isDirty = !1, this.children.forEach(t);
  }
}
function xg(e, t) {
  const n = Je.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (ut(r), e(o - t));
  };
  return ue.read(r, !0), () => ut(r);
}
const hl = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Eg = hl.length, Ia = (e) => typeof e == "string" ? parseFloat(e) : e, Ma = (e) => typeof e == "number" || J.test(e);
function Pg(e, t, n, r, i, o) {
  i ? (e.opacity = de(0, n.opacity ?? 1, _g(r)), e.opacityExit = de(t.opacity ?? 1, 0, Cg(r))) : o && (e.opacity = de(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let s = 0; s < Eg; s++) {
    const a = `border${hl[s]}Radius`;
    let u = ka(t, a), c = ka(n, a);
    if (u === void 0 && c === void 0)
      continue;
    u || (u = 0), c || (c = 0), u === 0 || c === 0 || Ma(u) === Ma(c) ? (e[a] = Math.max(de(Ia(u), Ia(c), r), 0), (et.test(c) || et.test(u)) && (e[a] += "%")) : e[a] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = de(t.rotate || 0, n.rotate || 0, r));
}
function ka(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const _g = /* @__PURE__ */ pl(0, 0.5, _c), Cg = /* @__PURE__ */ pl(0.5, 0.95, $e);
function pl(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ on(e, t, r));
}
function La(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ve(e, t) {
  La(e.x, t.x), La(e.y, t.y);
}
function Na(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function Va(e, t, n, r, i) {
  return e -= t, e = Ar(e, 1 / n, r), i !== void 0 && (e = Ar(e, 1 / i, r)), e;
}
function Rg(e, t = 0, n = 1, r = 0.5, i, o = e, s = e) {
  if (et.test(t) && (t = parseFloat(t), t = de(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = de(o.min, o.max, r);
  e === o && (a -= t), e.min = Va(e.min, t, n, a, i), e.max = Va(e.max, t, n, a, i);
}
function Fa(e, t, [n, r, i], o, s) {
  Rg(e, t[n], t[r], t[i], t.scale, o, s);
}
const Og = ["x", "scaleX", "originX"], Dg = ["y", "scaleY", "originY"];
function $a(e, t, n, r) {
  Fa(e.x, t, Og, n ? n.x : void 0, r ? r.x : void 0), Fa(e.y, t, Dg, n ? n.y : void 0, r ? r.y : void 0);
}
function Ba(e) {
  return e.translate === 0 && e.scale === 1;
}
function ml(e) {
  return Ba(e.x) && Ba(e.y);
}
function ja(e, t) {
  return e.min === t.min && e.max === t.max;
}
function Ag(e, t) {
  return ja(e.x, t.x) && ja(e.y, t.y);
}
function Wa(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function gl(e, t) {
  return Wa(e.x, t.x) && Wa(e.y, t.y);
}
function Ua(e) {
  return Oe(e.x) / Oe(e.y);
}
function Ha(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class Ig {
  constructor() {
    this.members = [];
  }
  add(t) {
    Po(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Fr(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        r = o;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Mg(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((i || o || s) && (r = `translate3d(${i}px, ${o}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: l, rotateX: f, rotateY: d, skewX: h, skewY: g } = n;
    c && (r = `perspective(${c}px) ${r}`), l && (r += `rotate(${l}deg) `), f && (r += `rotateX(${f}deg) `), d && (r += `rotateY(${d}deg) `), h && (r += `skewX(${h}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const a = e.x.scale * t.x, u = e.y.scale * t.y;
  return (a !== 1 || u !== 1) && (r += `scale(${a}, ${u})`), r || "none";
}
const xi = ["", "X", "Y", "Z"], kg = { visibility: "hidden" }, qa = 1e3;
let Lg = 0;
function Ei(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function vl(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Sc(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ue, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && vl(r);
}
function yl({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = Lg++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Fg), this.nodes.forEach(Ug), this.nodes.forEach(Hg), this.nodes.forEach($g);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let u = 0; u < this.path.length; u++)
        this.path[u].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Tg());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Co()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const u = this.eventHandlers.get(s);
      u && u.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = dl(s), this.instance = s;
      const { layoutId: u, layout: c, visualElement: l } = this.options;
      if (l && !l.current && l.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (c || u) && (this.isLayoutDirty = !0), e) {
        let f;
        const d = () => this.root.updateBlockedByResize = !1;
        e(s, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = xg(d, 250), Tr.hasAnimatedSinceResize && (Tr.hasAnimatedSinceResize = !1, this.nodes.forEach(Ka));
        });
      }
      u && this.root.registerSharedNode(u, this), this.options.animate !== !1 && l && (u || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: d, hasRelativeLayoutChanged: h, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || l.getDefaultTransition() || Gg, { onLayoutAnimationStart: x, onLayoutAnimationComplete: m } = l.getProps(), D = !this.targetLayout || !gl(this.targetLayout, g), O = !d && h;
        if (this.options.layoutRoot || this.resumeFrom || O || d && (D || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, O);
          const w = {
            ...Oo(p, "layout"),
            onPlay: x,
            onComplete: m
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w);
        } else
          d || Ka(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, ut(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(qg), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && vl(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let l = 0; l < this.path.length; l++) {
        const f = this.path[l];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: a, layout: u } = this.options;
      if (a === void 0 && !u)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(za);
        return;
      }
      this.isUpdating || this.nodes.forEach(jg), this.isUpdating = !1, this.nodes.forEach(Wg), this.nodes.forEach(Ng), this.nodes.forEach(Vg), this.clearAllSnapshots();
      const a = Je.now();
      xe.delta = ct(0, 1e3 / 60, a - xe.timestamp), xe.timestamp = a, xe.isProcessing = !0, mi.update.process(xe), mi.preRender.process(xe), mi.render.process(xe), xe.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Ao.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Bg), this.sharedNodes.forEach(zg);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ue.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ue.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Oe(this.snapshot.measuredBox.x) && !Oe(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let u = 0; u < this.path.length; u++)
          this.path[u].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = me(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a) {
        const u = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: u,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : u
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !ml(this.projectionDelta), u = this.getTransformTemplate(), c = u ? u(this.latestValues, "") : void 0, l = c !== this.prevTransformTemplateValue;
      s && (a || It(this.latestValues) || l) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let u = this.removeElementScroll(a);
      return s && (u = this.removeTransform(u)), Xg(u), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: u,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var c;
      const { visualElement: s } = this.options;
      if (!s)
        return me();
      const a = s.measureViewportBox();
      if (!(((c = this.scroll) == null ? void 0 : c.wasRoot) || this.path.some(Zg))) {
        const { scroll: l } = this.root;
        l && (tn(a.x, l.offset.x), tn(a.y, l.offset.y));
      }
      return a;
    }
    removeElementScroll(s) {
      var u;
      const a = me();
      if (Ve(a, s), (u = this.scroll) != null && u.wasRoot)
        return a;
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c], { scroll: f, options: d } = l;
        l !== this.root && f && d.layoutScroll && (f.wasRoot && Ve(a, s), tn(a.x, f.offset.x), tn(a.y, f.offset.y));
      }
      return a;
    }
    applyTransform(s, a = !1) {
      const u = me();
      Ve(u, s);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        !a && l.options.layoutScroll && l.scroll && l !== l.root && nn(u, {
          x: -l.scroll.offset.x,
          y: -l.scroll.offset.y
        }), It(l.latestValues) && nn(u, l.latestValues);
      }
      return It(this.latestValues) && nn(u, this.latestValues), u;
    }
    removeTransform(s) {
      const a = me();
      Ve(a, s);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        if (!c.instance || !It(c.latestValues))
          continue;
        io(c.latestValues) && c.updateSnapshot();
        const l = me(), f = c.measurePageBox();
        Ve(l, f), $a(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, l);
      }
      return It(this.latestValues) && $a(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== xe.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var d;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== a;
      if (!(s || u && this.isSharedProjectionDirty || this.isProjectionDirty || (d = this.parent) != null && d.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: l, layoutId: f } = this.options;
      if (!(!this.layout || !(l || f))) {
        if (this.resolvedRelativeTargetAt = xe.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = me(), this.relativeTargetOrigin = me(), On(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), Ve(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = me(), this.targetWithTransforms = me()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), tg(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ve(this.target, this.layout.layoutBox), ol(this.target, this.targetDelta)) : Ve(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const h = this.getClosestProjectingParent();
          h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = me(), this.relativeTargetOrigin = me(), On(this.relativeTargetOrigin, this.target, h.target), Ve(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || io(this.parent.latestValues) || il(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var g;
      const s = this.getLead(), a = !!this.resumingFrom || this !== s;
      let u = !0;
      if ((this.isProjectionDirty || (g = this.parent) != null && g.isProjectionDirty) && (u = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === xe.timestamp && (u = !1), u)
        return;
      const { layout: c, layoutId: l } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || l))
        return;
      Ve(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, d = this.treeScale.y;
      ng(this.layoutCorrected, this.treeScale, this.path, a), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = me());
      const { target: h } = s;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Na(this.prevProjectionDelta.x, this.projectionDelta.x), Na(this.prevProjectionDelta.y, this.projectionDelta.y)), Rn(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== d || !Ha(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ha(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), s) {
        const u = this.getStack();
        u && u.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = en(), this.projectionDelta = en(), this.projectionDeltaWithTransform = en();
    }
    setAnimationOrigin(s, a = !1) {
      const u = this.snapshot, c = u ? u.latestValues : {}, l = { ...this.latestValues }, f = en();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const d = me(), h = u ? u.source : void 0, g = this.layout ? this.layout.source : void 0, p = h !== g, x = this.getStack(), m = !x || x.members.length <= 1, D = !!(p && !m && this.options.crossfade === !0 && !this.path.some(Yg));
      this.animationProgress = 0;
      let O;
      this.mixTargetDelta = (w) => {
        const y = w / 1e3;
        Ya(f.x, s.x, y), Ya(f.y, s.y, y), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (On(d, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Kg(this.relativeTarget, this.relativeTargetOrigin, d, y), O && Ag(this.relativeTarget, O) && (this.isProjectionDirty = !1), O || (O = me()), Ve(O, this.relativeTarget)), p && (this.animationValues = l, Pg(l, c, this.latestValues, y, D, m)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = y;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (ut(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ue.update(() => {
        Tr.hasAnimatedSinceResize = !0, this.currentAnimation = fl(0, qa, {
          ...s,
          onUpdate: (a) => {
            this.mixTargetDelta(a), s.onUpdate && s.onUpdate(a);
          },
          onStop: () => {
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(qa), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: u, layout: c, latestValues: l } = s;
      if (!(!a || !u || !c)) {
        if (this !== s && this.layout && c && Sl(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          u = this.target || me();
          const f = Oe(this.layout.layoutBox.x);
          u.x.min = s.target.x.min, u.x.max = u.x.min + f;
          const d = Oe(this.layout.layoutBox.y);
          u.y.min = s.target.y.min, u.y.max = u.y.min + d;
        }
        Ve(a, u), nn(a, l), Rn(this.projectionDeltaWithTransform, this.layoutCorrected, a, l);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new Ig()), this.sharedNodes.get(s).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: u } = {}) {
      const c = this.getStack();
      c && c.promote(this, u), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: u } = s;
      if ((u.z || u.rotate || u.rotateX || u.rotateY || u.rotateZ || u.skewX || u.skewY) && (a = !0), !a)
        return;
      const c = {};
      u.z && Ei("z", s, c, this.animationValues);
      for (let l = 0; l < xi.length; l++)
        Ei(`rotate${xi[l]}`, s, c, this.animationValues), Ei(`skew${xi[l]}`, s, c, this.animationValues);
      s.render();
      for (const l in c)
        s.setStaticValue(l, c[l]), this.animationValues && (this.animationValues[l] = c[l]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return kg;
      const a = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, a.opacity = "", a.pointerEvents = wr(s == null ? void 0 : s.pointerEvents) || "", a.transform = u ? u(this.latestValues, "") : "none", a;
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        const h = {};
        return this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = wr(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !It(this.latestValues) && (h.transform = u ? u({}, "") : "none", this.hasProjected = !1), h;
      }
      const l = c.animationValues || c.latestValues;
      this.applyTransformsToTarget(), a.transform = Mg(this.projectionDeltaWithTransform, this.treeScale, l), u && (a.transform = u(l, a.transform));
      const { x: f, y: d } = this.projectionDelta;
      a.transformOrigin = `${f.origin * 100}% ${d.origin * 100}% 0`, c.animationValues ? a.opacity = c === this ? l.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : l.opacityExit : a.opacity = c === this ? l.opacity !== void 0 ? l.opacity : "" : l.opacityExit !== void 0 ? l.opacityExit : 0;
      for (const h in Mn) {
        if (l[h] === void 0)
          continue;
        const { correct: g, applyTo: p, isCSSVariable: x } = Mn[h], m = a.transform === "none" ? l[h] : g(l[h], c);
        if (p) {
          const D = p.length;
          for (let O = 0; O < D; O++)
            a[p[O]] = m;
        } else
          x ? this.options.visualElement.renderState.vars[h] = m : a[h] = m;
      }
      return this.options.layoutId && (a.pointerEvents = c === this ? wr(s == null ? void 0 : s.pointerEvents) || "" : "none"), a;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(za), this.root.sharedNodes.clear();
    }
  };
}
function Ng(e) {
  e.updateLayout();
}
function Vg(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: o } = e.options, s = t.source !== e.layout.source;
    o === "size" ? Fe((f) => {
      const d = s ? t.measuredBox[f] : t.layoutBox[f], h = Oe(d);
      d.min = r[f].min, d.max = d.min + h;
    }) : Sl(o, t.layoutBox, r) && Fe((f) => {
      const d = s ? t.measuredBox[f] : t.layoutBox[f], h = Oe(r[f]);
      d.max = d.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + h);
    });
    const a = en();
    Rn(a, r, t.layoutBox);
    const u = en();
    s ? Rn(u, e.applyTransform(i, !0), t.measuredBox) : Rn(u, r, t.layoutBox);
    const c = !ml(a);
    let l = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: d, layout: h } = f;
        if (d && h) {
          const g = me();
          On(g, t.layoutBox, d.layoutBox);
          const p = me();
          On(p, r, h.layoutBox), gl(g, p) || (l = !0), f.options.layoutRoot && (e.relativeTarget = p, e.relativeTargetOrigin = g, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: u,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: l
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function Fg(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function $g(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Bg(e) {
  e.clearSnapshot();
}
function za(e) {
  e.clearMeasurements();
}
function jg(e) {
  e.isLayoutDirty = !1;
}
function Wg(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Ka(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Ug(e) {
  e.resolveTargetDelta();
}
function Hg(e) {
  e.calcProjection();
}
function qg(e) {
  e.resetSkewAndRotation();
}
function zg(e) {
  e.removeLeadSnapshot();
}
function Ya(e, t, n) {
  e.translate = de(t.translate, 0, n), e.scale = de(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Ga(e, t, n, r) {
  e.min = de(t.min, n.min, r), e.max = de(t.max, n.max, r);
}
function Kg(e, t, n, r) {
  Ga(e.x, t.x, n.x, r), Ga(e.y, t.y, n.y, r);
}
function Yg(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Gg = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Xa = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Za = Xa("applewebkit/") && !Xa("chrome/") ? Math.round : $e;
function Qa(e) {
  e.min = Za(e.min), e.max = Za(e.max);
}
function Xg(e) {
  Qa(e.x), Qa(e.y);
}
function Sl(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !eg(Ua(t), Ua(n), 0.2);
}
function Zg(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Qg = yl({
  attachResizeListener: (e, t) => Fn(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Pi = {
  current: void 0
}, bl = yl({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Pi.current) {
      const e = new Qg({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Pi.current = e;
    }
    return Pi.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Jg = {
  pan: {
    Feature: vg
  },
  drag: {
    Feature: gg,
    ProjectionNode: bl,
    MeasureLayout: ll
  }
};
function Ja(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && ue.postRender(() => o(t, zn(t)));
}
class ev extends xt {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = mh(t, (n, r) => (Ja(this.node, r, "Start"), (i) => Ja(this.node, i, "End"))));
  }
  unmount() {
  }
}
class tv extends xt {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = qn(Fn(this.node.current, "focus", () => this.onFocus()), Fn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function eu(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && ue.postRender(() => o(t, zn(t)));
}
class nv extends xt {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = Sh(t, (n, r) => (eu(this.node, r, "Start"), (i, { success: o }) => eu(this.node, i, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const ao = /* @__PURE__ */ new WeakMap(), _i = /* @__PURE__ */ new WeakMap(), rv = (e) => {
  const t = ao.get(e.target);
  t && t(e);
}, iv = (e) => {
  e.forEach(rv);
};
function ov({ root: e, ...t }) {
  const n = e || document;
  _i.has(n) || _i.set(n, {});
  const r = _i.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(iv, { root: e, ...t })), r[i];
}
function sv(e, t, n) {
  const r = ov(t);
  return ao.set(e, n), r.observe(e), () => {
    ao.delete(e), r.unobserve(e);
  };
}
const av = {
  some: 0,
  all: 1
};
class uv extends xt {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : av[i]
    }, a = (u) => {
      const { isIntersecting: c } = u;
      if (this.isInView === c || (this.isInView = c, o && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: l, onViewportLeave: f } = this.node.getProps(), d = c ? l : f;
      d && d(u);
    };
    return sv(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(cv(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function cv({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const lv = {
  inView: {
    Feature: uv
  },
  tap: {
    Feature: nv
  },
  focus: {
    Feature: tv
  },
  hover: {
    Feature: ev
  }
}, fv = {
  layout: {
    ProjectionNode: bl,
    MeasureLayout: ll
  }
}, Ir = { current: null }, ts = { current: !1 };
function wl() {
  if (ts.current = !0, !!xo)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Ir.current = e.matches;
      e.addListener(t), t();
    } else
      Ir.current = !1;
}
const dv = [...jc, Pe, wt], hv = (e) => dv.find(Bc(e)), $n = /* @__PURE__ */ new WeakMap();
function pv(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (Te(i))
      e.addValue(r, i), process.env.NODE_ENV === "development" && Wn(i.version === "12.7.2", `Attempting to mix Motion versions ${i.version} with 12.7.2 may not work as expected.`);
    else if (Te(o))
      e.addValue(r, sn(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(i) : s.hasAnimated || s.set(i);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, sn(s !== void 0 ? s : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const tu = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Tl {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: o, visualState: s }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Xo, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const h = Je.now();
      this.renderScheduledAt < h && (this.renderScheduledAt = h, ue.render(this.render, !1, !0));
    };
    const { latestValues: u, renderState: c, onUpdate: l } = s;
    this.onUpdate = l, this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = n.initial ? { ...u } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!o, this.isControllingVariants = Wr(n), this.isVariantNode = rc(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const h in d) {
      const g = d[h];
      u[h] !== void 0 && Te(g) && g.set(u[h], !1);
    }
  }
  mount(t) {
    this.current = t, $n.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), ts.current || wl(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ir.current, process.env.NODE_ENV !== "production" && Wn(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), ut(this.notifyUpdate), ut(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = $t.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && ue.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o(), s && s(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in an) {
      const n = an[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : me();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < tu.length; r++) {
      const i = tu[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, s = t[o];
      s && (this.propEventSubscriptions[i] = this.on(i, s));
    }
    this.prevMotionValues = pv(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = sn(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Fc(r) || Rc(r)) ? r = parseFloat(r) : !hv(r) && wt.test(n) && (r = Lc(t, n)), this.setBaseTarget(t, Te(r) ? r.get() : r)), Te(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var o;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = Ho(this.props, n, (o = this.presenceContext) == null ? void 0 : o.custom);
      s && (r = s[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Te(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Co()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class xl extends Tl {
  constructor() {
    super(...arguments), this.KeyframeResolver = Wc;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Te(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function mv(e) {
  return window.getComputedStyle(e);
}
class El extends xl {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = pc;
  }
  readValueFromInstance(t, n) {
    if ($t.has(n))
      return Vp(t, n);
    {
      const r = mv(t), i = (No(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return sl(t, n);
  }
  build(t, n, r) {
    $o(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return qo(t, n, r);
  }
}
class Pl extends xl {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = me, this.updateDimensions = () => {
      this.current && !this.renderState.dimensions && hc(this.current, this.renderState);
    };
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if ($t.has(n)) {
      const r = kc(n);
      return r && r.default || 0;
    }
    return n = mc.has(n) ? n : Lo(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return vc(t, n, r);
  }
  onBindTransform() {
    this.current && !this.renderState.dimensions && ue.postRender(this.updateDimensions);
  }
  build(t, n, r) {
    Wo(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, i) {
    gc(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = Uo(t.tagName), super.mount(t);
  }
}
const gv = (e, t) => jo(e) ? new Pl(t) : new El(t, {
  allowProjection: e !== vo
}), vv = /* @__PURE__ */ lp({
  ...zm,
  ...lv,
  ...Jg,
  ...fv
}, gv), qe = /* @__PURE__ */ _h(vv);
function uo(e) {
  const t = jn(() => sn(e)), { isStatic: n } = be(Vr);
  if (n) {
    const [, r] = we(e);
    Ce(() => t.on("change", r), []);
  }
  return t;
}
function _l(e, t) {
  const n = uo(t()), r = () => n.set(t());
  return r(), Eo(() => {
    const i = () => ue.preRender(r, !1, !0), o = e.map((s) => s.on("change", i));
    return () => {
      o.forEach((s) => s()), ut(r);
    };
  }), n;
}
const yv = (e) => e && typeof e == "object" && e.mix, Sv = (e) => yv(e) ? e.mix : void 0;
function xr(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], i = e[1 + n], o = e[2 + n], s = e[3 + n], a = Gc(i, o, {
    mixer: Sv(o[0]),
    ...s
  });
  return t ? a(r) : a;
}
function bv(e) {
  En.current = [], e();
  const t = _l(En.current, e);
  return En.current = void 0, t;
}
function Mr(e, t, n, r) {
  if (typeof e == "function")
    return bv(e);
  const i = typeof t == "function" ? t : xr(t, n, r);
  return Array.isArray(e) ? nu(e, i) : nu([e], ([o]) => i(o));
}
function nu(e, t) {
  const n = jn(() => []);
  return _l(e, () => {
    n.length = 0;
    const r = e.length;
    for (let i = 0; i < r; i++)
      n[i] = e[i].get();
    return t(n);
  });
}
function wv() {
  !ts.current && wl();
  const [e] = we(Ir.current);
  return process.env.NODE_ENV !== "production" && Wn(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), e;
}
const Tv = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function Cl(e, t) {
  return Yc(e) ? e[Tv(0, e.length, t)] : e;
}
function ns(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function Rl(e, t, n, r) {
  return typeof e == "string" && ns(t) ? Qu(e, n, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e];
}
function xv(e, t, n) {
  return e * (t + 1);
}
function ru(e, t, n, r) {
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : r.get(t) ?? e;
}
function Ev(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    i.at > t && i.at < n && (Fr(e, i), r--);
  }
}
function Pv(e, t, n, r, i, o) {
  Ev(e, i, o);
  for (let s = 0; s < t.length; s++)
    e.push({
      value: t[s],
      at: de(i, o, r[s]),
      easing: Cl(n, s)
    });
}
function _v(e, t) {
  for (let n = 0; n < e.length; n++)
    e[n] = e[n] / (t + 1);
}
function Cv(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const Rv = "easeInOut", Ov = 20;
function Dv(e, { defaultTransition: t = {}, ...n } = {}, r, i) {
  const o = t.duration || 0.3, s = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), u = {}, c = /* @__PURE__ */ new Map();
  let l = 0, f = 0, d = 0;
  for (let h = 0; h < e.length; h++) {
    const g = e[h];
    if (typeof g == "string") {
      c.set(g, f);
      continue;
    } else if (!Array.isArray(g)) {
      c.set(g.name, ru(f, g.at, l, c));
      continue;
    }
    let [p, x, m = {}] = g;
    m.at !== void 0 && (f = ru(f, m.at, l, c));
    let D = 0;
    const O = (w, y, A, I = 0, E = 0) => {
      const b = Av(w), { delay: R = 0, times: L = Zc(b), type: $ = "keyframes", repeat: F, repeatType: H, repeatDelay: X = 0, ...K } = y;
      let { ease: z = t.ease || "easeOut", duration: M } = y;
      const _ = typeof R == "function" ? R(I, E) : R, S = b.length, P = $r($) ? $ : i == null ? void 0 : i[$];
      if (S <= 2 && P) {
        let k = 100;
        if (S === 2 && kv(b)) {
          const q = b[1] - b[0];
          k = Math.abs(q);
        }
        const B = { ...K };
        M !== void 0 && (B.duration = /* @__PURE__ */ Be(M));
        const j = Yu(B, k, P);
        z = j.ease, M = j.duration;
      }
      M ?? (M = o);
      const v = f + _;
      L.length === 1 && L[0] === 0 && (L[1] = 1);
      const T = L.length - b.length;
      if (T > 0 && Xc(L, T), b.length === 1 && b.unshift(null), F) {
        tt(F < Ov, "Repeat count too high, must be less than 20"), M = xv(M, F);
        const k = [...b], B = [...L];
        z = Array.isArray(z) ? [...z] : [z];
        const j = [...z];
        for (let q = 0; q < F; q++) {
          b.push(...k);
          for (let Y = 0; Y < k.length; Y++)
            L.push(B[Y] + (q + 1)), z.push(Y === 0 ? "linear" : Cl(j, Y - 1));
        }
        _v(L, F);
      }
      const C = v + M;
      Pv(A, b, z, L, v, C), D = Math.max(_ + M, D), d = Math.max(C, d);
    };
    if (Te(p)) {
      const w = iu(p, a);
      O(x, m, ou("default", w));
    } else {
      const w = Rl(p, x, r, u), y = w.length;
      for (let A = 0; A < y; A++) {
        x = x, m = m;
        const I = w[A], E = iu(I, a);
        for (const b in x)
          O(x[b], Iv(m, b), ou(b, E), A, y);
      }
    }
    l = f, f += D;
  }
  return a.forEach((h, g) => {
    for (const p in h) {
      const x = h[p];
      x.sort(Cv);
      const m = [], D = [], O = [];
      for (let y = 0; y < x.length; y++) {
        const { at: A, value: I, easing: E } = x[y];
        m.push(I), D.push(/* @__PURE__ */ on(0, d, A)), O.push(E || "easeOut");
      }
      D[0] !== 0 && (D.unshift(0), m.unshift(m[0]), O.unshift(Rv)), D[D.length - 1] !== 1 && (D.push(1), m.push(null)), s.has(g) || s.set(g, {
        keyframes: {},
        transition: {}
      });
      const w = s.get(g);
      w.keyframes[p] = m, w.transition[p] = {
        ...t,
        duration: d,
        ease: O,
        times: D,
        ...n
      };
    }
  }), s;
}
function iu(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function ou(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function Av(e) {
  return Array.isArray(e) ? e : [e];
}
function Iv(e, t) {
  return e && e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const Mv = (e) => typeof e == "number", kv = (e) => e.every(Mv);
function Lv(e, t) {
  return e in t;
}
class Nv extends Tl {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, n) {
    if (Lv(n, t)) {
      const r = t[n];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, n) {
    delete n.output[t];
  }
  measureInstanceViewportBox() {
    return me();
  }
  build(t, n) {
    Object.assign(t.output, n);
  }
  renderInstance(t, { output: n }) {
    Object.assign(t, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function Vv(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = dl(e) ? new Pl(t) : new El(t);
  n.mount(e), $n.set(e, n);
}
function Fv(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new Nv(t);
  n.mount(e), $n.set(e, n);
}
function $v(e, t) {
  return Te(e) || typeof e == "number" || typeof e == "string" && !ns(t);
}
function Ol(e, t, n, r) {
  const i = [];
  if ($v(e, t))
    i.push(fl(e, ns(t) && t.default || t, n && (n.default || n)));
  else {
    const o = Rl(e, t, r), s = o.length;
    tt(!!s, "No valid elements provided.");
    for (let a = 0; a < s; a++) {
      const u = o[a], c = u instanceof Element ? Vv : Fv;
      $n.has(u) || c(u);
      const l = $n.get(u), f = { ...n };
      "delay" in f && typeof f.delay == "function" && (f.delay = f.delay(a, s)), i.push(...es(l, { ...t, transition: f }, {}));
    }
  }
  return i;
}
function Bv(e, t, n) {
  const r = [];
  return Dv(e, t, n, { spring: Vn }).forEach(({ keyframes: o, transition: s }, a) => {
    r.push(...Ol(a, o, s));
  }), r;
}
function jv(e) {
  return Array.isArray(e) && e.some(Array.isArray);
}
function Wv(e) {
  function t(n, r, i) {
    let o = [];
    return jv(n) ? o = Bv(n, r, e) : o = Ol(n, r, i, e), new qu(o);
  }
  return t;
}
const su = Wv();
var au = "calc(100% - env(safe-area-inset-top) - 34px)", Bn = typeof window > "u", Uv = {
  ease: "easeOut",
  duration: 0.2
}, Hv = {
  ease: "linear",
  duration: 0.01
}, qv = 0.6, zv = 500, Kn = Bn ? Ce : cn;
function Kv({
  y: e,
  rootId: t,
  sheetRef: n
}) {
  const r = fe(Bn ? 0 : window.innerHeight);
  function i() {
    const s = document.querySelector(`#${t}`), a = document.querySelector("body");
    s && (a.style.backgroundColor = "#000", s.style.overflow = "hidden", s.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", s.style.transitionProperty = "transform, border-radius", s.style.transitionDuration = "0.5s", s.style.transformOrigin = "center top");
  }
  function o() {
    const s = document.querySelector(`#${t}`), a = document.querySelector("body");
    s && setTimeout(() => {
      a.style.removeProperty("background-color"), s.style.removeProperty("overflow"), s.style.removeProperty("transition-timing-function"), s.style.removeProperty("transition-property"), s.style.removeProperty("transition-duration"), s.style.removeProperty("transform-origin"), s.style.removeProperty("transform"), s.style.removeProperty("border-top-right-radius"), s.style.removeProperty("border-top-left-radius");
    }, 100);
  }
  Kn(() => () => {
    t && o();
  }, []), Ce(() => {
    const s = document.querySelector(`#${t}`);
    if (!s) return;
    function a() {
      e.get() - 10 >= r.current && o();
    }
    const u = e.on("animationStart", () => {
      var d;
      r.current = ((d = n.current) == null ? void 0 : d.offsetHeight) || window.innerHeight, i();
    }), c = e.on("change", (d) => {
      if (s) {
        const h = Math.max(0, 1 - d / r.current), g = window.innerWidth, p = (g - 16) / g, x = xr(h, [0, 1], [0, 24]), m = xr(h, [0, 1], [1, p]), D = xr(h, [0, 1], [0, 10]), O = "env(safe-area-inset-top)";
        s.style.transform = `scale(${m}) translate3d(0, calc(${O} + ${x}px), 0)`, s.style.borderTopRightRadius = `${D}px`, s.style.borderTopLeftRadius = `${D}px`;
      }
    }), l = e.on("animationComplete", a), f = e.on("animationCancel", a);
    return () => {
      u(), c(), l(), f();
    };
  }, [e, t]);
}
function Yv(e, t) {
  const n = Xv(e), r = fe(!1), i = ke(() => {
    var o, s, a, u;
    r.current ? ((u = (a = t.current).onCloseEnd) == null || u.call(a), r.current = !1) : ((s = (o = t.current).onOpenEnd) == null || s.call(o), r.current = !0);
  }, [e, n]);
  return Ce(() => {
    var o, s, a, u;
    !n && e ? (s = (o = t.current).onOpenStart) == null || s.call(o) : !e && n && ((u = (a = t.current).onCloseStart) == null || u.call(a));
  }, [e, n]), { handleAnimationComplete: i };
}
function Gv() {
  const [e, t] = we({
    height: Bn ? 0 : window.innerHeight,
    width: Bn ? 0 : window.innerWidth
  });
  return Kn(() => {
    function n() {
      t({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), e;
}
function Xv(e) {
  const t = fe(void 0);
  return Ce(() => {
    t.current = e;
  }), t.current;
}
function Ci(e) {
  const t = fe(void 0);
  return Kn(() => {
    t.current = e;
  }), ke((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
var Zv = { bottom: 0, top: 0, left: 0, right: 0 };
function Dl() {
  const e = fe(null), t = ke(() => Zv, []);
  return { constraintsRef: e, onMeasureDragConstraints: t };
}
var Al = Tt(
  void 0
), Hr = () => {
  const e = be(Al);
  if (!e) throw new Error("Sheet context error");
  return e;
}, Il = Tt(void 0);
function Qv({
  children: e
}) {
  const t = Hr(), [n, r] = we(!!t.disableDrag);
  function i() {
    t.disableDrag || r(!1);
  }
  function o() {
    n || r(!0);
  }
  return /* @__PURE__ */ W.createElement(
    Il.Provider,
    {
      value: { disableDrag: n, setDragEnabled: i, setDragDisabled: o }
    },
    e
  );
}
var Ml = () => {
  const e = be(Il);
  if (!e) throw new Error("Sheet scroller context error");
  return e;
};
function uu(e, t) {
  let n = e[0], r = Math.abs(e[0] - t);
  for (let i = 1; i < e.length; i++) {
    const o = Math.abs(e[i] - t);
    o < r && (n = e[i], r = o);
  }
  return n;
}
function Jv(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t + 1] > e[t]) return !1;
  return !0;
}
function cu({
  snapTo: e,
  sheetHeight: t
}) {
  return e < 0 && console.warn(
    `Snap point is out of bounds. Sheet height is ${t} but snap point is ${t + Math.abs(e)}.`
  ), Math.max(Math.round(e), 0);
}
function rs(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n && (n.current = t);
    });
  };
}
function ey() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function is(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(
    // @ts-expect-error
    ((t = window.navigator.userAgentData) == null ? void 0 : t.platform) || window.navigator.platform
  ) : !1;
}
function qr(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
var ty = qr(function() {
  return is(/^Mac/i);
}), ny = qr(function() {
  return is(/^iPhone/i);
}), ry = qr(function() {
  return is(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ty() && navigator.maxTouchPoints > 1;
}), iy = qr(function() {
  return ny() || ry();
}), oy = 24;
function co(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
var Ri = typeof document < "u" && window.visualViewport;
function lu(e, t) {
  if (!e)
    return !1;
  const n = window.getComputedStyle(e);
  let r = /(auto|scroll)/.test(
    n.overflow + n.overflowX + n.overflowY
  );
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
function kl(e, t) {
  let n = e;
  for (lu(n, t) && (n = n.parentElement); n && !lu(n, t); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
var sy = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), lr = 0, fr;
function ay(e = {}) {
  const { isDisabled: t } = e;
  Kn(() => {
    if (!t)
      return lr++, lr === 1 && (iy() ? fr = cy() : fr = uy()), () => {
        lr--, lr === 0 && (fr == null || fr());
      };
  }, [t]);
}
function uy() {
  return co(
    Dn(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    Dn(document.documentElement, "overflow", "hidden")
  );
}
function cy() {
  let e, t = 0;
  const n = (f) => {
    var d;
    const h = (d = f.composedPath()) == null ? void 0 : d[0];
    e = kl(h, !0), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (e === void 0)
      return;
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    const d = f.changedTouches[0].pageY, h = e.scrollTop, g = e.scrollHeight - e.clientHeight;
    g !== 0 && ((h <= 0 && d > t || h >= g && d < t) && f.preventDefault(), t = d);
  }, i = (f) => {
    var d;
    const h = (d = f.composedPath()) == null ? void 0 : d[0];
    du(h) && h !== document.activeElement && (f.preventDefault(), h.style.transform = "translateY(-2000px)", h.focus(), requestAnimationFrame(() => {
      h.style.transform = "";
    }));
  }, o = (f) => {
    var d;
    const h = (d = f.composedPath()) == null ? void 0 : d[0];
    du(h) && (h.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      h.style.transform = "", Ri && (Ri.height < window.innerHeight ? requestAnimationFrame(() => {
        fu(h);
      }) : Ri.addEventListener(
        "resize",
        () => fu(h),
        { once: !0 }
      ));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, u = window.pageYOffset, c = co(
    Dn(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    Dn(document.documentElement, "overflow", "hidden"),
    Dn(document.body, "marginTop", `-${u}px`)
  );
  window.scrollTo(0, 0);
  const l = co(
    yn(document, "touchstart", n, {
      passive: !1,
      capture: !0
    }),
    yn(document, "touchmove", r, {
      passive: !1,
      capture: !0
    }),
    yn(document, "touchend", i, {
      passive: !1,
      capture: !0
    }),
    yn(document, "focus", o, !0),
    yn(window, "scroll", s)
  );
  return () => {
    c(), l(), window.scrollTo(a, u);
  };
}
function Dn(e, t, n) {
  const r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function yn(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function fu(e) {
  const t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    const n = kl(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      const r = n.getBoundingClientRect().top, i = e.getBoundingClientRect().top, o = e.getBoundingClientRect().bottom, s = n.getBoundingClientRect().bottom + oy;
      o > s && (n.scrollTop += i - r);
    }
    e = n.parentElement;
  }
}
function du(e) {
  return e instanceof HTMLInputElement && !sy.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
var at = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    pointerEvents: "none"
  },
  backdrop: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    touchAction: "none",
    // Disable iOS body scrolling
    border: "none",
    WebkitTapHighlightColor: "transparent"
  },
  container: {
    zIndex: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  },
  headerWrapper: {
    width: "100%"
  },
  header: {
    height: "40px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  indicator: {
    width: "18px",
    height: "4px",
    borderRadius: "99px",
    backgroundColor: "#ddd"
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "0px",
    position: "relative"
  },
  scroller: {
    height: "100%",
    overflowY: "auto"
  }
}, Ll = lt(
  ({
    onOpenStart: e,
    onOpenEnd: t,
    onClose: n,
    onCloseStart: r,
    onCloseEnd: i,
    onSnap: o,
    children: s,
    disableScrollLocking: a = !1,
    isOpen: u,
    snapPoints: c,
    rootId: l,
    mountPoint: f,
    style: d,
    detent: h = "full-height",
    initialSnap: g = 0,
    disableDrag: p = !1,
    prefersReducedMotion: x = !1,
    tweenConfig: m = Uv,
    dragVelocityThreshold: D = zv,
    dragCloseThreshold: O = qv,
    ...w
  }, y) => {
    const A = fe(null), I = uo(0), { height: E } = Gv(), b = wv(), R = !!(x || b), L = {
      type: "tween",
      ...R ? Hv : m
    }, $ = uo(E), F = Mr(
      $,
      (T) => T + 2 >= E ? -1 : (d == null ? void 0 : d.zIndex) ?? 9999
    ), H = Mr(
      $,
      (T) => T + 2 >= E ? "hidden" : "visible"
    ), X = fe({
      onOpenStart: e,
      onOpenEnd: t,
      onCloseStart: r,
      onCloseEnd: i
    });
    Kn(() => {
      X.current = {
        onOpenStart: e,
        onOpenEnd: t,
        onCloseStart: r,
        onCloseEnd: i
      };
    });
    let K = c;
    K && (K = K.map((T) => T > 0 && T <= 1 ? Math.round(T * E) : T < 0 ? E + T : T), console.assert(
      Jv(K) || E === 0,
      `Snap points need to be in descending order got: [${K.join(
        ", "
      )}]`
    ));
    const z = Ci((T, { delta: C }) => {
      const k = $.getVelocity();
      k > 0 && I.set(10), k < 0 && I.set(-10), $.set(Math.max($.get() + C.y, 0));
    }), M = Ci(() => {
      const T = document.activeElement;
      if (!T || !A.current) return;
      (T.tagName === "INPUT" || T.tagName === "TEXTAREA") && A.current.contains(T) && T.blur();
    }), _ = Ci((T, { velocity: C }) => {
      if (C.y > D)
        n();
      else {
        const k = A.current.getBoundingClientRect().height, B = $.get();
        let j = 0;
        if (K) {
          const G = K.map(
            (ee) => k - Math.min(ee, k)
          );
          h === "content-height" && !G.includes(0) && G.unshift(0), j = uu(G, B);
        } else B / k > O && (j = k);
        if (j = cu({ snapTo: j, sheetHeight: k }), su($, j, L), K && o) {
          const G = Math.abs(Math.round(K[0] - j)), ee = K.indexOf(
            uu(K, G)
          );
          o(ee);
        }
        const q = Math.round(k);
        j + 2 >= q && n();
      }
      I.set(0);
    });
    Ce(() => {
      if (!K || !o) return;
      const T = u ? g : K.length - 1;
      o(T);
    }, [u]), Au(y, () => ({
      y: $,
      snapTo: (T) => {
        const C = A.current;
        if ((K == null ? void 0 : K[T]) !== void 0 && C) {
          const k = C.getBoundingClientRect().height, B = K[T], j = cu({
            snapTo: k - B,
            sheetHeight: k
          });
          su($, j, L), o && o(T), j >= k && n();
        }
      }
    })), Kv({
      y: $,
      rootId: l,
      sheetRef: A
    }), ay({ isDisabled: a || !u });
    const S = Ne(() => p ? void 0 : {
      drag: "y",
      dragElastic: 0,
      dragMomentum: !1,
      dragPropagation: !1,
      onDrag: z,
      onDragStart: M,
      onDragEnd: _
    }, [p, E]), P = {
      y: $,
      sheetRef: A,
      isOpen: u,
      initialSnap: g,
      snapPoints: K,
      detent: h,
      indicatorRotation: I,
      callbacks: X,
      dragProps: S,
      windowHeight: E,
      animationOptions: L,
      reduceMotion: R,
      disableDrag: p
    }, v = /* @__PURE__ */ W.createElement(Al.Provider, { value: P }, /* @__PURE__ */ W.createElement(
      qe.div,
      {
        ...w,
        ref: y,
        style: { ...at.wrapper, zIndex: F, visibility: H, ...d }
      },
      /* @__PURE__ */ W.createElement(Uu, null, u ? /* @__PURE__ */ W.createElement(Qv, null, Mu.map(
        s,
        (T, C) => Vf(T, { key: `sheet-child-${C}` })
      )) : null)
    ));
    return Bn ? v : Wf(v, f ?? document.body);
  }
);
Ll.displayName = "Sheet";
var Nl = lt(
  ({ children: e, style: t = {}, className: n = "", ...r }, i) => {
    const {
      y: o,
      isOpen: s,
      callbacks: a,
      snapPoints: u,
      initialSnap: c = 0,
      sheetRef: l,
      windowHeight: f,
      detent: d,
      animationOptions: h,
      reduceMotion: g
    } = Hr(), { handleAnimationComplete: p } = Yv(s, a), x = u ? u[0] - u[c] : 0, m = u ? u[0] : null, D = m !== null ? `min(${m}px, ${au})` : au;
    return /* @__PURE__ */ W.createElement(
      qe.div,
      {
        ...r,
        ref: rs([l, i]),
        className: `react-modal-sheet-container ${n}`,
        style: {
          ...at.container,
          ...t,
          ...d === "full-height" && { height: D },
          ...d === "content-height" && { maxHeight: D },
          y: o
        },
        initial: g ? !1 : { y: f },
        animate: { y: x, transition: h },
        exit: { y: f, transition: h },
        onAnimationComplete: p
      },
      e
    );
  }
);
Nl.displayName = "SheetContainer";
var Vl = lt(
  ({ children: e, style: t, disableDrag: n, className: r = "", ...i }, o) => {
    const s = Hr(), a = Ml(), { constraintsRef: u, onMeasureDragConstraints: c } = Dl(), l = n || a.disableDrag ? void 0 : s.dragProps;
    return /* @__PURE__ */ W.createElement(
      qe.div,
      {
        ...i,
        ref: rs([o, u]),
        className: `react-modal-sheet-content ${r}`,
        style: { ...at.content, ...t },
        ...l,
        dragConstraints: u,
        onMeasureDragConstraints: c
      },
      e
    );
  }
);
Vl.displayName = "SheetContent";
var Fl = lt(
  ({ children: e, style: t, disableDrag: n, ...r }, i) => {
    const { indicatorRotation: o, dragProps: s } = Hr(), { constraintsRef: a, onMeasureDragConstraints: u } = Dl(), c = n ? void 0 : s, l = Mr(
      o,
      (d) => `translateX(2px) rotate(${d}deg)`
    ), f = Mr(
      o,
      (d) => `translateX(-2px) rotate(${-1 * d}deg)`
    );
    return /* @__PURE__ */ W.createElement(
      qe.div,
      {
        ...r,
        ref: rs([i, a]),
        style: { ...at.headerWrapper, ...t },
        ...c,
        dragConstraints: a,
        onMeasureDragConstraints: u
      },
      e || /* @__PURE__ */ W.createElement("div", { className: "react-modal-sheet-header", style: at.header }, /* @__PURE__ */ W.createElement(
        qe.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...at.indicator, transform: l }
        }
      ), /* @__PURE__ */ W.createElement(
        qe.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...at.indicator, transform: f }
        }
      ))
    );
  }
);
Fl.displayName = "SheetHeader";
var hu = (e) => !!e.onClick || !!e.onTap, $l = lt(
  ({ style: e = {}, className: t = "", ...n }, r) => {
    const i = hu(n) ? qe.button : qe.div, o = hu(n) ? "auto" : "none";
    return /* @__PURE__ */ W.createElement(
      i,
      {
        ...n,
        ref: r,
        className: `react-modal-sheet-backdrop ${t}`,
        style: { ...at.backdrop, ...e, pointerEvents: o },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }
    );
  }
);
$l.displayName = "SheetBackdrop";
var Bl = lt(
  ({ draggableAt: e = "top", children: t, style: n, className: r = "", ...i }, o) => {
    const s = Ml();
    function a(f) {
      const { scrollTop: d, scrollHeight: h, clientHeight: g } = f;
      if (!(h > g)) return;
      const x = d <= 0, m = h - d === g;
      e === "top" && x || e === "bottom" && m || e === "both" && (x || m) ? s.setDragEnabled() : s.setDragDisabled();
    }
    function u(f) {
      a(f.currentTarget), i.onScroll && i.onScroll(f);
    }
    function c(f) {
      a(f.currentTarget), i.onTouchStart && i.onTouchStart(f);
    }
    const l = ey() ? { onScroll: u, onTouchStart: c } : void 0;
    return /* @__PURE__ */ W.createElement(
      "div",
      {
        ...i,
        ref: o,
        className: `react-modal-sheet-scroller ${r}`,
        style: { ...at.scroller, ...n },
        ...l
      },
      t
    );
  }
);
Bl.displayName = "SheetScroller";
var mt = Object.assign(Ll, {
  Container: Nl,
  Header: Fl,
  Content: Vl,
  Backdrop: $l,
  Scroller: Bl
});
const ly = "_backdrop_bkyrw_1", fy = "_container_bkyrw_6", dy = "_header_bkyrw_14", hy = "_headContainer_bkyrw_19", py = "_titleWrapper_bkyrw_26", my = "_title_bkyrw_26", gy = "_subTitle_bkyrw_38", vy = "_closeIconWrapper_bkyrw_45", yy = "_secondLevelHeadContainer_bkyrw_49", Sy = "_secondLevelTitleWrapper_bkyrw_54", by = "_backIconWrapper_bkyrw_59", wy = "_content_bkyrw_69", Ty = "_secondLevelContent_bkyrw_74", Ae = {
  backdrop: ly,
  container: fy,
  header: dy,
  headContainer: hy,
  titleWrapper: py,
  title: my,
  subTitle: gy,
  closeIconWrapper: vy,
  secondLevelHeadContainer: yy,
  secondLevelTitleWrapper: Sy,
  backIconWrapper: by,
  content: wy,
  secondLevelContent: Ty
}, Kw = ({
  children: e,
  placement: t = "mid",
  title: n,
  subTitle: r,
  customSnapPoint: i,
  onClose: o,
  isCloseButtonVisible: s = !1,
  secondLevelContent: a = null,
  isSecondLevelActive: u = !1,
  secondLevelTitle: c,
  toggleSecondLevel: l,
  isOpen: f,
  ...d
}) => {
  const h = {
    low: [0.22],
    mid: [0.65],
    high: [0.95]
  }, p = typeof i == "number" && i > 0 && i <= 1 ? [i] : h[t], x = Ne(
    () => /* @__PURE__ */ ne("div", { className: Ae.headContainer, children: [
      /* @__PURE__ */ ne("div", { className: Ae.titleWrapper, children: [
        /* @__PURE__ */ N("div", { className: Ae.title, children: n }),
        s && /* @__PURE__ */ N("div", { className: Ae.closeIconWrapper, onClick: o, children: /* @__PURE__ */ N(Lu, {}) })
      ] }),
      r && /* @__PURE__ */ N("div", { className: Ae.subTitle, children: r })
    ] }),
    [n, r, s, o]
  ), m = Ne(
    () => /* @__PURE__ */ ne("div", { className: Ae.secondLevelHeadContainer, children: [
      /* @__PURE__ */ N("div", { className: Ae.backIconWrapper, onClick: l, children: /* @__PURE__ */ N(Nu, {}) }),
      c && /* @__PURE__ */ N("div", { className: Ae.secondLevelTitleWrapper, children: /* @__PURE__ */ N("div", { className: Ae.title, children: c }) })
    ] }),
    [n, l]
  );
  return /* @__PURE__ */ ne(mt, { isOpen: f, ...d, snapPoints: p, onClose: o, children: [
    /* @__PURE__ */ N(mt.Container, { className: Ae.container, children: /* @__PURE__ */ N(Uu, { mode: "wait", children: u ? /* @__PURE__ */ ne(Le, { children: [
      /* @__PURE__ */ N(
        qe.div,
        {
          initial: { x: "100%" },
          animate: { x: 0 },
          exit: { x: "100%" },
          transition: { type: "tween", duration: 0.3 },
          children: m
        },
        "second-level-head"
      ),
      /* @__PURE__ */ N(
        mt.Content,
        {
          initial: { x: "100%" },
          animate: { x: 0 },
          exit: { x: "100%" },
          transition: { type: "tween", duration: 0.3 },
          className: Ae.secondLevelContent,
          children: /* @__PURE__ */ N(mt.Scroller, { draggableAt: "both", children: a })
        },
        "second-level"
      )
    ] }) : /* @__PURE__ */ ne(Le, { children: [
      /* @__PURE__ */ N(
        qe.div,
        {
          initial: { y: "-100%" },
          animate: { y: 0 },
          exit: { y: "-100%" },
          transition: { type: "tween", duration: 0.3 },
          children: /* @__PURE__ */ N(mt.Header, { className: Ae.header })
        },
        "head-line"
      ),
      n || r ? /* @__PURE__ */ N(
        qe.div,
        {
          initial: { x: "-100%" },
          animate: { x: 0 },
          exit: { x: "-100%" },
          transition: { type: "tween", duration: 0.1 },
          children: x
        },
        "first-level-head"
      ) : null,
      /* @__PURE__ */ N(
        mt.Content,
        {
          initial: { x: "-100%" },
          animate: { x: 0 },
          exit: { x: "-100%" },
          transition: { type: "tween", duration: 0.1 },
          className: Ae.content,
          children: /* @__PURE__ */ N(mt.Scroller, { draggableAt: "both", children: e })
        },
        "first-level"
      )
    ] }) }) }),
    /* @__PURE__ */ N(mt.Backdrop, { onTap: o, className: Ae.backdrop })
  ] });
}, xy = "_wrapper_le3du_1", Ey = "_dropzoneContainer_le3du_12", Py = "_displayImage_le3du_31", _y = "_details_le3du_36", Cy = "_heading_le3du_45", Ry = "_subHeading_le3du_60", Oy = "_hasError_le3du_73", Dy = "_hover_le3du_77", Ay = "_info_le3du_86", Iy = "_progressContainer_le3du_98", My = "_progressBar_le3du_104", ky = "_uploadingText_le3du_110", Ly = "_dropzoneInput_le3du_117", Ie = {
  wrapper: xy,
  dropzoneContainer: Ey,
  displayImage: Py,
  details: _y,
  heading: Cy,
  subHeading: Ry,
  hasError: Oy,
  hover: Dy,
  info: Ay,
  progressContainer: Iy,
  progressBar: My,
  uploadingText: ky,
  dropzoneInput: Ly
}, Yw = ({
  image: e = /* @__PURE__ */ N(Uf, {}),
  info: t,
  status: n,
  heading: r = "Click or drag file to this area to upload",
  onDragEnterCTA: i = "Drag file to this area to upload",
  processingText: o = "Uploading...",
  subHeading: s = /* @__PURE__ */ ne(Le, { children: [
    "Upload your existing resume in DOC, DOCX of PDF formats ",
    /* @__PURE__ */ N("br", {}),
    " (less than 10MB in size)",
    " "
  ] }),
  accept: a = "image/jpeg, image/x-png, .jpg, .jpeg, .png",
  onChange: u,
  disabled: c = !1,
  error: l
}) => {
  const f = n !== "processing", [d, h] = we(!1), [g, p] = we(!1), x = ke(
    (w) => {
      w.target.files && u(w.target.files[0]);
    },
    [u]
  ), m = ke(() => h(!0), []), D = ke(() => {
    h(!1), p(!1);
  }, []), O = ke(() => p(!0), []);
  return /* @__PURE__ */ ne(
    "div",
    {
      className: _e(Ie.wrapper, {
        [Ie.hover]: f || d || g
      }),
      onDragOver: m,
      onDragEnter: O,
      onDrop: D,
      onDragEnd: D,
      onDragLeave: D,
      children: [
        /* @__PURE__ */ ne(
          "div",
          {
            className: _e(Ie.dropzoneContainer, {
              [Ie.hasError]: n === "error" || !!l
            }),
            children: [
              n !== "processing" && /* @__PURE__ */ ne(Le, { children: [
                /* @__PURE__ */ N("aside", { className: Ie.displayImage, children: e }),
                /* @__PURE__ */ ne("div", { className: Ie.details, children: [
                  /* @__PURE__ */ N("h3", { className: Ie.heading, children: g ? i : r }),
                  /* @__PURE__ */ N("div", { className: Ie.subHeading, children: s })
                ] })
              ] }),
              n === "processing" && /* @__PURE__ */ ne(Le, { children: [
                /* @__PURE__ */ N("div", { className: Ie.uploadingText, children: o }),
                /* @__PURE__ */ N(Ny, {})
              ] }),
              /* @__PURE__ */ N(
                "input",
                {
                  disabled: n === "processing" || c,
                  className: Ie.dropzoneInput,
                  type: "file",
                  onChange: x,
                  accept: a
                }
              )
            ]
          }
        ),
        (!!t || !!l) && /* @__PURE__ */ N(
          "div",
          {
            className: _e(Ie.info, {
              [Ie.hasError]: n === "error" || !!l
            }),
            children: l || t
          }
        )
      ]
    }
  );
}, Ny = () => /* @__PURE__ */ N("div", { className: Ie.progressContainer, children: /* @__PURE__ */ N("div", { className: Ie.progressBar, style: { width: "50%" } }) }), Vy = "_container_mmoz5_1", Fy = "_inputPlaceholder_mmoz5_23", $y = "_asyncAutoSuggestContainer_mmoz5_31", By = "_inputContainer_mmoz5_35", jy = "_inputWrapper_mmoz5_44", Wy = "_input_mmoz5_23", Uy = "_defaultSuggestionContainer_mmoz5_66", Hy = "_separator_mmoz5_94", qy = "_suggestionItem_mmoz5_100", zy = "_suggestionItemDetails_mmoz5_116", Ky = "_clearBtn_mmoz5_122", Me = {
  container: Vy,
  inputPlaceholder: Fy,
  asyncAutoSuggestContainer: $y,
  inputContainer: By,
  inputWrapper: jy,
  input: Wy,
  defaultSuggestionContainer: Uy,
  separator: Hy,
  suggestionItem: qy,
  suggestionItemDetails: zy,
  clearBtn: Ky
}, Yy = ({
  name: e,
  value: t,
  onChange: n,
  placeholder: r,
  icon: i,
  defaultSuggestions: o = [],
  shouldRenderSuggestions: s = () => !0,
  fetchItems: a,
  renderCustomItemSuggestion: u,
  onSuggestionSelected: c,
  onClear: l,
  renderMenuIcon: f
}) => {
  const [d, h] = we(!1), g = (m) => m ? /* @__PURE__ */ ne("div", { className: Me.suggestionItem, children: [
    /* @__PURE__ */ ne("div", { className: Me.suggestionItemDetails, children: [
      f ? f(m) : i,
      /* @__PURE__ */ N("span", { children: m.formatted ?? m.text })
    ] }),
    u && u(m)
  ] }, m == null ? void 0 : m.text) : null, p = ({
    containerProps: m,
    children: D
  }) => {
    const { className: O, key: w, ...y } = m;
    return D ? (D && !d && h(!0), /* @__PURE__ */ _r("div", { ...y, key: w, className: _e(O, Me.defaultSuggestionContainer) }, /* @__PURE__ */ N("div", { className: Me.separator }), /* @__PURE__ */ N(Le, { children: D }))) : null;
  }, x = typeof t == "string" && t.length > 0 && l;
  return /* @__PURE__ */ N(
    "div",
    {
      "data-is-expanded": d,
      className: _e(Me.container, { [Me.isExpanded]: d }),
      children: /* @__PURE__ */ N(
        Ld,
        {
          name: e,
          id: e,
          value: t,
          onChange: n,
          defaultSuggestions: o,
          shouldRenderSuggestions: s,
          fetchItems: a,
          containerClassName: Me.asyncAutoSuggestContainer,
          renderSuggestion: g,
          onSuggestionSelected: (m, D) => {
            h(!1), c && c(D.suggestion);
          },
          renderSuggestionsContainer: p,
          inputProps: {
            placeholder: r,
            value: t,
            // @ts-ignore
            onChange: n,
            onBlur: () => h(!1),
            onClick: () => h(!0),
            onKeyDown: (m) => {
              (m.key === "Enter" || m.key === "Escape") && h(!1);
            }
          },
          children: ({ className: m, id: D, ...O }) => /* @__PURE__ */ N("div", { className: Me.inputPlaceholder, children: /* @__PURE__ */ N("div", { className: Me.inputContainer, children: /* @__PURE__ */ ne(
            "div",
            {
              className: _e(Me.inputWrapper, {
                [Me.isExpanded]: d
              }),
              children: [
                i,
                /* @__PURE__ */ _r(
                  "input",
                  {
                    ...O,
                    "aria-haspopup": "listbox",
                    key: D,
                    className: _e(m, Me.input)
                  }
                ),
                x && /* @__PURE__ */ N(
                  "button",
                  {
                    "aria-label": `Clear ${e}`,
                    onClick: (w) => {
                      (w == null ? void 0 : w.detail) !== 0 && (w == null || w.preventDefault(), w == null || w.stopPropagation(), l(e));
                    },
                    className: Me.clearBtn,
                    children: /* @__PURE__ */ N("span", { "aria-hidden": "true", children: /* @__PURE__ */ N(Gf, {}) })
                  }
                )
              ]
            }
          ) }) })
        }
      )
    }
  );
}, Gy = "_container_kmmsb_1", Xy = "_widthContainer_kmmsb_7", Zy = "_bar_kmmsb_13", Qy = "_inputWrapper_kmmsb_29", Jy = "_separator_kmmsb_35", eS = "_field_kmmsb_43", tS = "_btn_kmmsb_53", nS = "_spacing_kmmsb_88", gt = {
  container: Gy,
  widthContainer: Xy,
  bar: Zy,
  inputWrapper: Qy,
  separator: Jy,
  field: eS,
  btn: tS,
  spacing: nS
}, Gw = ({
  searchSchema: e = rS,
  searchValues: t,
  onSearchChange: n,
  onSearchClick: r
}) => {
  const i = fe(null), [o, s] = we({}), a = t !== void 0 && n !== void 0, u = a ? t : o, c = (g) => {
    a ? n == null || n(g) : s(g);
  }, l = (g) => {
    c({ ...u, [g.target.name]: g.target.value });
  }, f = (g) => async () => {
    const p = e.find((x) => x.name === g);
    return p != null && p.fetchItems ? p.fetchItems() : [];
  }, d = (g) => {
    c({ ...u, [g]: "" });
  }, h = (g) => {
    g.preventDefault(), r && r();
  };
  return /* @__PURE__ */ N("div", { className: gt.container, ref: i, children: /* @__PURE__ */ N("div", { className: gt.widthContainer, children: /* @__PURE__ */ ne("form", { onSubmit: h, className: gt.bar, children: [
    /* @__PURE__ */ N("div", { className: gt.field, children: e.map((g, p) => {
      const x = p === e.length - 1;
      return /* @__PURE__ */ ne(W.Fragment, { children: [
        /* @__PURE__ */ N(
          "div",
          {
            className: _e(gt.inputWrapper, { [gt.spacing]: !x }),
            children: /* @__PURE__ */ N(
              Yy,
              {
                onChange: l,
                value: u[g.name] || "",
                placeholder: g.placeholder,
                icon: g.icon,
                onSuggestionSelected: g.onSuggestionSelected,
                name: g.name,
                defaultSuggestions: g.defaultSuggestions,
                fetchItems: f(g.name),
                renderCustomItemSuggestion: g.renderCustomItemSuggestion,
                onClear: g.canClear ? d : void 0,
                renderMenuIcon: g.renderMenuIcon
              }
            )
          }
        ),
        !x && /* @__PURE__ */ N("div", { className: gt.separator })
      ] }, g.name);
    }) }),
    /* @__PURE__ */ N("div", { className: gt.btn, children: /* @__PURE__ */ N(kf, { type: "submit", children: "Search" }) })
  ] }) }) });
}, rS = [
  {
    name: "search",
    placeholder: "Job Title, Company, Skill",
    icon: /* @__PURE__ */ N(Hf, {}),
    fetchItems: async () => [
      { text: "Search Title One" },
      { text: "Search Title Two" },
      { text: "Search Title Three" }
    ],
    onSuggestionSelected: () => console.log("Title suggestion selected"),
    canClear: !0,
    defaultSuggestions: [
      {
        text: "Software Analyst"
      },
      {
        text: "Software Programmer"
      },
      {
        text: "Software Specialist"
      }
    ],
    renderCustomItemSuggestion: () => /* @__PURE__ */ N("div", { style: { fontSize: "10px" }, children: "Create job alert" })
  },
  {
    name: "location",
    placeholder: "Location",
    icon: /* @__PURE__ */ N(zf, {}),
    defaultSuggestions: [
      {
        text: "Location one"
      },
      {
        text: "Location two"
      },
      {
        text: "Location three"
      }
    ],
    onSuggestionSelected: () => console.log("Location suggestion selected"),
    renderMenuIcon: () => /* @__PURE__ */ N(qf, {}),
    fetchItems: async () => [
      { text: "Location one" },
      { text: "Location two" },
      { text: "Location three" }
    ]
  }
], iS = "_container_kaqh6_1", oS = {
  container: iS
}, Xw = ({ currentPage: e, numberOfPages: t, changePage: n }) => {
  const r = e < t, i = e > 1, { isPhone: o } = yo(), s = () => {
    const a = [];
    for (let u = 1; u <= t; u++) {
      const c = [1, e, t].includes(u), l = o ? e <= 3 && u <= 3 : e <= 4 && u <= 7, f = o ? e >= t - 2 && u >= t - 2 : e >= t - 3 && u >= t - 6, d = o ? !1 : Math.abs(u - e) <= 2;
      c || l || f || d ? a.push(u) : (u < e && !a.includes(-1) && a.push(-1), u > e && !a.includes(-2) && a.push(-2));
    }
    return a;
  };
  return /* @__PURE__ */ ne("div", { className: oS.container, children: [
    /* @__PURE__ */ N(
      Xr,
      {
        state: i ? "default" : "disabled",
        icon: /* @__PURE__ */ N(Nu, { "aria-hidden": "true" }),
        iconOnly: !0,
        page: 0,
        "aria-label": "Go to previous page",
        onClick: () => i && n(e - 1)
      }
    ),
    s().map((a, u) => /* @__PURE__ */ N(
      Xr,
      {
        state: a === e ? "selected" : "default",
        iconOnly: a < 0,
        icon: a < 0 ? /* @__PURE__ */ N(Kf, {}) : void 0,
        page: a >= 0 ? a : void 0,
        onClick: () => a >= 0 ? n(a) : void 0
      },
      u
    )),
    /* @__PURE__ */ N(
      Xr,
      {
        state: r ? "default" : "disabled",
        icon: /* @__PURE__ */ N(Yf, { "aria-hidden": "true" }),
        iconOnly: !0,
        page: 0,
        "aria-label": "Go to next page",
        onClick: () => r && n(e + 1)
      }
    )
  ] });
}, sS = "_checkboxLabel_17jhv_1", aS = "_hiddenInput_17jhv_10", uS = "_checkbox_17jhv_1", cS = "_checked_17jhv_37", lS = "_error_17jhv_42", fS = "_label_17jhv_46", zt = {
  checkboxLabel: sS,
  hiddenInput: aS,
  checkbox: uS,
  checked: cS,
  error: lS,
  label: fS
}, Zw = ({
  label: e,
  checked: t,
  onChange: n,
  disabled: r = !1,
  error: i = !1,
  id: o
}) => {
  const [s, a] = we(t || !1);
  Ce(() => {
    t !== void 0 && a(t);
  }, [t]);
  const u = (l) => {
    if (r) return;
    const f = l.target.checked;
    a(f), n == null || n(f);
  }, c = Ne(
    () => o || `checkbox-${Math.random().toString(36).substr(2, 9)}`,
    [o]
  );
  return /* @__PURE__ */ ne("label", { htmlFor: c, className: zt.checkboxLabel, children: [
    /* @__PURE__ */ N(
      "input",
      {
        type: "checkbox",
        className: zt.hiddenInput,
        checked: t ?? s,
        onChange: u,
        disabled: r,
        id: c
      }
    ),
    /* @__PURE__ */ N(
      "div",
      {
        className: _e(zt.checkbox, {
          [zt.checked]: s,
          [zt.error]: i
        }),
        children: s && /* @__PURE__ */ N(Xf, {})
      }
    ),
    e && /* @__PURE__ */ N("span", { className: zt.label, children: e })
  ] });
};
function bt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function pu(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function jl(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = pu(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : pu(e[i], null);
        }
      };
  };
}
function Bt(...e) {
  return V.useCallback(jl(...e), e);
}
function dS(e, t) {
  const n = V.createContext(t), r = (o) => {
    const { children: s, ...a } = o, u = V.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ N(n.Provider, { value: u, children: s });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const s = V.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function hS(e, t = []) {
  let n = [];
  function r(o, s) {
    const a = V.createContext(s), u = n.length;
    n = [...n, s];
    const c = (f) => {
      var m;
      const { scope: d, children: h, ...g } = f, p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[u]) || a, x = V.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ N(p.Provider, { value: x, children: h });
    };
    c.displayName = o + "Provider";
    function l(f, d) {
      var p;
      const h = ((p = d == null ? void 0 : d[e]) == null ? void 0 : p[u]) || a, g = V.useContext(h);
      if (g) return g;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [c, l];
  }
  const i = () => {
    const o = n.map((s) => V.createContext(s));
    return function(a) {
      const u = (a == null ? void 0 : a[e]) || o;
      return V.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    };
  };
  return i.scopeName = e, [r, pS(i, ...t)];
}
function pS(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((a, { useScope: u, scopeName: c }) => {
        const f = u(o)[`__scope${c}`];
        return { ...a, ...f };
      }, {});
      return V.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var kr = globalThis != null && globalThis.document ? V.useLayoutEffect : () => {
}, mS = V[" useId ".trim().toString()] || (() => {
}), gS = 0;
function Oi(e) {
  const [t, n] = V.useState(mS());
  return kr(() => {
    n((r) => r ?? String(gS++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Vt(e) {
  const t = V.useRef(e);
  return V.useEffect(() => {
    t.current = e;
  }), V.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function vS({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = yS({ defaultProp: t, onChange: n }), o = e !== void 0, s = o ? e : r, a = Vt(n), u = V.useCallback(
    (c) => {
      if (o) {
        const f = typeof c == "function" ? c(e) : c;
        f !== e && a(f);
      } else
        i(c);
    },
    [o, e, i, a]
  );
  return [s, u];
}
function yS({
  defaultProp: e,
  onChange: t
}) {
  const n = V.useState(e), [r] = n, i = V.useRef(r), o = Vt(t);
  return V.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
// @__NO_SIDE_EFFECTS__
function Wl(e) {
  const t = /* @__PURE__ */ SS(e), n = V.forwardRef((r, i) => {
    const { children: o, ...s } = r, a = V.Children.toArray(o), u = a.find(wS);
    if (u) {
      const c = u.props.children, l = a.map((f) => f === u ? V.Children.count(c) > 1 ? V.Children.only(null) : V.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ N(t, { ...s, ref: i, children: V.isValidElement(c) ? V.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ N(t, { ...s, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function SS(e) {
  const t = V.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (V.isValidElement(i)) {
      const s = xS(i), a = TS(o, i.props);
      return i.type !== V.Fragment && (a.ref = r ? jl(r, s) : s), V.cloneElement(i, a);
    }
    return V.Children.count(i) > 1 ? V.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var bS = Symbol("radix.slottable");
function wS(e) {
  return V.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === bS;
}
function TS(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function xS(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ft = ES.reduce((e, t) => {
  const n = /* @__PURE__ */ Wl(`Primitive.${t}`), r = V.forwardRef((i, o) => {
    const { asChild: s, ...a } = i, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ N(u, { ...a, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function PS(e, t) {
  e && jf.flushSync(() => e.dispatchEvent(t));
}
function _S(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Vt(e);
  V.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var CS = "DismissableLayer", lo = "dismissableLayer.update", RS = "dismissableLayer.pointerDownOutside", OS = "dismissableLayer.focusOutside", mu, Ul = V.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Hl = V.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, c = V.useContext(Ul), [l, f] = V.useState(null), d = (l == null ? void 0 : l.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = V.useState({}), g = Bt(t, (I) => f(I)), p = Array.from(c.layers), [x] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), m = p.indexOf(x), D = l ? p.indexOf(l) : -1, O = c.layersWithOutsidePointerEventsDisabled.size > 0, w = D >= m, y = IS((I) => {
      const E = I.target, b = [...c.branches].some((R) => R.contains(E));
      !w || b || (i == null || i(I), s == null || s(I), I.defaultPrevented || a == null || a());
    }, d), A = MS((I) => {
      const E = I.target;
      [...c.branches].some((R) => R.contains(E)) || (o == null || o(I), s == null || s(I), I.defaultPrevented || a == null || a());
    }, d);
    return _S((I) => {
      D === c.layers.size - 1 && (r == null || r(I), !I.defaultPrevented && a && (I.preventDefault(), a()));
    }, d), V.useEffect(() => {
      if (l)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (mu = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(l)), c.layers.add(l), gu(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = mu);
        };
    }, [l, d, n, c]), V.useEffect(() => () => {
      l && (c.layers.delete(l), c.layersWithOutsidePointerEventsDisabled.delete(l), gu());
    }, [l, c]), V.useEffect(() => {
      const I = () => h({});
      return document.addEventListener(lo, I), () => document.removeEventListener(lo, I);
    }, []), /* @__PURE__ */ N(
      ft.div,
      {
        ...u,
        ref: g,
        style: {
          pointerEvents: O ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: bt(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: bt(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: bt(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
Hl.displayName = CS;
var DS = "DismissableLayerBranch", AS = V.forwardRef((e, t) => {
  const n = V.useContext(Ul), r = V.useRef(null), i = Bt(t, r);
  return V.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ N(ft.div, { ...e, ref: i });
});
AS.displayName = DS;
function IS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Vt(e), r = V.useRef(!1), i = V.useRef(() => {
  });
  return V.useEffect(() => {
    const o = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          ql(
            RS,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = u, t.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function MS(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Vt(e), r = V.useRef(!1);
  return V.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && ql(OS, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function gu() {
  const e = new CustomEvent(lo);
  document.dispatchEvent(e);
}
function ql(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? PS(i, o) : i.dispatchEvent(o);
}
var Di = "focusScope.autoFocusOnMount", Ai = "focusScope.autoFocusOnUnmount", vu = { bubbles: !1, cancelable: !0 }, kS = "FocusScope", zl = V.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = e, [a, u] = V.useState(null), c = Vt(i), l = Vt(o), f = V.useRef(null), d = Bt(t, (p) => u(p)), h = V.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  V.useEffect(() => {
    if (r) {
      let p = function(O) {
        if (h.paused || !a) return;
        const w = O.target;
        a.contains(w) ? f.current = w : yt(f.current, { select: !0 });
      }, x = function(O) {
        if (h.paused || !a) return;
        const w = O.relatedTarget;
        w !== null && (a.contains(w) || yt(f.current, { select: !0 }));
      }, m = function(O) {
        if (document.activeElement === document.body)
          for (const y of O)
            y.removedNodes.length > 0 && yt(a);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", x);
      const D = new MutationObserver(m);
      return a && D.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", x), D.disconnect();
      };
    }
  }, [r, a, h.paused]), V.useEffect(() => {
    if (a) {
      Su.add(h);
      const p = document.activeElement;
      if (!a.contains(p)) {
        const m = new CustomEvent(Di, vu);
        a.addEventListener(Di, c), a.dispatchEvent(m), m.defaultPrevented || (LS(BS(Kl(a)), { select: !0 }), document.activeElement === p && yt(a));
      }
      return () => {
        a.removeEventListener(Di, c), setTimeout(() => {
          const m = new CustomEvent(Ai, vu);
          a.addEventListener(Ai, l), a.dispatchEvent(m), m.defaultPrevented || yt(p ?? document.body, { select: !0 }), a.removeEventListener(Ai, l), Su.remove(h);
        }, 0);
      };
    }
  }, [a, c, l, h]);
  const g = V.useCallback(
    (p) => {
      if (!n && !r || h.paused) return;
      const x = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, m = document.activeElement;
      if (x && m) {
        const D = p.currentTarget, [O, w] = NS(D);
        O && w ? !p.shiftKey && m === w ? (p.preventDefault(), n && yt(O, { select: !0 })) : p.shiftKey && m === O && (p.preventDefault(), n && yt(w, { select: !0 })) : m === D && p.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ N(ft.div, { tabIndex: -1, ...s, ref: d, onKeyDown: g });
});
zl.displayName = kS;
function LS(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (yt(r, { select: t }), document.activeElement !== n) return;
}
function NS(e) {
  const t = Kl(e), n = yu(t, e), r = yu(t.reverse(), e);
  return [n, r];
}
function Kl(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function yu(e, t) {
  for (const n of e)
    if (!VS(n, { upTo: t })) return n;
}
function VS(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function FS(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function yt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && FS(e) && t && e.select();
  }
}
var Su = $S();
function $S() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = bu(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = bu(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function bu(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function BS(e) {
  return e.filter((t) => t.tagName !== "A");
}
var jS = "Portal", Yl = V.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [i, o] = V.useState(!1);
  kr(() => o(!0), []);
  const s = n || i && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? Zt.createPortal(/* @__PURE__ */ N(ft.div, { ...r, ref: t }), s) : null;
});
Yl.displayName = jS;
function WS(e, t) {
  return V.useReducer((n, r) => t[n][r] ?? n, e);
}
var zr = (e) => {
  const { present: t, children: n } = e, r = US(t), i = typeof n == "function" ? n({ present: r.isPresent }) : V.Children.only(n), o = Bt(r.ref, HS(i));
  return typeof n == "function" || r.isPresent ? V.cloneElement(i, { ref: o }) : null;
};
zr.displayName = "Presence";
function US(e) {
  const [t, n] = V.useState(), r = V.useRef({}), i = V.useRef(e), o = V.useRef("none"), s = e ? "mounted" : "unmounted", [a, u] = WS(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return V.useEffect(() => {
    const c = dr(r.current);
    o.current = a === "mounted" ? c : "none";
  }, [a]), kr(() => {
    const c = r.current, l = i.current;
    if (l !== e) {
      const d = o.current, h = dr(c);
      e ? u("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? u("UNMOUNT") : u(l && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, u]), kr(() => {
    if (t) {
      let c;
      const l = t.ownerDocument.defaultView ?? window, f = (h) => {
        const p = dr(r.current).includes(h.animationName);
        if (h.target === t && p && (u("ANIMATION_END"), !i.current)) {
          const x = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = x);
          });
        }
      }, d = (h) => {
        h.target === t && (o.current = dr(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        l.clearTimeout(c), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: V.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function dr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function HS(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ii = 0;
function qS() {
  V.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? wu()), document.body.insertAdjacentElement("beforeend", e[1] ?? wu()), Ii++, () => {
      Ii === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ii--;
    };
  }, []);
}
function wu() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ze = function() {
  return Ze = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Ze.apply(this, arguments);
};
function Gl(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function zS(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Er = "right-scroll-bar-position", Pr = "width-before-scroll-bar", KS = "with-scroll-bars-hidden", YS = "--removed-body-scroll-bar-size";
function Mi(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function GS(e, t) {
  var n = we(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var XS = typeof window < "u" ? V.useLayoutEffect : V.useEffect, Tu = /* @__PURE__ */ new WeakMap();
function ZS(e, t) {
  var n = GS(null, function(r) {
    return e.forEach(function(i) {
      return Mi(i, r);
    });
  });
  return XS(function() {
    var r = Tu.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), s = n.current;
      i.forEach(function(a) {
        o.has(a) || Mi(a, null);
      }), o.forEach(function(a) {
        i.has(a) || Mi(a, s);
      });
    }
    Tu.set(n, e);
  }, [e]), n;
}
function QS(e) {
  return e;
}
function JS(e, t) {
  t === void 0 && (t = QS);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var s = t(o, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(a) {
          return o(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(o), s = n;
      }
      var u = function() {
        var l = s;
        s = [], l.forEach(o);
      }, c = function() {
        return Promise.resolve().then(u);
      };
      c(), n = {
        push: function(l) {
          s.push(l), c();
        },
        filter: function(l) {
          return s = s.filter(l), n;
        }
      };
    }
  };
  return i;
}
function eb(e) {
  e === void 0 && (e = {});
  var t = JS(null);
  return t.options = Ze({ async: !0, ssr: !1 }, e), t;
}
var Xl = function(e) {
  var t = e.sideCar, n = Gl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return V.createElement(r, Ze({}, n));
};
Xl.isSideCarExport = !0;
function tb(e, t) {
  return e.useMedium(t), Xl;
}
var Zl = eb(), ki = function() {
}, Kr = V.forwardRef(function(e, t) {
  var n = V.useRef(null), r = V.useState({
    onScrollCapture: ki,
    onWheelCapture: ki,
    onTouchMoveCapture: ki
  }), i = r[0], o = r[1], s = e.forwardProps, a = e.children, u = e.className, c = e.removeScrollBar, l = e.enabled, f = e.shards, d = e.sideCar, h = e.noIsolation, g = e.inert, p = e.allowPinchZoom, x = e.as, m = x === void 0 ? "div" : x, D = e.gapMode, O = Gl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = d, y = ZS([n, t]), A = Ze(Ze({}, O), i);
  return V.createElement(
    V.Fragment,
    null,
    l && V.createElement(w, { sideCar: Zl, removeScrollBar: c, shards: f, noIsolation: h, inert: g, setCallbacks: o, allowPinchZoom: !!p, lockRef: n, gapMode: D }),
    s ? V.cloneElement(V.Children.only(a), Ze(Ze({}, A), { ref: y })) : V.createElement(m, Ze({}, A, { className: u, ref: y }), a)
  );
});
Kr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Kr.classNames = {
  fullWidth: Pr,
  zeroRight: Er
};
var nb = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function rb() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = nb();
  return t && e.setAttribute("nonce", t), e;
}
function ib(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ob(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var sb = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = rb()) && (ib(t, n), ob(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ab = function() {
  var e = sb();
  return function(t, n) {
    V.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Ql = function() {
  var e = ab(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, ub = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Li = function(e) {
  return parseInt(e || "", 10) || 0;
}, cb = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Li(n), Li(r), Li(i)];
}, lb = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ub;
  var t = cb(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, fb = Ql(), rn = "data-scroll-locked", db = function(e, t, n, r) {
  var i = e.left, o = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(KS, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(rn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Er, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Pr, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Er, " .").concat(Er, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Pr, " .").concat(Pr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(rn, `] {
    `).concat(YS, ": ").concat(a, `px;
  }
`);
}, xu = function() {
  var e = parseInt(document.body.getAttribute(rn) || "0", 10);
  return isFinite(e) ? e : 0;
}, hb = function() {
  V.useEffect(function() {
    return document.body.setAttribute(rn, (xu() + 1).toString()), function() {
      var e = xu() - 1;
      e <= 0 ? document.body.removeAttribute(rn) : document.body.setAttribute(rn, e.toString());
    };
  }, []);
}, pb = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  hb();
  var o = V.useMemo(function() {
    return lb(i);
  }, [i]);
  return V.createElement(fb, { styles: db(o, !t, i, n ? "" : "!important") });
}, fo = !1;
if (typeof window < "u")
  try {
    var hr = Object.defineProperty({}, "passive", {
      get: function() {
        return fo = !0, !0;
      }
    });
    window.addEventListener("test", hr, hr), window.removeEventListener("test", hr, hr);
  } catch {
    fo = !1;
  }
var Kt = fo ? { passive: !1 } : !1, mb = function(e) {
  return e.tagName === "TEXTAREA";
}, Jl = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !mb(e) && n[t] === "visible")
  );
}, gb = function(e) {
  return Jl(e, "overflowY");
}, vb = function(e) {
  return Jl(e, "overflowX");
}, Eu = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = ef(e, r);
    if (i) {
      var o = tf(e, r), s = o[1], a = o[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, yb = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Sb = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ef = function(e, t) {
  return e === "v" ? gb(t) : vb(t);
}, tf = function(e, t) {
  return e === "v" ? yb(t) : Sb(t);
}, bb = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, wb = function(e, t, n, r, i) {
  var o = bb(e, window.getComputedStyle(t).direction), s = o * r, a = n.target, u = t.contains(a), c = !1, l = s > 0, f = 0, d = 0;
  do {
    var h = tf(e, a), g = h[0], p = h[1], x = h[2], m = p - x - o * g;
    (g || m) && ef(e, a) && (f += m, d += g), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !u && a !== document.body || // self content
    u && (t.contains(a) || t === a)
  );
  return (l && Math.abs(f) < 1 || !l && Math.abs(d) < 1) && (c = !0), c;
}, pr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Pu = function(e) {
  return [e.deltaX, e.deltaY];
}, _u = function(e) {
  return e && "current" in e ? e.current : e;
}, Tb = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, xb = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Eb = 0, Yt = [];
function Pb(e) {
  var t = V.useRef([]), n = V.useRef([0, 0]), r = V.useRef(), i = V.useState(Eb++)[0], o = V.useState(Ql)[0], s = V.useRef(e);
  V.useEffect(function() {
    s.current = e;
  }, [e]), V.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var p = zS([e.lockRef.current], (e.shards || []).map(_u), !0).filter(Boolean);
      return p.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), p.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = V.useCallback(function(p, x) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !s.current.allowPinchZoom;
    var m = pr(p), D = n.current, O = "deltaX" in p ? p.deltaX : D[0] - m[0], w = "deltaY" in p ? p.deltaY : D[1] - m[1], y, A = p.target, I = Math.abs(O) > Math.abs(w) ? "h" : "v";
    if ("touches" in p && I === "h" && A.type === "range")
      return !1;
    var E = Eu(I, A);
    if (!E)
      return !0;
    if (E ? y = I : (y = I === "v" ? "h" : "v", E = Eu(I, A)), !E)
      return !1;
    if (!r.current && "changedTouches" in p && (O || w) && (r.current = y), !y)
      return !0;
    var b = r.current || y;
    return wb(b, x, p, b === "h" ? O : w);
  }, []), u = V.useCallback(function(p) {
    var x = p;
    if (!(!Yt.length || Yt[Yt.length - 1] !== o)) {
      var m = "deltaY" in x ? Pu(x) : pr(x), D = t.current.filter(function(y) {
        return y.name === x.type && (y.target === x.target || x.target === y.shadowParent) && Tb(y.delta, m);
      })[0];
      if (D && D.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!D) {
        var O = (s.current.shards || []).map(_u).filter(Boolean).filter(function(y) {
          return y.contains(x.target);
        }), w = O.length > 0 ? a(x, O[0]) : !s.current.noIsolation;
        w && x.cancelable && x.preventDefault();
      }
    }
  }, []), c = V.useCallback(function(p, x, m, D) {
    var O = { name: p, delta: x, target: m, should: D, shadowParent: _b(m) };
    t.current.push(O), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== O;
      });
    }, 1);
  }, []), l = V.useCallback(function(p) {
    n.current = pr(p), r.current = void 0;
  }, []), f = V.useCallback(function(p) {
    c(p.type, Pu(p), p.target, a(p, e.lockRef.current));
  }, []), d = V.useCallback(function(p) {
    c(p.type, pr(p), p.target, a(p, e.lockRef.current));
  }, []);
  V.useEffect(function() {
    return Yt.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", u, Kt), document.addEventListener("touchmove", u, Kt), document.addEventListener("touchstart", l, Kt), function() {
      Yt = Yt.filter(function(p) {
        return p !== o;
      }), document.removeEventListener("wheel", u, Kt), document.removeEventListener("touchmove", u, Kt), document.removeEventListener("touchstart", l, Kt);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return V.createElement(
    V.Fragment,
    null,
    g ? V.createElement(o, { styles: xb(i) }) : null,
    h ? V.createElement(pb, { gapMode: e.gapMode }) : null
  );
}
function _b(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Cb = tb(Zl, Pb);
var nf = V.forwardRef(function(e, t) {
  return V.createElement(Kr, Ze({}, e, { ref: t, sideCar: Cb }));
});
nf.classNames = Kr.classNames;
var Rb = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Gt = /* @__PURE__ */ new WeakMap(), mr = /* @__PURE__ */ new WeakMap(), gr = {}, Ni = 0, rf = function(e) {
  return e && (e.host || rf(e.parentNode));
}, Ob = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = rf(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Db = function(e, t, n, r) {
  var i = Ob(t, Array.isArray(e) ? e : [e]);
  gr[n] || (gr[n] = /* @__PURE__ */ new WeakMap());
  var o = gr[n], s = [], a = /* @__PURE__ */ new Set(), u = new Set(i), c = function(f) {
    !f || a.has(f) || (a.add(f), c(f.parentNode));
  };
  i.forEach(c);
  var l = function(f) {
    !f || u.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (a.has(d))
        l(d);
      else
        try {
          var h = d.getAttribute(r), g = h !== null && h !== "false", p = (Gt.get(d) || 0) + 1, x = (o.get(d) || 0) + 1;
          Gt.set(d, p), o.set(d, x), s.push(d), p === 1 && g && mr.set(d, !0), x === 1 && d.setAttribute(n, "true"), g || d.setAttribute(r, "true");
        } catch (m) {
          console.error("aria-hidden: cannot operate on ", d, m);
        }
    });
  };
  return l(t), a.clear(), Ni++, function() {
    s.forEach(function(f) {
      var d = Gt.get(f) - 1, h = o.get(f) - 1;
      Gt.set(f, d), o.set(f, h), d || (mr.has(f) || f.removeAttribute(r), mr.delete(f)), h || f.removeAttribute(n);
    }), Ni--, Ni || (Gt = /* @__PURE__ */ new WeakMap(), Gt = /* @__PURE__ */ new WeakMap(), mr = /* @__PURE__ */ new WeakMap(), gr = {});
  };
}, Ab = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = Rb(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), Db(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, os = "Dialog", [of, Qw] = hS(os), [Ib, ze] = of(os), sf = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, a = V.useRef(null), u = V.useRef(null), [c = !1, l] = vS({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ N(
    Ib,
    {
      scope: t,
      triggerRef: a,
      contentRef: u,
      contentId: Oi(),
      titleId: Oi(),
      descriptionId: Oi(),
      open: c,
      onOpenChange: l,
      onOpenToggle: V.useCallback(() => l((f) => !f), [l]),
      modal: s,
      children: n
    }
  );
};
sf.displayName = os;
var af = "DialogTrigger", uf = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = ze(af, n), o = Bt(t, i.triggerRef);
    return /* @__PURE__ */ N(
      ft.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": us(i.open),
        ...r,
        ref: o,
        onClick: bt(e.onClick, i.onOpenToggle)
      }
    );
  }
);
uf.displayName = af;
var ss = "DialogPortal", [Mb, cf] = of(ss, {
  forceMount: void 0
}), lf = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = ze(ss, t);
  return /* @__PURE__ */ N(Mb, { scope: t, forceMount: n, children: V.Children.map(r, (s) => /* @__PURE__ */ N(zr, { present: n || o.open, children: /* @__PURE__ */ N(Yl, { asChild: !0, container: i, children: s }) })) });
};
lf.displayName = ss;
var Lr = "DialogOverlay", ff = V.forwardRef(
  (e, t) => {
    const n = cf(Lr, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = ze(Lr, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ N(zr, { present: r || o.open, children: /* @__PURE__ */ N(Lb, { ...i, ref: t }) }) : null;
  }
);
ff.displayName = Lr;
var kb = /* @__PURE__ */ Wl("DialogOverlay.RemoveScroll"), Lb = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = ze(Lr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ N(nf, { as: kb, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ N(
        ft.div,
        {
          "data-state": us(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ft = "DialogContent", df = V.forwardRef(
  (e, t) => {
    const n = cf(Ft, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = ze(Ft, e.__scopeDialog);
    return /* @__PURE__ */ N(zr, { present: r || o.open, children: o.modal ? /* @__PURE__ */ N(Nb, { ...i, ref: t }) : /* @__PURE__ */ N(Vb, { ...i, ref: t }) });
  }
);
df.displayName = Ft;
var Nb = V.forwardRef(
  (e, t) => {
    const n = ze(Ft, e.__scopeDialog), r = V.useRef(null), i = Bt(t, n.contentRef, r);
    return V.useEffect(() => {
      const o = r.current;
      if (o) return Ab(o);
    }, []), /* @__PURE__ */ N(
      hf,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: bt(e.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: bt(e.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && o.preventDefault();
        }),
        onFocusOutside: bt(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Vb = V.forwardRef(
  (e, t) => {
    const n = ze(Ft, e.__scopeDialog), r = V.useRef(!1), i = V.useRef(!1);
    return /* @__PURE__ */ N(
      hf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var u, c;
          (u = e.onInteractOutside) == null || u.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), hf = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = e, a = ze(Ft, n), u = V.useRef(null), c = Bt(t, u);
    return qS(), /* @__PURE__ */ ne(Le, { children: [
      /* @__PURE__ */ N(
        zl,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ N(
            Hl,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": us(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ne(Le, { children: [
        /* @__PURE__ */ N(Fb, { titleId: a.titleId }),
        /* @__PURE__ */ N(Bb, { contentRef: u, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), as = "DialogTitle", pf = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = ze(as, n);
    return /* @__PURE__ */ N(ft.h2, { id: i.titleId, ...r, ref: t });
  }
);
pf.displayName = as;
var mf = "DialogDescription", gf = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = ze(mf, n);
    return /* @__PURE__ */ N(ft.p, { id: i.descriptionId, ...r, ref: t });
  }
);
gf.displayName = mf;
var vf = "DialogClose", yf = V.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = ze(vf, n);
    return /* @__PURE__ */ N(
      ft.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: bt(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
yf.displayName = vf;
function us(e) {
  return e ? "open" : "closed";
}
var Sf = "DialogTitleWarning", [Jw, bf] = dS(Sf, {
  contentName: Ft,
  titleName: as,
  docsSlug: "dialog"
}), Fb = ({ titleId: e }) => {
  const t = bf(Sf), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return V.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, $b = "DialogDescriptionWarning", Bb = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${bf($b).contentName}}.`;
  return V.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, jb = sf, Wb = uf, Ub = lf, Hb = ff, qb = df, zb = pf, Kb = gf, Yb = yf;
function Gb(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const wf = W.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Yn = () => {
  const e = W.useContext(wf);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Gb(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Xb() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Zb() {
  return cs(/^Mac/);
}
function Qb() {
  return cs(/^iPhone/);
}
function Cu() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Jb() {
  return cs(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Zb() && navigator.maxTouchPoints > 1;
}
function Tf() {
  return Qb() || Jb();
}
function cs(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const ew = 24, tw = typeof window < "u" ? cn : Ce;
function Ru(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const Vi = typeof document < "u" && window.visualViewport;
function Ou(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function xf(e) {
  for (Ou(e) && (e = e.parentElement); e && !Ou(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const nw = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let vr = 0, Fi;
function rw(e = {}) {
  let { isDisabled: t } = e;
  tw(() => {
    if (!t)
      return vr++, vr === 1 && Tf() && (Fi = iw()), () => {
        vr--, vr === 0 && (Fi == null || Fi());
      };
  }, [
    t
  ]);
}
function iw() {
  let e, t = 0, n = (f) => {
    e = xf(f.target), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    let d = f.changedTouches[0].pageY, h = e.scrollTop, g = e.scrollHeight - e.clientHeight;
    g !== 0 && ((h <= 0 && d > t || h >= g && d < t) && f.preventDefault(), t = d);
  }, i = (f) => {
    let d = f.target;
    ho(d) && d !== document.activeElement && (f.preventDefault(), d.style.transform = "translateY(-2000px)", d.focus(), requestAnimationFrame(() => {
      d.style.transform = "";
    }));
  }, o = (f) => {
    let d = f.target;
    ho(d) && (d.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      d.style.transform = "", Vi && (Vi.height < window.innerHeight ? requestAnimationFrame(() => {
        Du(d);
      }) : Vi.addEventListener("resize", () => Du(d), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, u = window.pageYOffset, c = Ru(ow(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let l = Ru(Sn(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Sn(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Sn(document, "touchend", i, {
    passive: !1,
    capture: !0
  }), Sn(document, "focus", o, !0), Sn(window, "scroll", s));
  return () => {
    c(), l(), window.scrollTo(a, u);
  };
}
function ow(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Sn(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Du(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = xf(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, i = e.getBoundingClientRect().top, o = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + ew;
      o > s && (n.scrollTop += i - r);
    }
    e = n.parentElement;
  }
}
function ho(e) {
  return e instanceof HTMLInputElement && !nw.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function sw(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function aw(...e) {
  return (t) => e.forEach((n) => sw(n, t));
}
function Ef(...e) {
  return V.useCallback(aw(...e), e);
}
const Pf = /* @__PURE__ */ new WeakMap();
function Se(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([i, o]) => {
    if (i.startsWith("--")) {
      e.style.setProperty(i, o);
      return;
    }
    r[i] = e.style[i], e.style[i] = o;
  }), !n && Pf.set(e, r);
}
function uw(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = Pf.get(e);
  n && (e.style[t] = n[t]);
}
const ye = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function yr(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let i = r.match(/^matrix3d\((.+)\)$/);
  return i ? parseFloat(i[1].split(", ")[ye(t) ? 13 : 12]) : (i = r.match(/^matrix\((.+)\)$/), i ? parseFloat(i[1].split(", ")[ye(t) ? 5 : 4]) : null);
}
function cw(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function $i(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function lw(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const he = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, _f = 0.4, fw = 0.25, dw = 100, Cf = 8, Sr = 16, po = 26, Bi = "vaul-dragging";
function Rf(e) {
  const t = W.useRef(e);
  return W.useEffect(() => {
    t.current = e;
  }), W.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function hw({ defaultProp: e, onChange: t }) {
  const n = W.useState(e), [r] = n, i = W.useRef(r), o = Rf(t);
  return W.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
function Of({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = hw({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, s = o ? e : r, a = Rf(n), u = W.useCallback((c) => {
    if (o) {
      const f = typeof c == "function" ? c(e) : c;
      f !== e && a(f);
    } else
      i(c);
  }, [
    o,
    e,
    i,
    a
  ]);
  return [
    s,
    u
  ];
}
function pw({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: i, fadeFromIndex: o, onSnapPointChange: s, direction: a = "bottom", container: u, snapToSequentialPoint: c }) {
  const [l, f] = Of({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [d, h] = W.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  W.useEffect(() => {
    function I() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", I), () => window.removeEventListener("resize", I);
  }, []);
  const g = W.useMemo(() => l === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    l
  ]), p = W.useMemo(() => {
    var I;
    return (I = n == null ? void 0 : n.findIndex((E) => E === l)) != null ? I : null;
  }, [
    n,
    l
  ]), x = n && n.length > 0 && (o || o === 0) && !Number.isNaN(o) && n[o] === l || !n, m = W.useMemo(() => {
    const I = u ? {
      width: u.getBoundingClientRect().width,
      height: u.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var E;
    return (E = n == null ? void 0 : n.map((b) => {
      const R = typeof b == "string";
      let L = 0;
      if (R && (L = parseInt(b, 10)), ye(a)) {
        const F = R ? L : d ? b * I.height : 0;
        return d ? a === "bottom" ? I.height - F : -I.height + F : F;
      }
      const $ = R ? L : d ? b * I.width : 0;
      return d ? a === "right" ? I.width - $ : -I.width + $ : $;
    })) != null ? E : [];
  }, [
    n,
    d,
    u
  ]), D = W.useMemo(() => p !== null ? m == null ? void 0 : m[p] : null, [
    m,
    p
  ]), O = W.useCallback((I) => {
    var E;
    const b = (E = m == null ? void 0 : m.findIndex((R) => R === I)) != null ? E : null;
    s(b), Se(r.current, {
      transition: `transform ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      transform: ye(a) ? `translate3d(0, ${I}px, 0)` : `translate3d(${I}px, 0, 0)`
    }), m && b !== m.length - 1 && o !== void 0 && b !== o && b < o ? Se(i.current, {
      transition: `opacity ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      opacity: "0"
    }) : Se(i.current, {
      transition: `opacity ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(b, 0)]);
  }, [
    r.current,
    n,
    m,
    o,
    i,
    f
  ]);
  W.useEffect(() => {
    if (l || e) {
      var I;
      const E = (I = n == null ? void 0 : n.findIndex((b) => b === e || b === l)) != null ? I : -1;
      m && E !== -1 && typeof m[E] == "number" && O(m[E]);
    }
  }, [
    l,
    e,
    n,
    m,
    O
  ]);
  function w({ draggedDistance: I, closeDrawer: E, velocity: b, dismissible: R }) {
    if (o === void 0) return;
    const L = a === "bottom" || a === "right" ? (D ?? 0) - I : (D ?? 0) + I, $ = p === o - 1, F = p === 0, H = I > 0;
    if ($ && Se(i.current, {
      transition: `opacity ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`
    }), !c && b > 2 && !H) {
      R ? E() : O(m[0]);
      return;
    }
    if (!c && b > 2 && H && m && n) {
      O(m[n.length - 1]);
      return;
    }
    const X = m == null ? void 0 : m.reduce((z, M) => typeof z != "number" || typeof M != "number" ? z : Math.abs(M - L) < Math.abs(z - L) ? M : z), K = ye(a) ? window.innerHeight : window.innerWidth;
    if (b > _f && Math.abs(I) < K * 0.4) {
      const z = H ? 1 : -1;
      if (z > 0 && g && n) {
        O(m[n.length - 1]);
        return;
      }
      if (F && z < 0 && R && E(), p === null) return;
      O(m[p + z]);
      return;
    }
    O(X);
  }
  function y({ draggedDistance: I }) {
    if (D === null) return;
    const E = a === "bottom" || a === "right" ? D - I : D + I;
    (a === "bottom" || a === "right") && E < m[m.length - 1] || (a === "top" || a === "left") && E > m[m.length - 1] || Se(r.current, {
      transform: ye(a) ? `translate3d(0, ${E}px, 0)` : `translate3d(${E}px, 0, 0)`
    });
  }
  function A(I, E) {
    if (!n || typeof p != "number" || !m || o === void 0) return null;
    const b = p === o - 1;
    if (p >= o && E)
      return 0;
    if (b && !E) return 1;
    if (!x && !b) return null;
    const L = b ? p + 1 : p - 1, $ = b ? m[L] - m[L - 1] : m[L + 1] - m[L], F = I / Math.abs($);
    return b ? 1 - F : F;
  }
  return {
    isLastSnapPoint: g,
    activeSnapPoint: l,
    shouldFade: x,
    getPercentageDragged: A,
    setActiveSnapPoint: f,
    activeSnapPointIndex: p,
    onRelease: w,
    onDrag: y,
    snapPointsOffset: m
  };
}
const mw = () => () => {
};
function gw() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: i } = Yn(), o = W.useRef(null), s = Ne(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - po) / window.innerWidth;
  }
  W.useEffect(() => {
    if (t && n) {
      o.current && clearTimeout(o.current);
      const u = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!u) return;
      lw(r && !i ? $i(document.body, {
        background: "black"
      }) : mw, $i(u, {
        transformOrigin: ye(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${he.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${he.EASE.join(",")})`
      }));
      const c = $i(u, {
        borderRadius: `${Cf}px`,
        overflow: "hidden",
        ...ye(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), o.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, he.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let bn = null;
function vw({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: i, noBodyStyles: o }) {
  const [s, a] = W.useState(() => typeof window < "u" ? window.location.href : ""), u = W.useRef(0), c = W.useCallback(() => {
    if (Cu() && bn === null && e && !o) {
      bn = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: d } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-u.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = d - window.innerHeight;
        h && u.current >= d && (document.body.style.top = `${-(u.current + h)}px`);
      }), 300);
    }
  }, [
    e
  ]), l = W.useCallback(() => {
    if (Cu() && bn !== null && !o) {
      const f = -parseInt(document.body.style.top, 10), d = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, bn), window.requestAnimationFrame(() => {
        if (i && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(d, f);
      }), bn = null;
    }
  }, [
    s
  ]);
  return W.useEffect(() => {
    function f() {
      u.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), W.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || l();
      };
  }, [
    t,
    l
  ]), W.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      l();
    }, 500)) : l());
  }, [
    e,
    r,
    s,
    t,
    n,
    c,
    l
  ]), {
    restorePositionSetting: l
  };
}
function yw({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: i, snapPoints: o, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: u = fw, scrollLockTimeout: c = dw, dismissible: l = !0, handleOnly: f = !1, fadeFromIndex: d = o && o.length - 1, activeSnapPoint: h, setActiveSnapPoint: g, fixed: p, modal: x = !0, onClose: m, nested: D, noBodyStyles: O = !1, direction: w = "bottom", defaultOpen: y = !1, disablePreventScroll: A = !0, snapToSequentialPoint: I = !1, preventScrollRestoration: E = !1, repositionInputs: b = !0, onAnimationEnd: R, container: L, autoFocus: $ = !1 }) {
  var F, H;
  const [X = !1, K] = Of({
    defaultProp: y,
    prop: e,
    onChange: (Q) => {
      t == null || t(Q), !Q && !D && Zn(), setTimeout(() => {
        R == null || R(Q);
      }, he.DURATION * 1e3), Q && !x && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Q || (document.body.style.pointerEvents = "auto");
    }
  }), [z, M] = W.useState(!1), [_, S] = W.useState(!1), [P, v] = W.useState(!1), T = W.useRef(null), C = W.useRef(null), k = W.useRef(null), B = W.useRef(null), j = W.useRef(null), q = W.useRef(!1), Y = W.useRef(null), G = W.useRef(0), ee = W.useRef(!1), U = W.useRef(!y), ce = W.useRef(0), Z = W.useRef(null), ve = W.useRef(((F = Z.current) == null ? void 0 : F.getBoundingClientRect().height) || 0), rt = W.useRef(((H = Z.current) == null ? void 0 : H.getBoundingClientRect().width) || 0), Ke = W.useRef(0), je = W.useCallback((Q) => {
    o && Q === Ye.length - 1 && (C.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Yr, activeSnapPointIndex: it, setActiveSnapPoint: pn, onRelease: Gn, snapPointsOffset: Ye, onDrag: jt, shouldFade: ot, getPercentageDragged: Xn } = pw({
    snapPoints: o,
    activeSnapPointProp: h,
    setActiveSnapPointProp: g,
    drawerRef: Z,
    fadeFromIndex: d,
    overlayRef: T,
    onSnapPointChange: je,
    direction: w,
    container: L,
    snapToSequentialPoint: I
  });
  rw({
    isDisabled: !X || _ || !x || P || !z || !b || !A
  });
  const { restorePositionSetting: Zn } = vw({
    isOpen: X,
    modal: x,
    nested: D ?? !1,
    hasBeenOpened: z,
    preventScrollRestoration: E,
    noBodyStyles: O
  });
  function Wt() {
    return (window.innerWidth - po) / window.innerWidth;
  }
  function Ut(Q) {
    var ie, ae;
    !l && !o || Z.current && !Z.current.contains(Q.target) || (ve.current = ((ie = Z.current) == null ? void 0 : ie.getBoundingClientRect().height) || 0, rt.current = ((ae = Z.current) == null ? void 0 : ae.getBoundingClientRect().width) || 0, S(!0), k.current = /* @__PURE__ */ new Date(), Tf() && window.addEventListener("touchend", () => q.current = !1, {
      once: !0
    }), Q.target.setPointerCapture(Q.pointerId), G.current = ye(w) ? Q.pageY : Q.pageX);
  }
  function Qn(Q, ie) {
    var ae;
    let re = Q;
    const le = (ae = window.getSelection()) == null ? void 0 : ae.toString(), De = Z.current ? yr(Z.current, w) : null, Re = /* @__PURE__ */ new Date();
    if (re.tagName === "SELECT" || re.hasAttribute("data-vaul-no-drag") || re.closest("[data-vaul-no-drag]"))
      return !1;
    if (w === "right" || w === "left")
      return !0;
    if (C.current && Re.getTime() - C.current.getTime() < 500)
      return !1;
    if (De !== null && (w === "bottom" ? De > 0 : De < 0))
      return !0;
    if (le && le.length > 0)
      return !1;
    if (j.current && Re.getTime() - j.current.getTime() < c && De === 0 || ie)
      return j.current = Re, !1;
    for (; re; ) {
      if (re.scrollHeight > re.clientHeight) {
        if (re.scrollTop !== 0)
          return j.current = /* @__PURE__ */ new Date(), !1;
        if (re.getAttribute("role") === "dialog")
          return !0;
      }
      re = re.parentNode;
    }
    return !0;
  }
  function Gr(Q) {
    if (Z.current && _) {
      const ie = w === "bottom" || w === "right" ? 1 : -1, ae = (G.current - (ye(w) ? Q.pageY : Q.pageX)) * ie, re = ae > 0, le = o && !l && !re;
      if (le && it === 0) return;
      const De = Math.abs(ae), Re = document.querySelector("[data-vaul-drawer-wrapper]"), dt = w === "bottom" || w === "top" ? ve.current : rt.current;
      let Ue = De / dt;
      const _t = Xn(De, re);
      if (_t !== null && (Ue = _t), le && Ue >= 1 || !q.current && !Qn(Q.target, re)) return;
      if (Z.current.classList.add(Bi), q.current = !0, Se(Z.current, {
        transition: "none"
      }), Se(T.current, {
        transition: "none"
      }), o && jt({
        draggedDistance: ae
      }), re && !o) {
        const Ge = cw(ae), er = Math.min(Ge * -1, 0) * ie;
        Se(Z.current, {
          transform: ye(w) ? `translate3d(0, ${er}px, 0)` : `translate3d(${er}px, 0, 0)`
        });
        return;
      }
      const ht = 1 - Ue;
      if ((ot || d && it === d - 1) && (r == null || r(Q, Ue), Se(T.current, {
        opacity: `${ht}`,
        transition: "none"
      }, !0)), Re && T.current && s) {
        const Ge = Math.min(Wt() + Ue * (1 - Wt()), 1), er = 8 - Ue * 8, ls = Math.max(0, 14 - Ue * 14);
        Se(Re, {
          borderRadius: `${er}px`,
          transform: ye(w) ? `scale(${Ge}) translate3d(0, ${ls}px, 0)` : `scale(${Ge}) translate3d(${ls}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!o) {
        const Ge = De * ie;
        Se(Z.current, {
          transform: ye(w) ? `translate3d(0, ${Ge}px, 0)` : `translate3d(${Ge}px, 0, 0)`
        });
      }
    }
  }
  W.useEffect(() => {
    window.requestAnimationFrame(() => {
      U.current = !0;
    });
  }, []), W.useEffect(() => {
    var Q;
    function ie() {
      if (!Z.current || !b) return;
      const ae = document.activeElement;
      if (ho(ae) || ee.current) {
        var re;
        const le = ((re = window.visualViewport) == null ? void 0 : re.height) || 0, De = window.innerHeight;
        let Re = De - le;
        const dt = Z.current.getBoundingClientRect().height || 0, Ue = dt > De * 0.8;
        Ke.current || (Ke.current = dt);
        const _t = Z.current.getBoundingClientRect().top;
        if (Math.abs(ce.current - Re) > 60 && (ee.current = !ee.current), o && o.length > 0 && Ye && it) {
          const ht = Ye[it] || 0;
          Re += ht;
        }
        if (ce.current = Re, dt > le || ee.current) {
          const ht = Z.current.getBoundingClientRect().height;
          let Ge = ht;
          ht > le && (Ge = le - (Ue ? _t : po)), p ? Z.current.style.height = `${ht - Math.max(Re, 0)}px` : Z.current.style.height = `${Math.max(Ge, le - _t)}px`;
        } else Xb() || (Z.current.style.height = `${Ke.current}px`);
        o && o.length > 0 && !ee.current ? Z.current.style.bottom = "0px" : Z.current.style.bottom = `${Math.max(Re, 0)}px`;
      }
    }
    return (Q = window.visualViewport) == null || Q.addEventListener("resize", ie), () => {
      var ae;
      return (ae = window.visualViewport) == null ? void 0 : ae.removeEventListener("resize", ie);
    };
  }, [
    it,
    o,
    Ye
  ]);
  function Et(Q) {
    ge(), m == null || m(), Q || K(!1), setTimeout(() => {
      o && pn(o[0]);
    }, he.DURATION * 1e3);
  }
  function Ht() {
    if (!Z.current) return;
    const Q = document.querySelector("[data-vaul-drawer-wrapper]"), ie = yr(Z.current, w);
    Se(Z.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`
    }), Se(T.current, {
      transition: `opacity ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      opacity: "1"
    }), s && ie && ie > 0 && X && Se(Q, {
      borderRadius: `${Cf}px`,
      overflow: "hidden",
      ...ye(w) ? {
        transform: `scale(${Wt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Wt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${he.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${he.EASE.join(",")})`
    }, !0);
  }
  function ge() {
    !_ || !Z.current || (Z.current.classList.remove(Bi), q.current = !1, S(!1), B.current = /* @__PURE__ */ new Date());
  }
  function We(Q) {
    if (!_ || !Z.current) return;
    Z.current.classList.remove(Bi), q.current = !1, S(!1), B.current = /* @__PURE__ */ new Date();
    const ie = yr(Z.current, w);
    if (!Q || !Qn(Q.target, !1) || !ie || Number.isNaN(ie) || k.current === null) return;
    const ae = B.current.getTime() - k.current.getTime(), re = G.current - (ye(w) ? Q.pageY : Q.pageX), le = Math.abs(re) / ae;
    if (le > 0.05 && (v(!0), setTimeout(() => {
      v(!1);
    }, 200)), o) {
      Gn({
        draggedDistance: re * (w === "bottom" || w === "right" ? 1 : -1),
        closeDrawer: Et,
        velocity: le,
        dismissible: l
      }), i == null || i(Q, !0);
      return;
    }
    if (w === "bottom" || w === "right" ? re > 0 : re < 0) {
      Ht(), i == null || i(Q, !0);
      return;
    }
    if (le > _f) {
      Et(), i == null || i(Q, !1);
      return;
    }
    var De;
    const Re = Math.min((De = Z.current.getBoundingClientRect().height) != null ? De : 0, window.innerHeight);
    var dt;
    const Ue = Math.min((dt = Z.current.getBoundingClientRect().width) != null ? dt : 0, window.innerWidth), _t = w === "left" || w === "right";
    if (Math.abs(ie) >= (_t ? Ue : Re) * u) {
      Et(), i == null || i(Q, !1);
      return;
    }
    i == null || i(Q, !0), Ht();
  }
  W.useEffect(() => (X && (Se(document.documentElement, {
    scrollBehavior: "auto"
  }), C.current = /* @__PURE__ */ new Date()), () => {
    uw(document.documentElement, "scrollBehavior");
  }), [
    X
  ]);
  function Pt(Q) {
    const ie = Q ? (window.innerWidth - Sr) / window.innerWidth : 1, ae = Q ? -16 : 0;
    Y.current && window.clearTimeout(Y.current), Se(Z.current, {
      transition: `transform ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      transform: ye(w) ? `scale(${ie}) translate3d(0, ${ae}px, 0)` : `scale(${ie}) translate3d(${ae}px, 0, 0)`
    }), !Q && Z.current && (Y.current = setTimeout(() => {
      const re = yr(Z.current, w);
      Se(Z.current, {
        transition: "none",
        transform: ye(w) ? `translate3d(0, ${re}px, 0)` : `translate3d(${re}px, 0, 0)`
      });
    }, 500));
  }
  function Jn(Q, ie) {
    if (ie < 0) return;
    const ae = (window.innerWidth - Sr) / window.innerWidth, re = ae + ie * (1 - ae), le = -16 + ie * Sr;
    Se(Z.current, {
      transform: ye(w) ? `scale(${re}) translate3d(0, ${le}px, 0)` : `scale(${re}) translate3d(${le}px, 0, 0)`,
      transition: "none"
    });
  }
  function mn(Q, ie) {
    const ae = ye(w) ? window.innerHeight : window.innerWidth, re = ie ? (ae - Sr) / ae : 1, le = ie ? -16 : 0;
    ie && Se(Z.current, {
      transition: `transform ${he.DURATION}s cubic-bezier(${he.EASE.join(",")})`,
      transform: ye(w) ? `scale(${re}) translate3d(0, ${le}px, 0)` : `scale(${re}) translate3d(${le}px, 0, 0)`
    });
  }
  return W.useEffect(() => {
    x || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    x
  ]), /* @__PURE__ */ W.createElement(jb, {
    defaultOpen: y,
    onOpenChange: (Q) => {
      !l && !Q || (Q ? M(!0) : Et(!0), K(Q));
    },
    open: X
  }, /* @__PURE__ */ W.createElement(wf.Provider, {
    value: {
      activeSnapPoint: Yr,
      snapPoints: o,
      setActiveSnapPoint: pn,
      drawerRef: Z,
      overlayRef: T,
      onOpenChange: t,
      onPress: Ut,
      onRelease: We,
      onDrag: Gr,
      dismissible: l,
      shouldAnimate: U,
      handleOnly: f,
      isOpen: X,
      isDragging: _,
      shouldFade: ot,
      closeDrawer: Et,
      onNestedDrag: Jn,
      onNestedOpenChange: Pt,
      onNestedRelease: mn,
      keyboardIsOpen: ee,
      modal: x,
      snapPointsOffset: Ye,
      activeSnapPointIndex: it,
      direction: w,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: O,
      container: L,
      autoFocus: $
    }
  }, n));
}
const Sw = /* @__PURE__ */ W.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: i, shouldFade: o, isOpen: s, modal: a, shouldAnimate: u } = Yn(), c = Ef(t, n), l = r && r.length > 0;
  if (!a)
    return null;
  const f = W.useCallback((d) => i(d), [
    i
  ]);
  return /* @__PURE__ */ W.createElement(Hb, {
    onMouseUp: f,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && l ? "true" : "false",
    "data-vaul-snap-points-overlay": s && o ? "true" : "false",
    "data-vaul-animate": u != null && u.current ? "true" : "false",
    ...e
  });
});
Sw.displayName = "Drawer.Overlay";
const Df = /* @__PURE__ */ W.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, i) {
  const { drawerRef: o, onPress: s, onRelease: a, onDrag: u, keyboardIsOpen: c, snapPointsOffset: l, activeSnapPointIndex: f, modal: d, isOpen: h, direction: g, snapPoints: p, container: x, handleOnly: m, shouldAnimate: D, autoFocus: O } = Yn(), [w, y] = W.useState(!1), A = Ef(i, o), I = W.useRef(null), E = W.useRef(null), b = W.useRef(!1), R = p && p.length > 0;
  gw();
  const L = (F, H, X = 0) => {
    if (b.current) return !0;
    const K = Math.abs(F.y), z = Math.abs(F.x), M = z > K, _ = [
      "bottom",
      "right"
    ].includes(H) ? 1 : -1;
    if (H === "left" || H === "right") {
      if (!(F.x * _ < 0) && z >= 0 && z <= X)
        return M;
    } else if (!(F.y * _ < 0) && K >= 0 && K <= X)
      return !M;
    return b.current = !0, !0;
  };
  W.useEffect(() => {
    R && window.requestAnimationFrame(() => {
      y(!0);
    });
  }, []);
  function $(F) {
    I.current = null, b.current = !1, a(F);
  }
  return /* @__PURE__ */ W.createElement(qb, {
    "data-vaul-drawer-direction": g,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": w ? "true" : "false",
    "data-vaul-snap-points": h && R ? "true" : "false",
    "data-vaul-custom-container": x ? "true" : "false",
    "data-vaul-animate": D != null && D.current ? "true" : "false",
    ...r,
    ref: A,
    style: l && l.length > 0 ? {
      "--snap-point-height": `${l[f ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (F) => {
      m || (r.onPointerDown == null || r.onPointerDown.call(r, F), I.current = {
        x: F.pageX,
        y: F.pageY
      }, s(F));
    },
    onOpenAutoFocus: (F) => {
      n == null || n(F), O || F.preventDefault();
    },
    onPointerDownOutside: (F) => {
      if (e == null || e(F), !d || F.defaultPrevented) {
        F.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (F) => {
      if (!d) {
        F.preventDefault();
        return;
      }
    },
    onPointerMove: (F) => {
      if (E.current = F, m || (r.onPointerMove == null || r.onPointerMove.call(r, F), !I.current)) return;
      const H = F.pageY - I.current.y, X = F.pageX - I.current.x, K = F.pointerType === "touch" ? 10 : 2;
      L({
        x: X,
        y: H
      }, g, K) ? u(F) : (Math.abs(X) > K || Math.abs(H) > K) && (I.current = null);
    },
    onPointerUp: (F) => {
      r.onPointerUp == null || r.onPointerUp.call(r, F), I.current = null, b.current = !1, a(F);
    },
    onPointerOut: (F) => {
      r.onPointerOut == null || r.onPointerOut.call(r, F), $(E.current);
    },
    onContextMenu: (F) => {
      r.onContextMenu == null || r.onContextMenu.call(r, F), E.current && $(E.current);
    }
  });
});
Df.displayName = "Drawer.Content";
const bw = 250, ww = 120, Af = /* @__PURE__ */ W.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: i, isDragging: o, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: u, dismissible: c, handleOnly: l, isOpen: f, onPress: d, onDrag: h } = Yn(), g = W.useRef(null), p = W.useRef(!1);
  function x() {
    if (p.current) {
      O();
      return;
    }
    window.setTimeout(() => {
      m();
    }, ww);
  }
  function m() {
    if (o || e || p.current) {
      O();
      return;
    }
    if (O(), !s || s.length === 0) {
      c || i();
      return;
    }
    if (a === s[s.length - 1] && c) {
      i();
      return;
    }
    const y = s.findIndex((I) => I === a);
    if (y === -1) return;
    const A = s[y + 1];
    u(A);
  }
  function D() {
    g.current = window.setTimeout(() => {
      p.current = !0;
    }, bw);
  }
  function O() {
    g.current && window.clearTimeout(g.current), p.current = !1;
  }
  return /* @__PURE__ */ W.createElement("div", {
    onClick: x,
    onPointerCancel: O,
    onPointerDown: (w) => {
      l && d(w), D();
    },
    onPointerMove: (w) => {
      l && h(w);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ W.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Af.displayName = "Drawer.Handle";
function Tw(e) {
  const t = Yn(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ W.createElement(Ub, {
    container: n,
    ...r
  });
}
const St = {
  Root: yw,
  Content: Df,
  Trigger: Wb,
  Portal: Tw,
  Handle: Af,
  Close: Yb,
  Title: zb,
  Description: Kb
}, xw = "_drawer_19icx_1", Ew = "_overlay_19icx_9", Pw = "_content_19icx_17", _w = "_handle_19icx_31", Cw = "_header_19icx_36", Rw = "_title_19icx_43", Ow = "_description_19icx_53", Dw = "_closeButton_19icx_62", Aw = "_body_19icx_69", st = {
  drawer: xw,
  overlay: Ew,
  content: Pw,
  handle: _w,
  header: Cw,
  title: Rw,
  description: Ow,
  closeButton: Dw,
  body: Aw
}, Iw = {
  default: "auto",
  low: "28%",
  mid: "65%",
  high: "96%"
};
function e0(e) {
  return /* @__PURE__ */ N(St.Root, { ...e });
}
function t0({ children: e, levels: t, title: n, description: r, ...i }) {
  const o = {
    "--drawer-height": Iw[t || "default"]
  }, s = n || r;
  return /* @__PURE__ */ ne(St.Portal, { children: [
    /* @__PURE__ */ N("div", { className: st.overlay }),
    /* @__PURE__ */ ne(St.Content, { className: `${st.drawer} ${st.content}`, style: o, ...i, children: [
      s && /* @__PURE__ */ ne(vo, { children: [
        /* @__PURE__ */ N(St.Handle, { className: st.handle }),
        /* @__PURE__ */ ne("div", { className: st.header, children: [
          /* @__PURE__ */ ne("div", { style: { flex: 1 }, children: [
            /* @__PURE__ */ N(Mw, { children: n }),
            /* @__PURE__ */ N(kw, { children: r })
          ] }),
          /* @__PURE__ */ N(St.Close, { className: st.closeButton, children: /* @__PURE__ */ N(Lu, {}) })
        ] })
      ] }),
      /* @__PURE__ */ N("div", { className: st.body, children: e })
    ] })
  ] });
}
function Mw({ children: e, ...t }) {
  return /* @__PURE__ */ N(St.Title, { className: st.title, ...t, children: e });
}
function kw({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ N(St.Description, { className: st.description, ...t, children: e });
}
function n0({ children: e, ...t }) {
  return /* @__PURE__ */ N(St.Trigger, { ...t, children: e });
}
export {
  Uw as ActionMenu,
  Ld as AsyncAutosuggest,
  Kw as BottomSheet,
  Zw as Checkbox,
  e0 as Drawer,
  t0 as DrawerContent,
  kw as DrawerDescription,
  Mw as DrawerTitle,
  n0 as DrawerTrigger,
  Yw as Dropzone,
  qd as FieldNote,
  o0 as HeartButton,
  Hw as ModalOverlay,
  Xw as Paginator,
  Gw as SearchBar,
  qw as TextField
};
